/* Bar Fridges Australia — Frothy Finder.
   Generated by fit-finder/build-liquid.js. Edit the builder, not this file.
   Build 2026-10-05 */
(function(){
  var root = document.querySelector('.frothy');
  if (!root) return;

/*
 * How a fridge record is derived from its raw Shopify fields.
 *
 * ONE definition, two callers:
 *   - build-data.js, in Node, from a Matrixify export
 *   - the browser engine, from collection.frothy-data.liquid
 *
 * That is the whole point of this file existing. Both sides used to be the same
 * code only because there was one side; the moment the page started deriving its
 * own records, a second copy would have been two rulebooks that agree until they
 * don't — and the failure mode is a fridge that fits in one and not the other.
 *
 * Everything here is a pure function of a `raw` record. `raw` uses OUR field
 * names, not Matrixify's column headers and not Liquid's metafield paths, so
 * each producer does its own naming and this file never learns about either.
 *
 * No imports, no Node built-ins: the source is inlined verbatim into the browser
 * bundle by build-liquid.js.
 */

/* The chassis a model belongs to. SG1R-B-HD, SG1L-SD and SG1R-NC are all SG1 —
   one cabinet, one set of dimensions, one ventilation figure. Accessories name
   the chassis they fit, so this must agree exactly on both sides or a shelf
   lands beside the wrong fridge. */
function rootOf(text) {
  const m = String(text || '').toUpperCase().replace(/^(HUS|DW|EC)-/, '');
  const hit = /^(?:([A-Z]+)-)?([A-Z]+\d+)/.exec(m);
  if (!hit) return m;
  return hit[1] ? `${hit[1]}-${hit[2]}` : hit[2];
}

/* Finish, however it was written. The source fields say "Brushed 304 Grade
   Stainless Steel", "Silver", "Matte Black Finish" and "stainless steel" for
   what are three colours. */
function normaliseFinish(text) {
  if (!text) return null;
  if (/stainless|brushed 304|silver/i.test(text)) return 'stainless';
  if (/black/i.test(text)) return 'black';
  if (/white/i.test(text)) return 'white';
  return null;
}

/* Which way the door opens, from prose. Everything after "can be changed" or
   "please mention" describes what CAN be done, not what ships, so it is cut
   before reading — otherwise a right-hinged fridge whose blurb offers a left
   conversion reads as left. */
function statedHinge(text) {
  if (!text) return null;
  const primary = String(text).split(/can be changed|please mention|- please/i)[0];
  const l = primary.search(/left hinge/i);
  const r = primary.search(/right hinge/i);
  if (l < 0 && r < 0) return null;
  if (l < 0) return 'right';
  if (r < 0) return 'left';
  return l < r ? 'left' : 'right';
}

/* Can this fridge be had the other way round? The tail statedHinge() throws away
   is exactly where the answer lives, so the two read the same prose for
   different things: statedHinge says which way it SHIPS, this says whether the
   other way is available on the same product.

   Without it, "Reversible Door (left or right)" names no side, so statedHinge
   returns null and the fridge matches neither Left nor Right — 19 fridges in the
   range sat outside the Hinge filter entirely on the strength of being MORE
   flexible than the ones inside it.

   Three phrasings mean yes, and BFA use all three: the door reverses ("Reversible
   Door (left or right)", "reversible by installer"), BFA change it before it
   ships ("Can Be Changed To Left Hinged - Please Mention In Comments"), or the
   side is a choice at checkout ("Left/Right Side Hinge (Select On The Dropdown
   Menu)").

   Naming another model cancels it, and that exception is the point rather than a
   nicety. "Comes Right Hinged - Can Be Changed To Left Hinged - See Model
   SK156L-B-MW" reads as reversible and is not: the other side is a different
   product to buy. A shopper who ticks Reversible and orders that one gets a
   fridge that opens the wrong way. */
const OTHER_MODEL = /\bsee\s+(?:the\s+)?model\b|\bmodel\s+[A-Z0-9][A-Z0-9-]{3,}|\bversion\s+[A-Z0-9][A-Z0-9-]{3,}|can be ordered as/i;
function isReversible(text) {
  if (!text) return false;
  const s = String(text);
  if (OTHER_MODEL.test(s)) return false;
  return /revers/i.test(s)
    || /can be changed/i.test(s)
    || /select (?:on the dropdown|in option set)/i.test(s);
}

/* Two doors, hinged one each way — "1 x Left & 1 x Right", which BFA write on
   every multi-door cabinet. statedHinge() cannot see it: it looks for the literal
   "left hinge" / "right hinge", and this names a count instead of a side, so 46
   fridges answered neither Left nor Right despite having one of each.

   The digit-and-x prefix is doing real work and must not be relaxed to a bare
   left-AND-right test. Forty-two products say "Right Hinge (Handle Left)" — a
   right hinge whose HANDLE is on the left. A loose test reads those as both-sided
   and pushes Left from 39 to 169, which is worse than the bug it fixes. Nothing
   that describes a handle carries a "N x".

   This used to be isMultiDoor(), answering yes or no, and the counts it matched
   on were thrown away. They are kept now because the drawing needs them: "2 x
   Left & 1 x Right" is a three-door cabinet with two doors opening one way and
   one the other, and a picture that hangs all three the same way contradicts what
   the source plainly says.

   Returning null rather than false where a side is unnamed is what keeps that
   change free: "counts exist" is exactly the condition isMultiDoor() tested, so
   every caller that asked whether a cabinet is hinged both ways gets the same
   answer from a null check, and the Hinge filter is untouched. */
const MULTI_L = /(\d+)\s*x\s*left/i;
const MULTI_R = /(\d+)\s*x\s*right/i;
function hingeCounts(text) {
  const s = String(text || '');
  const l = MULTI_L.exec(s);
  const r = MULTI_R.exec(s);
  if (!l || !r) return null;
  return { left: Number(l[1]), right: Number(r[1]) };
}

/* Sliding doors have no hinge side at all, so they suit a shopper who needs
   either one. Two products, and they used to match no Hinge option. */
function isSlidingDoor(text) { return /sliding door/i.test(String(text || '')); }

/* Door type, most reliable source first: the model code, then the tags BFA
   maintain, then the door blurb, then the title. The title is last because it
   is marketing copy — "Glass Door" appears in the name of fridges whose glass is
   heated, and heated is the distinction that matters for condensation. */
function doorType(raw, dec) {
  if (dec.heat === true) return 'heated';
  if (dec.door === 'solid') return 'solid';

  const tags = String(raw.tags || '').toLowerCase();
  if (/(variation|specialty):\s*heated glass/.test(tags)) return 'heated';
  if (/(variation|specialty):\s*solid door/.test(tags)) return 'solid';

  const info = raw.doorInfo;
  if (info) {
    if (/heated glass/i.test(info)) return 'heated';
    if (/solid/i.test(info)) return 'solid';
    if (/glazed|low e glass|tempered/i.test(info)) return 'glass';
  }

  const title = String(raw.title || '');
  if (/heated glass/i.test(title)) return 'heated';
  if (/glass door/i.test(title)) return 'glass';
  if (/solid/i.test(title)) return 'solid';
  return null;
}

/* A branded design: the same cabinet as a plain model wearing different graphics.
 * Covers the licensed liveries (Coca-Cola, VB, Carlton, Holden, Bundy) and BFA's
 * own themed wraps (Ned Kelly, the fuel pumps, ACME, Lest We Forget) alike —
 * one class, because a shopper who does not want a fridge with a picture on it
 * does not want either kind.
 *
 * Read from BFA's own fields, never from the title. The title is the tempting
 * signal and the wrong one, in both directions: "Retro Black Small Vintage Mini
 * Bar Fridge" is the plain retro cabinet rather than a design, and any keyword
 * list broad enough to catch Castrol also catches "Carlton Draught" in the name
 * of a fridge carrying neither. Six fridges in the current collection differ
 * between the two readings and the tag is right about all six.
 *
 * So the answer lives in admin, where BFA maintain it, and a mis-filed fridge is
 * fixed by correcting its tag rather than by widening a regex here.
 */
function isBrandedDesign(raw) {
  if (/licensed branding/i.test(String(raw.type || ''))) return true;
  return String(raw.tags || '').split(',')
    .some((t) => /^\s*(?:branded:|fridge type:\s*branded\b)/i.test(t));
}

/* BFA's own rule, and note it is <= 0 rather than < 0: sitting at exactly zero
   and still orderable is a pre-order, which is what the theme's card does too. */
function stockState(qty, available) {
  if (!available) return 'out';
  if (Number.isFinite(qty) && qty <= 0) return 'preorder';
  return 'in';
}

/* Rich-text fields, flattened to plain text.
 *
 * Both producers hand these over as Shopify's rich-text AST — Matrixify writes
 * the JSON into its column, and Liquid returns the same structure rather than
 * rendering it, whichever filter you reach for. So neither side fights the
 * format: the AST is parsed here, once, and every consumer downstream sees text.
 *
 * All values are concatenated, link text included. That is deliberate and
 * matches the Node build: "Solid Foamed Door" plus a condensation-PDF link still
 * reads as solid, and the door tests look for words, not structure.
 *
 * A plain string passes straight through, so a producer that DOES render it
 * properly costs nothing. */
function richText(raw) {
  if (raw === null || raw === undefined) return null;
  const s = String(raw);
  if (!s.startsWith('{')) return s.trim() || null;
  try {
    const out = [];
    (function walk(n) {
      if (n.value) out.push(n.value);
      (n.children || []).forEach(walk);
    }(JSON.parse(s)));
    return out.join(' ').trim() || null;
  } catch {
    return s.trim() || null;
  }
}

/* Every number, coerced here rather than trusted from the producer.
 *
 * Liquid hands back a number_decimal metafield as the STRING "430.0", and a
 * string reaching the fit maths does not throw — `f.w + 2*f.vs` quietly
 * concatenates, so 430 + 40 becomes "43040" and the fridge fits a cavity nobody
 * owns. Silent, plausible, and wrong in the direction that matters.
 *
 * Zero is a real value here (integrated units publish 0mm clearances), so the
 * test is "is it a finite number", not "is it truthy". */
function num(v) {
  if (v === null || v === undefined || v === '') return null;
  const n = Number(v);
  return Number.isFinite(n) ? n : null;
}

/* One record, everything except ventilation — which cannot be settled per
   product because a variant with no stated clearances borrows them from a
   sibling on the same chassis, and that needs the whole set. See applyVent. */
function deriveOne(raw, dec) {
  const model = raw.model || raw.sku || null;
  /* Flattened before anything reads them, so doorType, normaliseFinish and
     statedHinge each see prose rather than an AST. Done once here rather than in
     each of them, which is how one of them would have been missed. */
  raw = Object.assign({}, raw, {
    doorInfo: richText(raw.doorInfo),
    doorFinish: richText(raw.doorFinish),
    bodyColour: richText(raw.bodyColour),
    hingeText: richText(raw.hingeText),
    noise: richText(raw.noise),
  });
  const door = doorType(raw, dec || {});
  const solid = door === 'solid';
  /* Integration hangs a cabinet door on a sliding hinge kit, and the kits are
     one- and two-door only, so a three-door fridge cannot be integrated however
     solid its doors are. Settled after ventilation, in applyVent, because the
     fully integrated range is exempt and identifies itself by having no
     clearances at all. */
  const doors = raw.doorsTag ? Number((String(raw.doorsTag).match(/\d/) || [1])[0]) : null;

  /* Read once, because hingeLeft and hingeRight below have to agree with each
     other and with `hinge`. The SKU wins on the shipped side — a model code is
     the one place it cannot be prose. */
  const hingeSide = (dec && dec.hinge) || statedHinge(raw.hingeText);
  const reversible = isReversible(raw.hingeText);
  const counts = hingeCounts(raw.hingeText);
  const bothSides = counts !== null || reversible || isSlidingDoor(raw.hingeText);

  return {
    handle: raw.handle,
    /* The title as Shopify holds it, trailing "- Model SK156R-HD" and all.
     *
     * This used to be stripped, on the reasoning that the model is repeated in
     * the spec row below. Two things were wrong with that. The theme's own card
     * doesn't strip it — product-grid-item7.liquid outputs {{ product.title }}
     * raw — and 23 groups of fridges share a name once it's gone, one of them
     * nine deep. SK86R-HD and SK156L-B-HD are different sizes and different
     * hinges reading as the same fridge. The suffix is the only thing telling
     * them apart on the face of the card. */
    title: String(raw.title || '').trim(),
    model,
    sku: raw.sku || null,
    chassis: model ? rootOf(model) : null,
    brand: raw.brand || null,
    /* BFA's own product type, verbatim. isBrandedDesign() already reads it off
       the RAW record; isCamping() has to answer the same question in the
       browser, on a record that has been derived, so it has to ride along. */
    type: raw.type || null,
    /* Held out of the default grid, not filtered out of it — see the pool
       options in the engine. The flag rides on the record so both the baked set
       and a record derived live in the browser answer the question the same
       way. */
    branded: isBrandedDesign(raw),
    price: num(raw.price),
    was: num(raw.was),
    productId: raw.productId ?? null,
    inStock: raw.available !== false,
    stock: stockState(num(raw.qty), raw.available !== false),
    eta: raw.eta || null,
    etaDate: raw.etaDate || null,
    badges: raw.badges || [],
    img: raw.img || null,
    w: num(raw.w), d: num(raw.d), h: num(raw.h),
    vr: num(raw.vr), vs: num(raw.vs), vt: num(raw.vt),
    cap: num(raw.cap),
    cans: num(raw.cans),
    wine: num(raw.wine),
    energy: num(raw.energy),
    doors,
    colour: (dec && dec.colour)
      || normaliseFinish(raw.finishTag)
      || normaliseFinish(raw.doorFinish)
      || normaliseFinish(raw.bodyColour),
    hinge: hingeSide,
    /* Prose only, never the SKU. A model code carries the side the unit ships
       with (SK116L), which says nothing about whether it can be swapped. */
    reversible,
    /* `hinge` is the side it SHIPS; these are the sides you can HAVE, and the
       Hinge filter asks the second question. A two-door cabinet hinged one each
       way answers both; so does a reversible one, and so do sliding doors.
       isReversible()'s OTHER_MODEL guard is what keeps this honest — "can be
       changed to left, see model SK156L-B-MW" is a different product to buy, so
       it stays right-only rather than claiming a side it cannot deliver. */
    hingeLeft: hingeSide === 'left' || bothSides,
    hingeRight: hingeSide === 'right' || bothSides,
    /* How the doors on a multi-door cabinet are split, as {left, right} — the
       only field here that describes doors individually rather than the fridge
       as a whole, and it exists for the diagram alone. `hinge` and hingeLeft /
       hingeRight all answer about the product; this says that an SG3H is two
       doors opening left and one opening right, which is what a picture of it
       has to get right.
       Null on every single-door fridge and on the 191 that name no count, so
       the drawing falls back to a convention rather than to a wrong split. */
    hingeCounts: counts,
    door,
    heat: door === 'heated',
    dualZone: raw.dualZone === true,
    /* Membership of the specialty-slide-out-wine-shelves collection, straight off
       the feed, exactly as dualZone above it comes off dual-zone. BFA curate the
       list in admin; nothing here decides what belongs in it. */
    slideOutShelves: raw.slideOutShelves === true,
    lockable: raw.lockable === true,
    suitability: raw.suitability || null,
    maxTemp: num(raw.maxTemp),
    noise: num(raw.noise),
    mount: raw.mount || null,
    _solid: solid,
  };
}

/* Cabinets that satisfy the integrable rule but cannot physically take a
 * cabinet door in front.
 *
 * The rule reads "solid door, one or two of them", which is right for the range
 * but has no way to see the shape of the cabinet. RF-42 is round: there is no
 * flat face to mount a cupboard door against, so a solid door and a door count
 * of one describe a fridge that still cannot be integrated. It only surfaced
 * when the missing door tag was filled in — the absent tag had been holding it
 * out of the integrable set by accident, which is not a mechanism to rely on.
 *
 * An explicit set rather than a heuristic, and deliberately narrow. "Round" is
 * not a field, and reading it off the title would also catch HUS-RND70B, a
 * rounded cabinet that does integrate. Nothing in the data settles this: the
 * hinge-kit lists look like an authority, but kitFor() derives from
 * `integrable`, so they agree with it by construction rather than as evidence.
 * A model belongs here only once someone has looked at the fridge.
 */
const NOT_INTEGRABLE = new Set([
  // Round cabinet — no flat face to mount a cupboard door against.
  'RF-42',
  // Speakers built into the door.
  'HUS-BC70B-BTS',
]);

/* One definition, both callers — build-data.js in Node, and applyVent below,
   which the browser runs inlined. Two copies of this test would be two rulebooks
   that agree until they don't, and the failure mode is a fridge that integrates
   in one and not the other. */
function isIntegrable({ model, sku, solid, integratedOnly, doors, branded }) {
  /* A branded design is bought to be looked at. Hiding a Coca-Cola livery or a
     Ned Kelly wrap behind a cupboard front defeats the whole reason it costs
     more than the plain cabinet, so the branded range is out of the integrable
     set wholesale.
     A rule rather than a list, and that is the point: BFA add liveries steadily,
     and each new one classifies itself. It also subsumes most of what a
     model-code list would have to carry — the BTS and AMP liveries, and the four
     designs sharing the HUS-BC70B-BTS code — leaving the set below to hold only
     the handful of PLAIN cabinets that cannot physically take a door. */
  if (branded) return false;
  const id = String(model || sku || '').toUpperCase().trim();
  if (NOT_INTEGRABLE.has(id)) return false;
  return Boolean(solid) && (integratedOnly || doors === 1 || doors === 2);
}

/* A cabinet door bolted straight to the fridge front, with no sliding hinge kit
 * in between: the Schmick MSL/MSF/MC/MSLF modules and the Blastcool iXP.
 *
 * NOT the same question as `integrable`, and conflating them is what put the iXP
 * in the wrong place. Integrable asks "can this take a cupboard front at all",
 * and most of the range answers yes by way of a kit. This asks "does it take one
 * WITHOUT a kit", which is a fact about how the fridge is built.
 *
 * It cannot be read off ventilation, which is how it was being read. `integratedOnly`
 * means "publishes no clearances", which catches the MSL range because they are
 * sized flush — but the iXP is an outdoor unit that still needs 5/5/50, so it
 * publishes figures and slipped straight past. It went the other way too: a
 * portable camping fridge with no clearances entered on it looked identical to a
 * built-in module.
 *
 * So it reads BFA's own naming, which is consistent across all eight, and takes
 * the ventilation shortcut only for the unbranded, where it is reliable. Branded
 * designs are excluded on the same grounds as isIntegrable(): a livery is bought
 * to be looked at, so hiding it behind a cupboard door defeats the purchase. */
function isFullyIntegrated({ title, integratedOnly, branded }) {
  if (branded) return false;
  if (integratedOnly) return true;
  return /\bintegrated\b/i.test(String(title || ''));
}

/* Which sliding hinge kit a fridge takes, or null.
 *
 * SHK-MINI and SHK-LARGE state no model anywhere — not in the title, tags or
 * body — so the title-matching that pairs a roller shelf with its chassis finds
 * nothing for them. BFA's rule instead:
 *
 *   70 litres or under -> SHK-MINI        over 70 -> SHK-LARGE
 *   1 and 2 door only  — a 3-door cannot take them
 *   solid door only    — you cannot hang a cupboard front over glass
 *   never the fully integrated range (MSL/MSF/MC/MSLF, iXP), which is built
 *   behind a cabinet door by design and needs no kit to get there
 *
 * The last three arrive together as `integrable`, so the rule reads as capacity
 * plus integrability.
 *
 * It lives here, beside the other derivations, because every input is a
 * metafield the live feed carries. The browser runs it against whatever the feed
 * says on this page load, so a capacity corrected in admin moves the fridge from
 * one kit to the other on the next reload rather than the next rebuild. The old
 * home for this was build-data.js alone, which meant the pairing was baked and a
 * corrected capacity sat wrong until someone re-ran the build.
 *
 * Roller shelves stay baked, and there is no fixing that here: "Roller Shelf To
 * Suit SK116" names its chassis in its title and nothing in the feed states it. */
function kitFor(f) {
  if (!f || !f.integrable) return null;
  /* A flag, not a title match. This used to read /fully integrated/i off the
     title, which happened to catch the iXP and happened to miss the Schmick
     modules — they say "Integrated" without "Fully" and were caught by
     integratedOnly instead. Two accidental half-rules covering each other is not
     a rule; isFullyIntegrated() is. */
  if (f.fullyIntegrated) return null;
  if (f.doors !== 1 && f.doors !== 2) return null;
  if (!f.cap) return null;
  return f.cap <= 70 ? 'SHK-MINI' : 'SHK-LARGE';
}

/* Ventilation, settled across the whole set.
 *
 * Three sources, narrowing:
 *   stated    — the product publishes its own clearances
 *   inherited — it does not, but another product with the SAME external
 *               dimensions does, and identical dimensions mean one cabinet
 *   airflow   — no clearances exist anywhere for it AND it is solid-door: the
 *               Schmick MSL/MSF/MC range, which installs behind a cabinet front
 *               and no other way, and is sized flush
 *
 * The airflow rule is NARROW on purpose. Front-venting solid-door units never
 * reach it because they do publish clearances. Do not widen it to all integrable
 * units — behind a cabinet door they need their own provision, but not this
 * figure, and BFA judge that out of scope for a fit finder.
 *
 * Anything still without figures is dropped: a fit answer computed from a
 * guessed clearance is worse than no answer.
 */
/* Door type from the chassis, for the products that state none.
 *
 * 21 fridges carry no door type at all — all branded or novelty designs (the
 * BC46/BC70 liveries, two HSV SC70s) whose metafield was never filled in and
 * whose model code has no HD or SD in it to read. BFA confirmed the chassis
 * answer is right for every one of them, 2026-08-20.
 *
 * Only where the chassis is UNANIMOUS. A chassis that sells glass and solid
 * versions has nothing to say about which one this is, and a wrong door is worse
 * than a blank: it is the field the finder's Door Style filter reads and the
 * field review pooling keys on.
 *
 * Blank is what it fixes. A fridge with no door type answers no Door Style filter
 * at all, so ticking "Solid" hid 18 BC46 liveries that plainly fit. Ratings are
 * untouched: every one of the 21 is branded, and a branded recipient takes its
 * whole chassis regardless of spec.
 *
 * Runs over the whole set for the same reason applyVent does — one product
 * cannot see its siblings — and in both callers: the Node build and the live
 * feed, which carries the same blanks.
 */
/* ── Camping gear ───────────────────────────────────────────────────────────
 *
 * Eskys, fire pits and the portable camping fridge/freezer. They are in the
 * finder because BFA sell them beside the fridges, not because they answer the
 * cavity question — nobody builds a fire pit into a bench.
 *
 * Three things follow from that, and all three are handled here rather than
 * scattered:
 *
 *   - They need NO ventilation clearance. A fridge's vr/vs/vt is the air gap a
 *     compressor needs around a cabinet in a hole; this gear stands in the open
 *     and has no compressor to cool, so 0/0/0 is the honest figure rather than a
 *     stand-in for a missing one. `ventSource: 'portable'` records that it was
 *     answered rather than inherited or guessed — see applyVent().
 *
 *   - They inherit their cabinet from the chassis. BFA confirmed every fire pit
 *     is the same 490x490x435 shell under a different wrap, and the six licensed
 *     liveries carry no dimension metafields of their own. Without this they hit
 *     the "no external dimensions" skip and never reach the grid.
 *
 *   - They are exempt from the Branded designs holdback. Ticking Camping has to
 *     show the CUB fire pits and the Great Northern camping fridge without also
 *     making the shopper find the branded toggle, which is a different question
 *     about a different range. See the `only` option in the engine.
 *
 * Classified by product type first, because that is BFA's own word for it in
 * admin and it stays right as they add stock. The title patterns are the
 * fallback for a livery filed under "Licensed Branding" — the Great Northern
 * camping fridge is the case.
 *
 * `\bice box\b` is word-bounded for the same reason audit.js says it is: the
 * unbounded form matches inside "PolICE BOX" and would take both Police Box
 * fridges out of the range. Anything added here needs the same care. */
const CAMPING_TYPE = /^(fire ?pit|ice box chiller)$/i;
const CAMPING_TITLE = /\bfire ?pit\b|\bice box\b|\bcooler box\b|\besky\b|\bchilly bin\b|portable camping/i;
const isCamping = (r) => !!r && (CAMPING_TYPE.test(String(r.type || '').trim())
  || CAMPING_TITLE.test(String(r.title || '')));

/* WHICH kind of camping gear, once isCamping() has said that it is some kind.
 *
 * Only the engine's sort reads it, and only to order the block that sits at the
 * foot of the grid: portable fridge, then eskys, then fire pits. That is the
 * order BFA asked for and it is roughly "how much like a fridge is this" - the
 * portable fridge/freezer is one, an esky keeps things cold without being one,
 * and a fire pit is the opposite of one.
 *
 * Type and title are tested TOGETHER, as one string, rather than type-then-title
 * the way isCamping() does. isCamping() has to prefer the type because the type
 * is BFA's own word and stays right as they add stock; this only has to pick a
 * bucket, and a fire pit filed under "Licensed Branding" says "Fire Pit" in its
 * title. Either field naming the kind is enough.
 *
 * Fire pit is tested FIRST because it is the one unambiguous phrase - nothing
 * that is a fire pit is described as anything else.
 *
 * PORTABLE IS TESTED BEFORE ESKY, and that order was earned against the live
 * collection rather than guessed. "Portable Camping Multi Purpose Fridge Freezer
 * 12 - 24 & 240V - 60Litre" is filed in admin under the product type
 * `Ice Box Chiller`, so esky-first bucketed it as an esky - while the Great
 * Northern livery of THE SAME THING, filed under `Licensed Branding`, bucketed as
 * portable. Two spellings of one product, at opposite ends of the camping block.
 * A title saying "portable camping" or "fridge freezer" is a stronger claim about
 * what a thing IS than a type field grouping it with the gear it sits beside, so
 * the title wins.
 *
 * Esky last, sharing its alternatives with CAMPING_TITLE - and sharing the WORD
 * BOUNDARIES, which are not decoration: `ice box` unbounded matches inside
 * "PolICE BOX" and would file both Police Box fridges as eskys. See the note
 * above CAMPING_TYPE, and read this file's history before removing one.
 *
 * Anything camping that matches nothing falls to 'portable'. That is the residual
 * category on purpose: an unrecognised camping item is most likely a portable
 * fridge of some sort, and 'portable' is the bucket nearest the real fridges, so
 * a misfile lands next to the range rather than under the fire pits. */
const CAMP_FIREPIT = /\bfire ?pit\b/i;
const CAMP_PORTABLE = /portable camping|fridge ?freezer/i;
const CAMP_ESKY = /\bice box\b|\bcooler box\b|\besky\b|\bchilly bin\b/i;
const campKind = (r) => {
  if (!isCamping(r)) return null;
  const s = String((r && r.type) || '') + ' ' + String((r && r.title) || '');
  if (CAMP_FIREPIT.test(s)) return 'firepit';
  if (CAMP_PORTABLE.test(s)) return 'portable';
  if (CAMP_ESKY.test(s)) return 'esky';
  return 'portable';
};

function applyChassisDoor(records) {
  const seen = new Map();
  for (const f of records) {
    if (!f.chassis || !f.door) continue;
    if (!seen.has(f.chassis)) seen.set(f.chassis, new Set());
    seen.get(f.chassis).add(f.door);
  }
  const filled = [];
  for (const f of records) {
    if (f.door || !f.chassis) continue;
    const doors = seen.get(f.chassis);
    if (!doors || doors.size !== 1) continue;
    f.door = Array.from(doors)[0];
    f.heat = f.door === 'heated';
    /* So a reader can tell a stated door from an inherited one. Nothing branches
       on it today; the finder's filters and the pooling treat both alike, which
       is the point of filling it in. */
    f.doorSource = 'chassis';
    filled.push(f.sku || f.model);
  }
  return filled;
}

function applyVent(records, airflowCm2) {
  const donors = new Map();
  /* Second-choice donors, keyed on chassis. A combo is two of the same cabinet
     side by side — BD425-Combo is 1200mm where the single BD425 is 595 — so it
     matches no dimension key and would be dropped for want of figures it plainly
     shares. Clearances are a property of the cabinet, not of how many are bolted
     together, so the chassis is the right thing to fall back to.
     Dimensions still win: two chassis-mates with genuinely different cabinets
     must not swap clearances just because their model codes rhyme. */
  const byChassis = new Map();
  for (const f of records) {
    if (!(f.vr && f.vs && f.vt)) continue;
    if (f.w != null && f.d != null && f.h != null) {
      const key = [f.w, f.d, f.h].join('|');
      if (!donors.has(key)) donors.set(key, { vr: f.vr, vs: f.vs, vt: f.vt });
    }
    if (f.chassis && !byChassis.has(f.chassis)) {
      byChassis.set(f.chassis, { vr: f.vr, vs: f.vs, vt: f.vt });
    }
  }

  /* Camping cabinets, keyed on chassis. Only camping gear donates and only
     camping gear receives: a fire pit livery must take the fire pit's shell and
     nothing else's, and restricting both ends means a chassis code that happens
     to collide with a fridge's cannot lend a cabinet across the divide.
     BFA confirmed every fire pit is the same shell — 490x490x435 on SK-PIT49 —
     and the six licensed liveries publish no dimensions of their own. */
  const campingCabinet = new Map();
  for (const f of records) {
    if (!isCamping(f) || !f.chassis) continue;
    if (!(f.w && f.d && f.h)) continue;
    if (!campingCabinet.has(f.chassis)) campingCabinet.set(f.chassis, { w: f.w, d: f.d, h: f.h });
  }

  const kept = [];
  const skipped = [];
  for (const f of records) {
    if (!(f.w && f.d && f.h) && isCamping(f) && f.chassis) {
      const shell = campingCabinet.get(f.chassis);
      if (shell) {
        f.w = shell.w; f.d = shell.d; f.h = shell.h;
        /* So a reader can tell a published cabinet from an inherited one, the
           same way doorSource marks an inherited door. Nothing branches on it. */
        f.dimSource = 'chassis';
      }
    }
    if (!f.w || !f.d || !f.h) { skipped.push({ title: f.title, why: 'no external dimensions' }); continue; }

    f.ventSource = 'stated';
    /* Camping gear needs no clearance at all, and 0/0/0 is the answer rather
       than a missing figure: vr/vs/vt is the air gap a compressor needs around a
       cabinet sunk in a hole, and an esky or a fire pit stands in the open with
       no compressor to cool. Settled BEFORE the donor lookup so a camping item
       can never inherit a fridge's clearances off a matching cabinet size, which
       would quietly add 100mm to what it "needs". See isCamping(). */
    const portable = isCamping(f);
    if (portable) { f.vr = 0; f.vs = 0; f.vt = 0; f.ventSource = 'portable'; }
    /* Both fallbacks are gated on `portable` and not on the figures, because a
       resolved camping clearance is ZERO and zero is falsy — testing
       `!(f.vr && f.vs && f.vt)` reads a settled 0/0/0 as an unanswered blank and
       would hand an esky the clearances of any fridge with the same cabinet. */
    if (!portable && !(f.vr && f.vs && f.vt)) {
      const donor = donors.get([f.w, f.d, f.h].join('|'))
        || (f.chassis ? byChassis.get(f.chassis) : null);
      if (donor) { f.vr = donor.vr; f.vs = donor.vs; f.vt = donor.vt; f.ventSource = 'inherited'; }
    }
    if (!portable && !(f.vr && f.vs && f.vt) && f._solid) {
      f.vr = 0; f.vs = 0; f.vt = 0; f.ventSource = 'airflow';
    }
    if (!(f.vr !== null && f.vs !== null && f.vt !== null)) {
      skipped.push({ title: f.title, model: f.model, why: 'no ventilation figures' });
      continue;
    }
    // Installs one way only — derived from the ABSENCE of clearances rather than
    // from a name, so a new model in the range classifies itself.
    f.integratedOnly = f.ventSource === 'airflow';
    f.airflow = f.integratedOnly ? airflowCm2 : null;
    /* Camping gear is never integrable and never fully integrated. Both tests
       key on a solid door and a door count, which an esky answers by accident —
       it has a lid, no glass, and no doorsTag — and a fire pit you cannot hang a
       cupboard front on at all. Stated here rather than added to NOT_INTEGRABLE,
       which is a list of named cabinets someone has looked at; this is a whole
       category that is out by kind. */
    f.integrable = !portable && isIntegrable({
      model: f.model, sku: f.sku, solid: f._solid,
      integratedOnly: f.integratedOnly, doors: f.doors, branded: f.branded,
    });
    f.fullyIntegrated = !portable && isFullyIntegrated({
      title: f.title, integratedOnly: f.integratedOnly, branded: f.branded,
    });
    f.camping = portable;
    /* null on everything that is not camping gear, so the engine can rank on it
       without a second isCamping() test. Set here rather than in build-data.js
       because the browser derives live-feed records through this same function -
       baking it in one place only would leave the live site unsorted. */
    f.camp = campKind(f);
    delete f._solid;
    kept.push(f);
  }
  return { kept, skipped };
}

/* ── Which fridges' reviews speak for this one ──────────────────────────────
 *
 * Feefo keys reviews on variant SKU, so a fridge that has never been reviewed
 * under its own SKU shows nothing — which is most of the branded range, wraps of
 * plain cabinets carrying hundreds of reviews between them.
 *
 * These rules pick the SKUs whose reviews describe this fridge. They used to
 * live in float-reviews.js and run only in Node; they are here now because the
 * browser asks the same question at runtime, and two copies would be two
 * rulebooks that agree until they don't. float-reviews.js imports them.
 *
 * The pooling itself is Feefo's: `product_sku` takes a comma-separated list and
 * the API returns the weighted average and summed count. Choosing the list is
 * the whole of what happens here.
 */

/* Condition prefixes wrap an otherwise normal SKU:
 *
 *   SD-TW103-BC70B-ROADIE-AUS   scratch and dent, report TW103, of BC70B-ROADIE-AUS
 *   T2-A645-SC372W-VC           factory second,   report A645,  of SC372W-VC
 *
 * The token after the prefix identifies whoever wrote the damage report, so it
 * carries no product meaning and has to come off before the chassis is read —
 * left in, it becomes the chassis and the fridge pairs with nothing.
 *
 * A report code (A645, TW103, BA) is indistinguishable from a model code by
 * shape alone — EC68 looks exactly like TW103 — so both readings are returned
 * and the caller takes whichever finds a real pool. */
const CONDITION = /^(SD|T2)-\s*/i;
function condition(sku) {
  const raw = String(sku || '').trim();
  const m = CONDITION.exec(raw);
  if (!m) return { label: 'New', candidates: [raw] };
  const rest = raw.slice(m[0].length).trim();
  return {
    label: m[1].toUpperCase() === 'SD' ? 'Scratch & Dent' : 'Factory Second',
    // Longest strip first: usually the next token IS the report code.
    candidates: [rest.replace(/^[A-Z]+\d*-\s*/i, ''), rest].filter(Boolean),
  };
}

/* NOT isBrandedDesign(). The two answer different questions and disagree on
 * purpose — read this before "fixing" either.
 *
 *   isBrandedDesign()  reads TAGS and product type, and drives the Fridge Type
 *                      filter. A retro or vintage cabinet is a plain fridge.
 *   isBrandedByName()  reads TITLE and MODEL, and decides whether a fridge may
 *                      DONATE its reviews. Deliberately over-broad, retro and
 *                      vintage included.
 *
 * The asymmetry is the point. Wrongly excluding a plain donor costs a little
 * coverage; wrongly admitting a branded one puts another fridge's reviews on a
 * card. So the donor test errs toward silence and the filter does not.
 *
 * Measured cost of that choice, 2026-08-19: on BC46, HUS-BC46B-RET and
 * HUS-BC46W-RET are plain by tag and branded by name, so the pool is 10 reviews
 * where all three siblings would give 32. That is the conservative reading
 * working, not a bug.
 *
 * "Official X branded" is the most reliable signal — every licensed design
 * carries it, including ones no keyword list would catch (Bundy Rum). The
 * keyword list then picks up BFA's own themed designs, which don't. */
const BRANDED = /\bofficial\b|\bbranded\b|coca.?cola|\bcoke\b|fanta|sprite|pepsi|\bvb\b|victoria bitter|holden|\bhsv\b|ford|jack daniel|bundaberg|\bbundy\b|\bxxxx\b|carlton|great northern|\bgnbc\b|draught|\bcorona\b|ned kelly|lest we forget|fuel pump|castrol|esso|golden fleece|gilmore|hancock|dino|telephone box|playing card|joker|footy|football|soccer|rugby|basketball|tennis|golf|retro|vintage|dice|toxic|slime|acme|crate|roadie|travel case|safe design|bank safe|east point|cyberpunk|arcade|amp\b/i;

const isBrandedByName = (r) => BRANDED.test(`${String(r.title || '')} ${String(r.model || '')}`);

/* What has to match before a PLAIN fridge may take a chassis-mate's reviews.
 *
 * Branded and condition-prefixed stock needs no such check — the difference is
 * graphics or a blemish, never the machine. A plain sibling is different: within
 * one chassis BFA sell heated-glass, plain-glass and solid-door versions, and
 * which door you got is a large part of what a review is about. Capacity carries
 * the two-unit Combo packages, which share a chassis with a single fridge but
 * are plainly not the same purchase.
 *
 * Finish and hinge are deliberately absent. A black SK68 and a stainless one are
 * the same fridge, and refusing to pair them is what left a third of the plain
 * range unrated next to a well-reviewed twin.
 *
 * Compared as strict equality including absence, so two siblings that both omit
 * a field still pair, while one that states a value never pairs with one that
 * doesn't — an unverified claim is worse here than silence.
 *
 * Reads the five fields off the record directly, so it works on a finder record
 * (flat) and on build-data's `spec` object (the same five keys) alike. */
const FUNCTIONAL = ['door', 'heat', 'doors', 'cap', 'dualZone'];
const specKey = (r) => (r ? FUNCTIONAL.map((k) => String(r[k] ?? '')).join('/') : null);

/* A Combo is the same cabinet, sold two at a time.
 *
 * BFA's call, 2026-08-20: a review of a single SK156 describes an SK156 Combo,
 * because the fridge a customer is writing about is the same fridge — there are
 * simply two of them in the package. So a Combo drops `doors` and `cap` from the
 * comparison: those two fields encode HOW MANY cabinets, and the review is about
 * the cabinet. Door type, heating and dual zone still have to match, because
 * that is what a review is actually about.
 *
 * It is ONE-WAY. A Combo takes a single's reviews; a single never takes a
 * Combo's. Reviews of a two-unit package can carry an opinion about the pair —
 * how they sit side by side, what the whole thing cost — and that does not
 * describe a fridge sold on its own. It also keeps the singles' pools, and
 * therefore their requests, exactly as they were.
 *
 * The test is the finder's own Combo filter, moved here so the filter and the
 * pooling rule cannot disagree about what a Combo is. */
const isCombo = (r) => /combo/i.test(String((r && (r.sku || '')) || '') + ' '
  + String((r && (r.model || '')) || ''));

/* The key one fridge is matched against another by. `combo` is the RECIPIENT's
   answer to isCombo(), and both sides of a comparison must use the same list —
   that asymmetry is the one-way rule above. */
const matchKey = (r, combo) => (r
  ? (combo ? ['door', 'heat', 'dualZone'] : FUNCTIONAL).map((k) => String(r[k] ?? '')).join('/')
  : null);

/* Chassis whose review pool splits by finish, and the ONLY exception to the
 * "finish and hinge may differ" rule in FUNCTIONAL above.
 *
 * SC70 is sold as two different cabinets under one model number. The stainless
 * units are TRIPLE glazed at $747; the black ones are DOUBLE glazed at $577-597.
 * The titles say so outright ("Tropical Triple Glazed" against "Tropical Double
 * Glazed") and the ~$180 gap is the glazing. Glazing is much of what a review of
 * an outdoor fridge is about -- condensation, how it holds temperature in the
 * sun -- so the SS reviews do not describe a B, and until 2026-08-28 all 43 SC70
 * fridges shared one pool of 202.
 *
 * Deliberately a NAMED LIST, not a new FUNCTIONAL field. Adding finish to
 * FUNCTIONAL would re-split every chassis in the range and undo the 2026-08-06
 * change that rescued 31 unrated cards sitting next to a well-reviewed twin --
 * a black SK68 and a stainless one really are the same fridge. SC70 is the one
 * model where the finish token also marks a different cabinet, so it is the one
 * entry here. Add another only with the same kind of evidence: a spec
 * difference stated in the titles and carried by the price.
 */
const POOL_SPLIT = new Set(['SC70']);

/* The finish token as it appears in the SKU, read as a SEGMENT immediately after
   the model number rather than anywhere in the string -- HUS-SC70-B, SC70-B-CCR
   and SC70-SS-GTSR-W1 all answer, while a design code that merely contains the
   letters cannot. Returns null when the SKU carries no token, which the six
   SC70-FP-* fuel-pump designs do not; those fall back to the derived finish. */
function finishToken(text) {
  const seg = String(text || '').toUpperCase().replace(/^(HUS|DW|EC)-/, '').split('-');
  const i = seg.findIndex((x) => /^SC70L?$/.test(x));
  const next = i < 0 ? null : seg[i + 1];
  return next === 'B' || next === 'SS' ? next : null;
}

/* The pool key for a fridge already resolved to `root`. A no-op for every
   chassis but the ones in POOL_SPLIT.

   SKU token first, derived finish only as the fallback: BFA's call 2026-08-28,
   and the two disagree on exactly one fridge. SC70-SS-HRT is tokened SS but is
   black at $597 with a title identical to SC70-B-HRT's, so by token it pools
   with the triple-glazed units. Left that way deliberately -- the SKU is the
   thing BFA control and can correct, and a rule that second-guesses it would
   hide the mis-SKU rather than surface it. Fix the SKU and this follows.

   Reads the finish off a finder record (`colour`) or off build-data's spec
   object (`spec.finish`), so the browser, the finder build and the coverage CSV
   all answer identically. */
function poolRoot(root, f) {
  if (!POOL_SPLIT.has(root)) return root;
  const finish = (f && f.colour) || (f && f.spec && f.spec.finish) || null;
  const t = finishToken((f && (f.sku || f.model)) || '')
    || (finish === 'black' ? 'B' : finish === 'stainless' ? 'SS' : null);
  return t ? root + '-' + t : root;
}

/* The chassis whose reviews this fridge draws on. New stock reads straight off
   the model; condition-prefixed stock offers two readings and takes the first
   that names a chassis something is actually filed under.

   `known` holds UNSPLIT roots, so the split is applied last -- a T2- or SD-
   prefixed SC70 still resolves its chassis the same way, then lands on the side
   its finish token puts it. */
function reviewChassis(f, known) {
  const c = condition(f.sku || f.model);
  if (c.label === 'New') return poolRoot(f.chassis || rootOf(f.model || f.sku), f);
  const roots = c.candidates.map(rootOf);
  return poolRoot((known && roots.find((r) => known.has(r))) || roots[roots.length - 1], f);
}

/* The SKU list to ask Feefo about, for one fridge.
 *
 * Includes the fridge's own SKU whenever it has one: the figure on a card is the
 * MODEL's score, not this design's, so a fridge with its own reviews counts them
 * alongside its siblings' rather than instead of them. Every SC70 then shows one
 * number, which is the claim being made.
 *
 * Returns [] when nothing may speak for it — 4 fridges in the range, all
 * genuinely one-off chassis. An empty list must never be sent: Feefo answers a
 * blank product_sku with the merchant-wide score, which would put the shop's
 * overall rating on a fridge nobody has reviewed.
 */
function reviewPool(f, all) {
  const known = new Set();
  all.forEach((x) => { if (x.chassis) known.add(x.chassis); });
  const root = reviewChassis(f, known);
  if (!root) return [];

  const plain = !isBrandedByName(f) && condition(f.sku || f.model).label === 'New';
  const combo = isCombo(f);
  const key = matchKey(f, combo);

  const skus = all.filter((d) => {
    if (!d.sku || reviewChassis(d, known) !== root) return false;
    // A donor must be plain and undamaged. Branded designs never donate to each
    // other: two wraps of one cabinet share no reviews of their own.
    if (isBrandedByName(d) || condition(d.sku || d.model).label !== 'New') return false;
    /* One-way, same as the recipient-side rule above: a Combo package's
       reviews are about TWO units bought together and are not a review of
       the single fridge it's built from, so a non-Combo recipient — branded
       or plain — never draws on one. Missing until 2026-08-25: this only
       ever guarded the plain branch below (via matchKey, where a Combo's
       differing doors/cap naturally fail the comparison); a branded or
       condition-prefixed recipient skips that comparison entirely and was
       picking up Combo donors along with everything else on the chassis —
       measured live, SC70-SS-CCR pooled in HUS-SC70-SS-COMBO's reviews
       while the plain HUS-SC70-SS correctly did not, so the two disagreed
       on one chassis's own score. */
    if (!combo && isCombo(d)) return false;
    // Branded and condition-prefixed recipients take the whole chassis. A plain
    // one takes only siblings that are the same machine.
    return plain ? matchKey(d, combo) === key : true;
  }).map((d) => d.sku);

  /* The fridge is in the list only if it qualifies as a donor in its own right,
     which every plain one does. Pushing it in regardless would make the list
     unique to it, and the list IS the request: 201 branded fridges would each
     ask a question their chassis-mates had already asked. Keyed on the pool
     instead, one request answers every fridge on that chassis.
     The consequence is deliberate. A branded fridge shows the MODEL score
     rather than its own handful of reviews, which is the claim the card makes.

     Unless nothing else speaks for it: 4 fridges in the range are genuine
     one-off chassis, and asking about their own SKU is better than asking
     nothing. Never an EMPTY list either way — Feefo answers a blank
     product_sku with the merchant-wide score, which would put the shop rating
     on an unreviewed fridge. */
  if (!skus.length && f.sku) skus.push(f.sku);
  // Stable and de-duplicated, so the list is a usable cache key.
  return skus.filter((v, i, a) => a.indexOf(v) === i).sort();
}


/*
 * Decodes BFA / Schmick model codes into product attributes.
 *
 * The attribute metafields (Door Hinged, Body Colour, Door / Grill Finish) are
 * Rich text, so they carry HTML rather than clean values. Model Code is a plain
 * single-line field on 1,328 products, so we derive from that instead.
 *
 * Convention (confirmed by BFA):
 *   HD = heated door, always glass      SD = solid door
 *   B  = black                          SS = stainless steel
 *   -HD without B = stainless           L / R = left / right hinge
 *
 * Range exception: W is white in the SK range (SK422L-W-HD) but a zone code in
 * the BD425 wine range (BD425W = single zone, BD425D = dual zone, -B still
 * black). Handled by only reading colour from the suffix tokens, never the head.
 *
 * Anything not confidently decodable is reported in `unresolved` rather than
 * guessed — a wrong hinge or finish on a fit result is worse than a blank one.
 */

const VENDOR_PREFIX = /^(HUS|DW|EC)-/;
const HEAD = /^([A-Z]+)(\d+)([A-Z]*)$/;

/* Suffix tokens we recognise but that carry no attribute we currently surface.
   M / MW are shelving (beer / wine) and say nothing about the fridge itself;
   840 and 865 are heights, and which one a range uses is a property of the range
   (GSP is 840); RET retro, BTS bluetooth speaker, RND round, FP fuel-pump
   design, INT integrated, COMBO a two-unit package, BW a beer-and-wine pair. */
const KNOWN_NOISE = new Set(['X', 'ZZ', 'WZ', 'M', 'MW', 'NC', 'FP', 'V1', 'V2', 'V3',
  'RET', 'BTS', 'RND', 'INT', 'COMBO', 'BW', '840', '865']);

/* Tokens that state a body colour in a form of their own, all confirmed by BFA
   2026-08-20:
     SSH  unique to the EC68 — stainless frame and grill on a BLACK body, so the
          body colour is black and the SS in it is trim, not finish
     AB   all black
     BS   unique to the Rhino SGT range; BFA think black stainless and are not
          certain, but certain it is black */
const COLOUR_TOKEN = { SSH: 'black', AB: 'black', BS: 'black' };

// Series where the letter glued to the model number is a product-type code
// rather than a finish — see the BD425 note in the head-parsing block below.
const HEAD_SUFFIX_IS_TYPE_CODE = new Set(['BD']);

function decodeSku(sku) {
  const out = {
    sku,
    root: null,
    series: null,
    hinge: null,
    colour: null,
    colourSource: null,
    door: null,
    heat: null,
    dualZone: null,
    unresolved: [],
  };

  if (!sku || typeof sku !== 'string') {
    out.unresolved.push('missing-sku');
    return out;
  }

  const clean = sku.toUpperCase().trim().replace(VENDOR_PREFIX, '');
  const [head, ...rest] = clean.split('-');

  const m = HEAD.exec(head);
  if (!m) {
    out.unresolved.push(`unparsable-head:${head}`);
    return out;
  }

  const [, letters, number, headSuffix] = m;
  out.root = letters + number;
  out.series = letters;

  /* Hinge rides on the head token, and it can be at either end: SK116L and SG1R
     put it last, SC372LB and HUS-SC372LW put it first with the colour after it
     (left + black, left + white — both confirmed against the Finish Colour tag). */
  let leftover = headSuffix;
  if (/[LR]$/.test(leftover)) {
    out.hinge = leftover.endsWith('L') ? 'left' : 'right';
    leftover = leftover.slice(0, -1);
  } else if (leftover.length > 1 && /^[LR]/.test(leftover)) {
    out.hinge = leftover.startsWith('L') ? 'left' : 'right';
    leftover = leftover.slice(1);
  }
  // Colour codes are sometimes glued to the model number (BC46B = black) rather
  // than split out as their own token (SG1L-B). Safe everywhere EXCEPT the BD
  // series, where the glued letter is a product-type code, not a finish:
  // BD425B = drinks, BD425W = wine, BD425D = dual zone. A separate -B token
  // still means black there (BD425D-B is a black dual-zone unit).
  const tokens = new Set(rest);
  if (!HEAD_SUFFIX_IS_TYPE_CODE.has(letters)) {
    /* B and W both glue to the number outside the BD series: BC46B is black,
       BC46W and HUS-SC50W are white. The 30 glued Ws matter — 12 of them are
       branded minis with no Finish Colour tag at all, so this is the only place
       their colour is written down. */
    if (leftover === 'B' || leftover === 'W' || leftover === 'SS') {
      tokens.add(leftover);
      leftover = '';
    } else if (COLOUR_TOKEN[leftover]) {
      // AB — all black — glues to the number: HUS-SC50AB, SC50AB-DRY.
      tokens.add(leftover);
      leftover = '';
    } else if (leftover === 'D') {
      // JC132D, SK198D — a D on the number is dual zone.
      out.dualZone = true;
      leftover = '';
    }
  } else if (leftover === 'D') {
    // Same letter, same meaning, in the range where W does NOT mean white:
    // BD425B is drinks, BD425W single-zone wine, BD425D dual zone.
    out.dualZone = true;
    leftover = '';
  }
  if (leftover) out.unresolved.push(`head-code:${leftover}`);

  // Door type and heating.
  if (tokens.has('HD')) {
    out.door = 'glass';
    out.heat = true;
  } else if (tokens.has('SD')) {
    out.door = 'solid';
    out.heat = false;
  }

  // Finish. Order matters: an explicit code always beats the HD fallback.
  // colourSource records which applied — the fallback is a convention rather
  // than a stated code, and special variants (SK156-HD-MW is black) break it,
  // so callers doing data validation should only trust 'explicit'.
  if (tokens.has('B')) {
    out.colour = 'black';
    out.colourSource = 'explicit';
  } else if (tokens.has('SS')) {
    out.colour = 'stainless';
    out.colourSource = 'explicit';
  } else if (tokens.has('W')) {
    out.colour = 'white';
    out.colourSource = 'explicit';
  } else if ([...tokens].some((t) => COLOUR_TOKEN[t])) {
    out.colour = COLOUR_TOKEN[[...tokens].find((t) => COLOUR_TOKEN[t])];
    out.colourSource = 'explicit';
  } else if (tokens.has('HD')) {
    /* -HD without B is stainless. A CONVENTION, not a stated code, and it is
       wrong on five fridges whose tag says black (SK198D-HD, SK228D-HD,
       SK248D-HD, SK156L-HD-MW, SK156R-HD-MW). Callers must let a stated colour
       win over this one — see the colour precedence in build-data.js. */
    out.colour = 'stainless';
    out.colourSource = 'inferred';
  }

  for (const t of rest) {
    if (['HD', 'SD', 'B', 'SS', 'W'].includes(t)) continue;
    if (COLOUR_TOKEN[t]) continue;
    if (KNOWN_NOISE.has(t)) continue;
    out.unresolved.push(`token:${t}`);
  }

  if (!out.colour) out.unresolved.push('no-colour');
  if (!out.door) out.unresolved.push('no-door');

  return out;
}



  var FRIDGES = null;
  var THEME = true;
  var FIT = {"threshold":25,"roomy":"Heaps of room","tight":"Good Fit","flush":"Flush fit","proud":"Sits proud"};
  var OVERHANG = {"max":20};
  /* Millimetres of depth overhang the shopper has accepted. 0 until they tick
     the offer in the alert; read by fit() whenever a caller does not name its
     own, so one assignment re-scopes every count, card and message at once. */
  var ALLOW = 0;
  /* Built-in or freestanding, set by the switch above the measurement fields.
     THE TWO MODES ASK FOR DIFFERENT FIGURES, and fit() reads this - changed
     2026-09-14, and it is the one branch on MODE the arithmetic is allowed.
     It used to say the opposite, on the reasoning that a fridge standing in a
     room wants the same published clearances a built-in one does. It does. What
     differs is WHOSE PROBLEM THAT IS. A cavity is cut once, so the air gap has
     to be cut with it or it never exists; a room is not cut at all, and the
     100mm behind a freestanding fridge is space the shopper leaves rather than
     space they lose. Folding the clearance into the freestanding requirement was
     charging them for a wall they had not built: a 600mm-wide cabinet was quoted
     at 680mm and ruled out of a 650mm alcove it stands in perfectly well.
     So the clearance is MOVED, not dropped - out of fit() and onto the card as
     its own Ventilation row, in the switch's own blue, said again in the hint
     under the fields and again in the note under the drawing. Those three are
     load-bearing, not decoration. Take them away and this branch quietly sells
     someone a fridge with its back against a wall and no way to shed heat.
     Everything else the switch does is unchanged: the wording, the drawing and
     the video slot.
     One noun table rather than two drafts of every sentence. The copy in this
     file says "cavity" or "opening" in about a dozen places, and keeping two
     versions of each is exactly how the two modes would end up describing
     different tools:
       subject  what the shopper measured        "pop your cavity in"
       opening  the hole it makes, abstractly    "nothing fits this opening"
       an       the same with its article, since "an opening" and "a space" differ
       row      the cards' spec row label, CAVITY ONLY
     "row" is the one entry with no freestanding half, and the gap is deliberate
     rather than an omission to fill in later. That row states what the shopper
     has to find room for, and in freestanding that is the cabinet - which the
     Size row directly above it already gives, to the millimetre. So the card
     spends the line on the one thing those figures leave out instead, and
     card() branches to a 'Ventilation:' row of its own shape rather than taking
     a label from here. A 'Space:' string in this table would only ever be read
     by whoever put the duplicate row back. */
  var MODE = 'cavity';
  var WORDS = {
    cavity: { subject:'cavity', opening:'opening', an:'an opening', row:'Cavity:',
      label:'Your cavity (mm) \u2014 optional',
      hint:'Measure at the narrowest point. Watch for skirting boards, power points '
        + 'and plumbing \u2014 they all steal depth.' },
    space: { subject:'space', opening:'space', an:'a space',
      /* "Fridge Space", not "Your space". The field is asking for the footprint the
         fridge itself has to occupy now, and naming the fridge in the label is
         what stops it being read as the room. */
      label:'Fridge Space (mm) \u2014 optional',
      /* HTML, not text, and the only entry in this table that is - see applyMode().
         The WHOLE hint is the warning here, where cavity's is all practical
         advice, and the asymmetry is the point rather than an unfinished edit:
         the measuring guidance that used to open this string moved up into
         SUBHEAD, which now explains both modes before the shopper picks one, so
         repeating it here would be the third telling on one screen. What is left
         is the one thing nothing else on the page says, in the mode switch's own
         blue - see .ff-vent-hi.
         "every card lists its own" rather than a figure here, because there is no
         one figure - the range runs 10mm to 40mm at the sides and 50mm to 150mm
         at the back, so any number in this hint would be wrong for most of the
         grid beneath it. The Ventilation row on each card carries that fridge's
         own, which is the only place the real answer can live. */
      hint:'<span class="ff-vent-hi">These figures are the fridge itself \u2014 the '
        + 'ventilation gap is needed on top, sides and rear, every card lists its '
        + 'own.</span>' },
  };
  function W(){ return WORDS[MODE]; }
  var CLS = {"card":"t4s-product t4s-pr-grid t4s-pr-style6 t4s-pr-style7 t4s-col-item ff-card","wrapper":"t4s-product-wrapper t4s-pr t4s-oh ff-wrap","img":"t4s-product-inner t4s-pr t4s-oh ff-img","imglink":"t4s-full-width-link ff-imglink","info":"t4s-product-info ff-info","inner":"t4s-product-info__inner ff-top","detail":"t4s-product-info-detail ff-detail","priceWrap":"t4s-product-info-detail-price-cart ff-pricewrap","title":"t4s-product-title ff-title","badge":"t4s-product-badge ff-badges","price":"t4s-product-price ff-priceline","spec":"pr-info ff-spec"};
  var LABELS = {"type":"Fridge Type","doors":"Doors","hinge":"Hinge","door":"Door Style","finish":"Finish","features":"Features","noise":"Noise","suit":"Use","brand":"Brand","view":"View Shelving / Hinge Kits"};
  var GROUPS = [{id:"type",options:[{id:"integrable",test:(f) => f.integrable},{id:"undercounter",test:(f) => f.mount === 'undercounter_units'
          || f.mount === 'non_front_venting'},{id:"upright",test:(f) => f.mount === 'upright_free_standing'
          || f.mount === 'jc430'},{id:"mini",test:(f) => /^mini_/.test(f.mount || '')},{id:"camping",test:(f) => !!f.camping},{id:"integrated",test:(f) => f.fullyIntegrated},{id:"branded",label:"Branded designs",only:(f) => f.branded && !f.camping}]},{id:"doors",options:[{id:"d1",test:(f) => f.doors === 1},{id:"d2",test:(f) => f.doors === 2},{id:"d3",test:(f) => f.doors === 3}]},{id:"hinge",options:[{id:"hl",test:(f) => f.hingeLeft},{id:"hr",test:(f) => f.hingeRight},{id:"hrev",test:(f) => f.reversible}]},{id:"door",options:[{id:"glass",test:(f) => f.door === 'glass' || f.door === 'heated'},{id:"solid",test:(f) => f.door === 'solid'}]},{id:"finish",options:[{id:"black",test:(f) => f.colour === 'black'},{id:"stainless",test:(f) => f.colour === 'stainless'},{id:"white",test:(f) => f.colour === 'white'}]},{id:"features",options:[{id:"dual",test:(f) => f.dualZone},{id:"lock",test:(f) => f.lockable},{id:"combo",test:(f) => isCombo(f)},{id:"shelving",test:(f) => f.slideOutShelves}]},{id:"noise",options:[{id:"silent",test:(f) => f.noise != null && f.noise <= 29},{id:"whisper",test:(f) => f.noise > 29 && f.noise <= 39},{id:"standard",test:(f) => f.noise > 39 && f.noise <= 45},{id:"commercial",test:(f) => f.noise > 45}]},{id:"suit",options:[{id:"indoor",test:(f) => /indoor|alfresco|outdoor/i.test(f.suitability || '')},{id:"alfresco",test:(f) => /alfresco|outdoor/i.test(f.suitability || '')},{id:"outdoor",test:(f) => /outdoor/i.test(f.suitability || '')}]},{id:"brand",options:[{id:"schmick",test:(f) => f.brand === 'Schmick'},{id:"rhino",test:(f) => f.brand === 'Rhino'},{id:"other",test:(f) => f.brand && !['Schmick', 'Rhino'].includes(f.brand)}]},{id:"view",options:[{id:"shelves",display:true},{id:"kits",display:true}]}];
  var AIRFLOW_NOTE = 'Installs flush into the cabinetry. Needs 200cm\u00b2 of free airflow through a grill or duct.';
  /* Why it stands proud, and why that is usually fine — one string, because the
     offer and the standing notice are the same explanation at two moments and a
     shopper who reads both should not find two accounts of it.
     The second sentence is the one that does the work. A shopper measuring a
     cavity measures to the carcass, which is what the depth field asks for, and
     the doors either side of that cavity are already standing off it by about
     the same distance we are asking them to accept. Said plainly, the overhang
     stops being a defect and becomes what the rest of the kitchen already does. */
  /* CAVITY MODE ONLY, and it no longer reads MODE because it is never reached in
     the other one - see overhangGain(). It used to carry a freestanding second
     sentence, "nothing is built in around it, so that is simply the fridge
     standing further into the room", and that sentence was the tell: in a room
     there is nothing to stand proud OF. A freestanding shopper types the space
     they are willing to give the fridge, not the mouth of a hole it has to sit
     inside, so a cabinet 15mm deeper than that figure is not 15mm proud of
     anything - it is 15mm bigger than what they told us they had, and offering
     to let it through is offering to ignore their answer.
     Still W().opening rather than 'cavity' spelt out: one noun table, so if the
     allowance is ever offered in some third mode the wording follows it. */
  function proudNote(){
    return 'The gap behind the cabinet is ventilation \u2014 close it up and the compressor cooks \u2014 '
      + 'so the fridge slides forward instead and its door stands out of the ' + W().opening + '. '
      + 'Cabinet doors and a benchtop nose usually stand 18\u201320mm off the carcass anyway, '
      + 'so most of these finish close to level with the cupboards either side.';
  }

  /* Injected by the Liquid template so links honour the market's URL prefix and
     prices use the shop's own money format. Sensible defaults for the preview. */
  var PBASE = (root.getAttribute('data-products') || '/products/').replace(/\/*$/, '/');
  var MONEY = root.getAttribute('data-money') || '${{amount}}';
  /* The compare page is this engine with data-cpage on the root; see
     bootComparePage(). */
  var CPAGE = root.hasAttribute('data-cpage');

  /* The build that produced this file, stamped in at build time by
     build-liquid.js. It rides out on the fit record below and onto the order,
     so a warranty conversation years from now can say which version of the
     finder did the measuring. It is also the one marker that changes on every
     build, which is what section 5 of the handover wants for verifying a paste
     — see the note there before picking any other string. */
  var BUILD = "2026-10-05";

  /* The diagram is drawn to a fixed millimetre scale so a small opening looks
     small and a large one fills the frame — rescaling per cavity would make
     every cavity look identical. The scale is pinned to the largest opening any
     fridge in the range needs, so a full frame means "big enough for anything we
     sell". Beyond that the drawing stops growing but the typed figures don't:
     enter 50000 and the box stays put while the label reads 50000. */
  var CAP = null;
  function capDims(){
    if (CAP) return CAP;
    CAP = { w:0, h:0, d:0 };
    FRIDGES.forEach(function(f){
      CAP.w = Math.max(CAP.w, f.w + 2*f.vs);
      CAP.h = Math.max(CAP.h, f.h + f.vt);
      CAP.d = Math.max(CAP.d, f.d + f.vr);
    });
    return CAP;
  }

  var $ = function(s,r){ return (r||root).querySelector(s); };
  var $$ = function(s,r){ return Array.prototype.slice.call((r||root).querySelectorAll(s)); };
  var grid = $('[data-grid]'), svg = $('.ff-viz svg'), active = {};

  /* Shelves and parts ride in the same data file but are not fridges: no
     cabinet, so no fit, so they must never reach the fit maths or the "N of M"
     count. They are pulled out once, here, rather than guarded against at every
     later step. */
  var ALL_ACCESSORIES = [];

  /* The openings this range can actually answer over: the narrowest and widest
     any fridge needs. Derived, never typed — it is what decides which unit a
     bare number is in, so a hand-picked constant here would silently rot the
     moment BFA stock a taller cabinet. Cleared with CAP when the live feed
     replaces the range. */
  var OPEN = null;
  function openRange(){
    if (OPEN) return OPEN;
    var lo = null, hi = null;
    (FRIDGES || []).forEach(function(f){
      [f.w+2*f.vs, f.d+f.vr, f.h+f.vt].forEach(function(v){
        if (lo === null || v < lo) lo = v;
        if (hi === null || v > hi) hi = v;
      });
    });
    OPEN = { lo: lo || 390, hi: hi || 2150 };
    return OPEN;
  }

  /* Millimetres out of whatever the shopper typed: 600, 600mm, 60cm, 60 cm, 0.6m.
   *
   * Normalised silently rather than behind a units toggle. A toggle puts the
   * question to every shopper when only a handful have it, and the ones who do
   * not notice it get a wrong answer that looks right — a cavity read as 890cm
   * clears the entire range and the grid says so confidently. The echo under the
   * field is what makes silence safe: the interpretation is always on screen, so
   * a wrong guess is visible rather than assumed.
   *
   * A stated unit is obeyed. A bare number is read by which interpretation lands
   * inside the openings above, and AT MOST ONE EVER CAN — not by luck, but
   * because those openings span 390-2150mm, a factor of about 5.5, while the
   * unit steps are factors of 10 and 1000. A window narrower than 10x cannot
   * hold both n and n*10. That is the whole licence for guessing, and it is a
   * property of the range rather than of the thresholds, which is why the
   * thresholds are gone.
   *
   * When NOTHING lands in range the guessing stops. Between roughly 216 and 389
   * the millimetre reading fits nothing and the centimetre reading clears
   * everything — opposite answers, no evidence either way — so it is taken
   * verbatim as millimetres, the one reading that invents no factor, and flagged
   * as a question. Erring small is the recoverable direction: a shopper told
   * nothing fits measures again or rings, where one told everything fits orders
   * a fridge that does not.
   *
   * Returns null for anything unreadable, which the caller shows as such rather
   * than folding into 0 — "no measurement yet" and "that is not a measurement"
   * want different sentences. */
  function readMm(text){
    var s = String(text == null ? '' : text).trim().toLowerCase().replace(/,/g, '.');
    /* Backslashes doubled: this engine is emitted from a template literal, so a
       lone s would reach the browser as a bare "s". */
    var m = /^([0-9]*\.?[0-9]+)\s*(mm|cm|m)?$/.exec(s);
    if (!m) return null;
    var n = parseFloat(m[1]);
    if (!isFinite(n) || n <= 0) return null;

    var mul = { mm:1, cm:10, m:1000 };
    if (m[2]) return { mm: Math.round(n * mul[m[2]]), unit: m[2], guessed: false, ask: false };

    var r = openRange();
    var hit = ['mm','cm','m'].map(function(u){ return { mm: Math.round(n * mul[u]), unit: u }; })
      .filter(function(c){ return c.mm >= r.lo && c.mm <= r.hi; });
    if (hit.length === 1) return { mm: hit[0].mm, unit: hit[0].unit, guessed: true, ask: false };

    /* Bigger than anything we stock needs: every reading says the same thing
       ("it all fits"), so there is nothing to be wrong about. Taken as typed. */
    if (n > r.hi) return { mm: Math.round(n), unit: 'mm', guessed: false, ask: false };
    /* Smaller than the smallest opening on every reading: they all say nothing
       fits, so again no disagreement to resolve. */
    if (n * 1000 < r.lo) return { mm: Math.round(n), unit: 'mm', guessed: false, ask: false };

    return { mm: Math.round(n), unit: 'mm', guessed: true, ask: true, n: n };
  }

  function parseMm(text){ var r = readMm(text); return r ? r.mm : null; }

  var DIM_IDS = ['ff-cw','ff-ch','ff-cd'];

  /* Only when the text actually needed interpreting. Echoing the reading back at
     someone who typed plain millimetres is noise; withholding it from someone who
     typed 60 is the bug it exists to prevent. And where the number is genuinely
     undecidable it ASKS rather than reporting a guess as fact — the whole defence
     of normalising silently is that the interpretation is visible, which it is
     not if a coin-toss is dressed up as a reading.
     Emptied, never hidden: the line is reserved in CSS so the field below cannot
     move.
     "= 600mm" rather than "Reading as 600mm" because the column is 104px and the
     longer phrase ran into the ellipsis — a truncated reading is worse than a
     terse one, since the whole job of this line is to show the number. It needs
     no verb: it sits between a label naming the measurement and the box holding
     what was typed, so the equals sign is doing all the work required. The
     sentence survives on the title. */
  function updateEchoes(){
    DIM_IDS.forEach(function(id){
      var el = $('#'+id), out = $('[data-echo="'+id+'"]');
      if (!el || !out) return;
      var raw = String(el.value).trim(), r = readMm(raw);
      var text = '', title = '', bad = false;

      if (!raw){
        /* Nothing typed — that is "any size" now, and the alert box says so. */
      } else if (/^0*\.?0*$/.test(raw)){
        /* readMm() refuses 0, and rightly — it is not a measurement. It IS an
           instruction, though, so it must not be echoed as a typo. Named rather
           than left blank because a lone 0 in a box labelled Width otherwise
           reads as a cavity of nothing, which is the opposite of what it does. */
        text = 'any size';
        title = '0 means no limit on this measurement.';
      } else if (!r){
        text = 'Not a number'; bad = true;
        title = '"' + raw + '" is not a measurement. Try 600, 60cm or 0.6m.';
      } else if (r.ask){
        text = '= ' + r.mm + 'mm?'; bad = true;
        title = r.n + ' could be ' + r.n + 'mm or ' + (r.n * 10) + 'mm. Taking the smaller '
          + 'one — type mm, cm or m to be sure.';
      } else if (/^[0-9]+$/.test(raw) && Number(raw) === r.mm){
        /* Already plain millimetres. Confirming it back would be noise. */
      } else {
        text = '= ' + r.mm + 'mm';
        title = '"' + raw + '" read as ' + r.mm + 'mm.';
      }

      out.textContent = text;
      out.classList.toggle('is-bad', bad);
      if (title) out.setAttribute('title', title); else out.removeAttribute('title');
    });
  }

  /* A blank field, a typed 0 and an unreadable one all mean NO LIMIT on that
     axis rather than a cavity of nothing.
     Since the filters moved above these boxes the cavity is the optional half of
     the toolbar, so the finder has to open on the whole range — three empty
     fields cannot mean "nothing fits", or the first thing a shopper sees is an
     empty grid. 0 means the same as empty because it is the one a shopper can
     TYPE to get back here after measuring; clearing three boxes is the same
     instruction spelled differently, and both have to work.
     open is all three together, and it now means only "nothing to fit against".
     A PARTIAL cavity used to be treated as unanswerable and shown an alert
     telling the shopper to go and measure the rest, which was the tool refusing
     the commonest thing anyone does with it: a cavity between two cabinets has
     ONE hard number and the shopper has it before they have the others. Held to
     all three, that shopper saw an empty grid and no way to read it — a blank
     axis is 0, and 0mm of depth fails every fridge we stock, so "nothing fits"
     was arithmetic about a measurement they never gave us.
     Each axis now constrains on its own and a blank one constrains nothing. See
     fit(), which carries the nulls, and missingAxes() for what the caption says
     about it — because an answer on two axes needs saying so, not hiding. */
  function cavity(){
    var w = parseMm($('#ff-cw').value) || 0,
        h = parseMm($('#ff-ch').value) || 0,
        d = parseMm($('#ff-cd').value) || 0;
    return { w:w, h:h, d:d, open: !w && !h && !d };
  }

  /* ---- The fit record -----------------------------------------------------
     What the shopper measured, saved on the way OUT of the finder, read by
     snippets/bfau-ff-stamp.liquid on the product page and stamped onto the cart
     as hidden attributes when something is added. It is the OPENING and nothing
     else: no verdict about any fridge, no slack figure, no "fits".

     That restraint is the design. The arithmetic joining an opening to a fridge
     is fit(), and fit() reads MODE, ALLOW, the fridge's three dimensions and its
     three ventilation gaps — none of which the product page has an engine for.
     A slack number computed over there would be a second implementation of the
     one rule, which is exactly what derive.js opens by arguing against, and it
     would be the copy nobody ever reruns the checks against. The product's own
     published figures go onto the order beside these, so the sum can be redone
     later from both halves rather than trusted from a number of ours.

     MODE and ALLOW travel with the millimetres because without them the
     millimetres do not mean anything. 600 of depth in cavity mode is an opening
     that has still to find room for the rear vent gap; the same 600 in space
     mode is the cabinet alone, vent excluded — see fit(), which is the one
     branch on MODE the arithmetic is allowed. And a shopper who ticked the
     overhang offer was told the fridge would stand proud and agreed to it,
     which is the entire question if a claim ever turns on the door line.

     Saved on CLICK, never on keystroke. renderSoon() fires on a 160ms debounce,
     which is a render timer and not a statement of intent: half of what it sees
     is a number mid-typing. A measurement nobody acted on has no business
     stamping a purchase made a fortnight later from the nav menu. */
  var FIT_STORE = 'bfau.ff.fit';
  /* Long enough to cover measure-now, buy-on-payday. Short enough that a second
     kitchen two years on is not fitted against the first one's opening — a
     stale record is worse than none here, because it reads as evidence. */
  var FIT_TTL_DAYS = 30;

  function saveFit(){
    var c = cavity();
    /* Nothing measured is not a measurement of nothing. Leave whatever is
       already stored alone rather than overwriting it with blanks: a shopper who
       measured, wandered off to browse, and came back to click a card through an
       empty form still measured. */
    if (c.open) return;
    try {
      localStorage.setItem(FIT_STORE, JSON.stringify({
        w: c.w || null, d: c.d || null, h: c.h || null,
        mode: MODE, allow: ALLOW, build: BUILD, ts: Date.now(),
        /* The EXPIRY TRAVELS WITH THE RECORD rather than the lifetime being
           restated on the reading side. bfau-ff-stamp.liquid is hand-written and
           outside this build, so a second copy of "30 days" over there would be
           a number nothing keeps in step — and the two drifting apart is silent
           in both directions. Written as a moment, it is the record's own claim
           about when it stops being worth anything, and the reader only has to
           compare it to now. */
        exp: Date.now() + FIT_TTL_DAYS * 24 * 60 * 60 * 1000
      }));
    } catch (e) {
      /* Private browsing, or a full quota. The finder is unaffected and the
         order simply carries no fit record — which is the same state as a
         shopper who never opened the finder, and reads correctly as that. */
    }
  }

  /* The axes with nothing in them, in W/D/H order — the order the fields sit in
     and the order every figure in the tool is written in. Named rather than
     counted, because every caller says them out loud: the caption warns with
     them and the "it all fits" alert offers them back.
     One list function with them, too. "width and depth", "width, depth and
     height" — the Oxford comma is off on purpose, matching the shop's own copy
     voice everywhere else in this file. */
  function missingAxes(c){
    var out = [];
    if (!c.w) out.push('width');
    if (!c.d) out.push('depth');
    if (!c.h) out.push('height');
    return out;
  }
  function givenAxes(c){
    var out = [];
    if (c.w) out.push('width');
    if (c.d) out.push('depth');
    if (c.h) out.push('height');
    return out;
  }
  function andList(a){
    return a.length < 2 ? (a[0] || '')
      : a.slice(0, -1).join(', ') + ' and ' + a[a.length - 1];
  }

  /* cavSummary() lived here until 2026-09-22. It wrote the collapsed phone
   * row's figures; the row is gone (BFA — see .ff-cav in coreCss()) and the
   * fields it summarised are now on screen at every width, which is the only
   * summary that cannot go stale. andList() stays — givenAxes() and three of
   * the alert boxes still use it. */

  /* What the shopper's measurement has to cover, and it is NOT the same thing in
     the two modes. The MODE declaration carries the reasoning; in short:
       cavity  cabinet + its published clearances, because the opening is cut
               once and the air gap has to be cut with it. "20mm spare" is what
               is left AFTER the fridge and its ventilation gap.
       space   the cabinet, full stop. The shopper told us the footprint they are
               willing to give the fridge; the air around it is theirs to leave.
     Every figure this function hands back follows the one rule, so the cards'
     measurement row, the drawing, the tier and "Nmm spare" all agree with each
     other in either mode without any of them having to know about the switch. */
  function fit(f, c, allow){
    var free = MODE === 'space';
    var needW = free ? f.w : f.w + 2*f.vs,
        needH = free ? f.h : f.h + f.vt,
        needD = free ? f.d : f.d + f.vr;
    /* No opening to fail against, so everything fits and there is no clearance
       to report. min is null rather than 0 or Infinity on purpose: 0 badges every
       card "tight" and Infinity badges every card "roomy", and both are claims
       about an opening the shopper never gave us. Every caller that prints or
       sorts on min checks for null instead. */
    if (c.open) return { fits:true, min:null, proud:0, fill:null,
      needW:needW, needH:needH, needD:needD };
    /* NULL, not a number, on any axis the shopper left empty — and that single
       choice is the whole of partial-cavity support. Subtracting from 0 is what
       used to make a part-measured opening reject everything: a blank depth read
       as a 0mm cavity, which no fridge on earth goes into. A null gap is not a
       gap of zero, it is no constraint, and every line below tests for it rather
       than comparing it. */
    var gW = c.w ? c.w-needW : null,
        gH = c.h ? c.h-needH : null,
        gD = c.d ? c.d-needD : null;
    /* Callers that do not name an allowance get the shopper's, so the strict
       test is written as fit(f, c, 0) and everything else follows ALLOW. */
    var a = (allow === undefined ? ALLOW : allow);
    /* The integrated range is sized to sit flush and the camping range needs no
       clearance at all — one of those standing proud is a joinery fault, not a
       choice a shopper gets to make. They are excluded from the allowance even
       when it is switched on.
       Nothing stands proud of a depth nobody gave us, hence the null guard: the
       overhang is a depth shortfall, and there is no shortfall against no
       figure. */
    var mayProud = a > 0 && f.ventSource !== 'airflow' && !f.camping;
    var proud = (mayProud && gD !== null && gD < 0 && gD >= -a) ? -gD : 0;
    /* min stays the smallest of the axes WE WERE GIVEN, overhang included as the
       negative it is. That keeps "Most room to spare" honest for free — a fridge
       that sticks out has less than none, so it sorts below every clean fit
       rather than jumping the queue on a generous width. tier() never sees it:
       card() reads .proud first.
       On a partial cavity it is the smallest of one or two gaps, which is the
       only spare room anyone can claim to know — and the caption under the
       drawing says which axes that was, so the figure is never quoted without
       its scope. min stays null only when nothing at all was measured, which is
       the c.open return above; every caller already tests for it. */
    var gaps = [gW, gH, gD].filter(function(g){ return g !== null; });
    /* How much of the opening this cabinet actually occupies, as a fraction, and
       the whole of "Best fit for your space".

       A PRODUCT of the per-axis ratios, over ONLY the axes we were given. That
       shape is the point, not an implementation detail:

         one axis    the fill on that axis, and nothing else pretending to know
         two axes    how much of that rectangle is used
         three axes  how much of the box is used

       so the figure means the same thing however much the shopper measured, and
       measuring more narrows it rather than changing the question.

       It is also what fixes the case this sort was built for. Given a width of
       900 and nothing else, a 600-wide upright scores 0.69 and an 870-wide
       under-bench 0.99, so the under-bench leads - which is the honest answer,
       because a width is the only thing that was asked about. Add a height of
       2000 and the upright takes it back (0.69 x 0.95 beats 0.99 x 0.43): the
       under-bench now wastes over a metre of a height the shopper DID give us.
       An average or a sum of the gaps gets that second case wrong; the product
       gets both without a rule for either.

       Each axis is capped at 1 so an overhang cannot buy a score above a flush
       fit - sortRows() puts proud cabinets below every clean one anyway, but a
       ratio of 1.02 reading as "better than perfect" is a trap for the next
       caller. min stays the clearance figure; this is the occupancy one, and
       they are inverses only when a single axis was measured. */
    var fills = [];
    if (c.w) fills.push(Math.min(needW/c.w, 1));
    if (c.h) fills.push(Math.min(needH/c.h, 1));
    if (c.d) fills.push(Math.min(needD/c.d, 1));
    return { fits:(gW===null||gW>=0) && (gH===null||gH>=0) && (gD===null||gD>=0||proud>0),
             min:gaps.length ? Math.min.apply(null, gaps) : null,
             fill:fills.reduce(function(p,x){ return p*x; }, 1),
             proud:proud, needW:needW, needH:needH, needD:needD };
  }
  function tier(m){ return m>=FIT.threshold?['good',FIT.roomy]:['tight',FIT.tight]; }

  function passes(f, sel){
    for (var i=0;i<GROUPS.length;i++){
      var g = GROUPS[i];
      // Only a "test" option filters. Display toggles narrow nothing, and pool
      // and only options decide which fridges exist at all, in pool() — reading
      // them here as well would OR them against their siblings, so ticking
      // Branded designs would union the liveries with the plain range instead of
      // replacing it.
      var chosen = g.options.filter(function(o){ return o.test && sel[g.id+':'+o.id]; });
      if (chosen.length && !chosen.some(function(o){ return o.test(f); })) return false;
    }
    return true;
  }

  /* The range the shopper is currently shopping.
   *
   * Everything competes for the cavity by default. Integrable units used to be
   * held back on the reasoning that they answered a different question. They do
   * not: a solid-door SK116-SD is an ordinary built-under that can ALSO take a
   * cabinet door, and hiding it meant a shopper measuring a cavity never saw a
   * fridge that fits it. The old rule also swept up ten glass and heated-door
   * fridges that were never integrable at all.
   *
   * Branded designs are the one exception, and they are handled HERE rather than
   * in passes() on purpose. Held back, they are out of the range entirely, so the
   * total says 179 rather than 380, every filter counts against 179, and "our
   * smallest fridge" names one the shopper can actually see. Filtering them
   * instead would leave a shopper with no branded fridges on screen and eight
   * dropdowns to blame for it.
   *
   * Ticked, they swap places with the plain range rather than joining it: the
   * grid becomes liveries only, and every count, total and alert re-scopes to
   * them because they are the pool now. Someone who ticks Branded designs is
   * hunting a Coca-Cola or Ned Kelly fridge, not sifting one out of 380. */
  function pool(sel){
    var closed = [], only = [];
    GROUPS.forEach(function(g){
      g.options.forEach(function(o){
        var inSet = o.pool || o.only;
        if (!inSet) return;
        if (sel && sel[g.id+':'+o.id]){ if (o.only) only.push(inSet); }
        else closed.push(inSet);
      });
    });
    if (!closed.length && !only.length) return FRIDGES;
    return FRIDGES.filter(function(f){
      if (only.length && !only.some(function(inSet){ return inSet(f); })) return false;
      return !closed.some(function(inSet){ return inSet(f); });
    });
  }

  /* allow is optional and defaults, through fit(), to the shopper's ALLOW.
     Naming it is how the alert asks the counterfactual — "how many would be
     here if they said yes" — without disturbing what is on screen. */
  function results(sel, allow){
    var c = cavity();
    return pool(sel).filter(function(f){ return passes(f,sel); })
      .map(function(f){ return { f:f, r:fit(f,c,allow) }; })
      .filter(function(x){ return x.r.fits; });
  }

  /* Which sort answers the question the shopper has actually asked, given how
     much of the opening they have told us about. Runs before every render, and
     only until they touch the dropdown themselves - see SORT_TOUCHED.

       nothing measured   capacity. There is no opening to fit, so "best fit"
                          and "room to spare" both have nothing to say, and
                          sortRows() falls back to capacity regardless.
       one or two axes    best fit. This is the case capacity gets WRONG: at 900
                          wide and nothing else, every upright in the range fits
                          and sorts above the under-bench fridges that suit a
                          900mm gap, purely because they are taller than a space
                          nobody measured. The UNMEASURED axis is doing the
                          ranking.
       all three          capacity. The box is fully constrained now, so what is
                          left to choose between is how much fridge you get for
                          it - and fill and capacity largely agree by then.

     The select's value is rewritten rather than the mode being passed around, so
     the dropdown always names the order actually on screen. A shopper who has
     picked a sort keeps it through every measurement change: the point of this
     is a better default, not overruling anyone. */
  var SORT_TOUCHED = false;
  function autoSort(){
    if (SORT_TOUCHED) return;
    var c = cavity(), given = (c.w?1:0) + (c.h?1:0) + (c.d?1:0);
    var el = $('#ff-sort'), want = (given === 1 || given === 2) ? 'fit' : 'cap';
    if (!el) return;
    /* Guarded like the other markup landing in the SAME deploy round as the code
       reading it: against a stale snippet with no 'fit' option, assigning the
       value would silently blank the select and sortRows() would sort on ''. */
    var has = false;
    for (var i=0;i<el.options.length;i++) if (el.options[i].value === want) has = true;
    if (has && el.value !== want) el.value = want;
  }

  /* Where a row sits relative to the camping block. -1 is everything that is not
     camping gear, so the whole block lands at the FOOT of the grid whatever the
     sort, and 0/1/2 is the order BFA asked for within it: portable fridge, then
     eskys, then fire pits.

     Ranked here rather than filtered out, because camping gear does fit and a
     shopper who measured a 900mm gap can legitimately be shown an esky - just
     not above the fridges. The Camping filter is still the way to see only these,
     and when it is ticked they are the only rows there, so a block that is
     "always last" is simply the whole grid, in the stated order.

     f.camp comes from campKind() in derive.js. Defaulting an unknown string to 0
     rather than dropping it keeps a camping item that this engine has no bucket
     for inside the block instead of scattering it up among the fridges - the same
     call campKind() makes when it falls through to 'portable'. */
  var CAMP_ORDER = { portable:0, esky:1, firepit:2 };
  var campRank = function(f){
    if (!f.camping) return -1;
    var r = CAMP_ORDER[f.camp];
    return r === undefined ? 0 : r;
  };

  function sortRows(rows){
    var mode = $('#ff-sort').value;
    /* Every row's min is null and every fill is 1 with no cavity, so both of
       these would sort on nothing and hand the order to whatever the engine felt
       like. Falls back to the default. */
    if ((mode === 'room' || mode === 'fit') && cavity().open) mode = 'cap';
    var rootModel = function(m){ var x=/^([A-Z]+\d+)/.exec(String(m||'').replace(/^(HUS|DW|EC)-/,'')); return x?x[1]:String(m||''); };
    return rows.sort(function(a,b){
      /* FIRST, and ahead of the mode, which is the whole point: camping gear goes
         to the bottom on capacity, best fit, room to spare AND price alike. Read
         it as a section break rather than a sort key - the mode orders the
         fridges, then it orders the camping block, and the two never interleave.
         Cheapest-first would otherwise open on a fire pit. */
      var ca = campRank(a.f), cb = campRank(b.f);
      if (ca !== cb) return ca - cb;
      if (mode==='price') return (a.f.price||0)-(b.f.price||0);
      if (mode==='room') return b.r.min-a.r.min;
      /* Proud first, then fill, then straight on into the capacity tiebreak
         below - which is why this is a variable and not a return. A cabinet
         standing out of the opening is not a better fit than one sitting inside
         it however much of the hole it fills, and fit() caps each axis at 1
         precisely so it cannot claim otherwise; this line is the other half of
         that. Two fridges filling the same fraction are then separated by
         capacity and model, so the order is total and a re-render never
         reshuffles equals. */
      var lead = 0;
      if (mode==='fit') lead = (a.r.proud?1:0)-(b.r.proud?1:0) || (b.r.fill-a.r.fill);
      return lead
        || (b.f.cap||0)-(a.f.cap||0)
        || rootModel(a.f.model).localeCompare(rootModel(b.f.model))
        || String(a.f.model).localeCompare(String(b.f.model));
    });
  }

  var money = function(n){
    var v = Number(n).toLocaleString('en-AU',{minimumFractionDigits:2});
    return MONEY.replace(/\{\{\s*amount[^}]*\}\}/, v);
  };
  /* The collection card's own spec-row markup, class for class: a
     li.pr-info-single holding a .pr-info-label / .pr-info-detail pair inside
     div.pr-info > ul. Emitting the theme's names rather than our own is what
     makes the zebra striping, the label blue, the 12px type and the orange
     model number arrive from the shop's stylesheet instead of being guessed at
     here — which is where the two grids had drifted apart. */
  var row = function(k,v,cls,vcls,attrs){
    return '<li class="pr-info-single'+(cls?' '+cls:'')+'"'+(attrs?' '+attrs:'')+'>'
      + '<span class="pr-info-label">'+k+'</span>'
      + '<span class="pr-info-detail'+(vcls?' '+vcls:'')+'">'+v+'</span></li>';
  };

  var htmlEsc = function(s){ return String(s==null?'':s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); };

  /* The air gap this fridge wants, for the freestanding card - the figures fit()
     stopped charging the shopper for. Two lines, filling the two .ff-cav-row
     already reserves, because "Ventilation:" plus the whole string on one line
     overruns the narrowest grid column by about 35px (see .ff-vent-row).
     "Top & Side" collapsed to one figure only where they ARE one figure. Across
     the range they agree on all but two cabinets - the HUS-SC700W at 40 side /
     20 top and the SK156-COMBO-BM at 15 / 10 - and printing "Top & Side 40mm" at
     an SC700W shopper would overstate the top gap by double on the one axis a
     bar fridge under a bench has least of. Cheap to be right: those two get all
     three named. */
  /* The same clearance as one running phrase, for the drawing's caption, where
     the two-line card layout has nothing to hang off. Same "Top & Side" collapse
     and the same two exceptions - see ventNeed(). */
  function ventGap(f){
    return (f.vs === f.vt
      ? 'top &amp; sides ' + f.vt + 'mm'
      : 'top ' + f.vt + 'mm, sides ' + f.vs + 'mm')
      + ', rear ' + f.vr + 'mm';
  }

  function ventNeed(f){
    var sides = f.vs === f.vt
      ? 'Top &amp; Side ' + f.vt + 'mm'
      : 'Top ' + f.vt + 'mm, Side ' + f.vs + 'mm';
    return '<span class="ff-cav-d">' + sides + '</span>'
      + '<span class="ff-vent-r">Rear ' + f.vr + 'mm</span>';
  }

  /* Feefo stars — the MODEL's score, not this exact SKU's.
   *
   * Feefo keys reviews on variant SKU, so a branded wrap of a well-reviewed
   * cabinet has none of its own and would show nothing. The figure here is
   * pooled across the SKUs whose reviews describe this fridge (derive.js
   * reviewPool), which Feefo averages server-side.
   *
   * No attribution on the card, decided 2026-08-19. A star rating and a count
   * are an aggregate claim about the model, and read as one; the moment a
   * customer's actual WORDS appear they are attached to the fridge that customer
   * bought, which is the product page's job. That is the whole rule: stars are a
   * model score, written reviews are a product claim.
   *
   * The screen-reader span stays. It carries the same sentence a sighted user
   * gets from the tooltip — the stars are aria-hidden decoration and "(202)"
   * alone says nothing — and it is not attribution, just the figure in words. */
  function stars(f){
    if (!f.reviews || !f.rating) return '<span class="ff-rate-none">Not yet reviewed</span>';
    /* Two numbers, not a percentage: the row has gaps in it, so 95% of its width
       is 4.75 stars plus a slice of gap. See star-css.js. */
    var whole = Math.floor(Math.max(0, Math.min(5, f.rating)));
    var frac = (Math.max(0, Math.min(5, f.rating)) - whole).toFixed(2);
    var n = f.reviews + (f.reviews === 1 ? ' review' : ' reviews');
    var said = 'Rated '+f.rating.toFixed(1)+' from '+n;
    return '<span class="ff-stars" style="--bfau-star-n:'+whole+';--bfau-star-frac:'+frac+'" title="'+said+'" aria-hidden="true"><i></i></span>'
      + '<span class="ff-rate-c" title="'+said+'">('+f.reviews+')</span>'
      + '<span class="ff-sr">'+said+'</span>';
  }

  /* ── Live ratings, one request per chassis ──────────────────────────────
   *
   * The baked figures paint first because they are in a CDN file and they are
   * instant. These replace them, so a fridge tagged into the collection since
   * the last build gets stars on this page load rather than on the next rebuild.
   * That is the whole reason this exists: a rating was the last thing on a card
   * that still needed someone to remember to rebuild.
   *
   * Fetched as cards approach the viewport rather than all at once. The unit is
   * the POOL, not the card — one call answers every fridge on that chassis — so
   * a screen of 24 cards costs about 8 requests. Feefo's own widget spends 24 on
   * a collection page, one per card, so this is lighter than what the shop
   * already runs.
   */
  var RATE_URL = root.getAttribute('data-reviews') || "https://api.feefo.com/api/10/reviews/summary/product?since_period=all&unanswered_feedback=include&source=on_page_product_integration&merchant_identifier=bar-fridges-australia&origin=bar-fridges-australia.com.au";

  /* The star levels the shop quotes, and the same list card-stars.browser.js,
     model-stars.browser.js and model-reviews.browser.js carry. A finder card
     and the collection card beside it are the same claim about the same fridge,
     so they have to say one number; build-reviews.js asserts all four agree.

     Summed from the histogram rather than asked for with &rating=, because only
     the COUNT follows the floor. The SCORE stays Feefo's over every review
     including the ones not quoted -- see the note in model-reviews.browser.js
     for why the two part company. */
  var SHOWN = '3,4,5';
  function isShown(level){ return SHOWN.split(',').indexOf(String(level)) >= 0; }
  /* Keyed on the pool, not the SKU: every SC70 shares one entry, so the second
     card of a chassis costs nothing. Lives out here rather than on the records
     because render() rebuilds the whole grid on every keystroke in the cavity
     fields — anything hanging off a node is thrown away with it. */
  var RATINGS = {}, POOL_OF = {}, RATE_Q = [], RATE_BUSY = 0, RATE_OBS = null;
  var RATE_MAX = 3;

  /* Which SKUs speak for this fridge, memoised. derive.js's rule, inlined above
     and shared with the Node build, so the finder and the collection page cannot
     pool a fridge differently. Null where nothing may speak for it — 4 fridges,
     all genuinely one-off chassis. */
  function poolKeyFor(f){
    if (!f || !f.sku) return null;
    if (POOL_OF[f.sku] !== undefined) return POOL_OF[f.sku];
    var list = reviewPool(f, FRIDGES);
    return (POOL_OF[f.sku] = list.length ? list.join(',') : null);
  }

  /* Onto the records as well as the DOM. The DOM patch is what the shopper sees
     now; the record is what the NEXT render() reads, so ticking a filter after a
     rating lands does not throw it away and fetch it again. */
  function applyRating(key, val){
    RATINGS[key] = val || null;
    if (!val) return;
    FRIDGES.forEach(function(f){
      if (poolKeyFor(f) !== key) return;
      f.rating = val.rating; f.reviews = val.reviews;
    });
    $$('[data-pool]').forEach(function(li){
      if (li.getAttribute('data-pool') !== key) return;
      var d = li.querySelector('.pr-info-detail');
      if (d) d.innerHTML = stars({ rating: val.rating, reviews: val.reviews });
    });
    /* Hovered while it was still in flight — open it now rather than making the
       shopper move off and back. */
    if (POP_KEY === key && POP_EL) popShow(key, POP_EL);
  }

  /* The breakdown panel. One element for the whole grid, on <body>: a panel per
     card would be 24 of them, and render() throws away everything inside the
     grid on each keystroke anyway.
     Only a pool that has ANSWERED has per-level counts — a baked rating is a
     number and a count and nothing else — so hovering a card that has not been
     fetched yet asks for it and opens the panel when it lands, if the pointer
     is still there. In practice the observer has usually fetched it 300px
     before the card arrived. */
  var POP = null, POP_KEY = null, POP_EL = null;

  function popEl(){
    if (POP) return POP;
    POP = document.createElement('div');
    POP.className = 'frothy ff-pop';
    POP.hidden = true;
    document.body.appendChild(POP);
    return POP;
  }

  function popShow(key, el){
    var v = RATINGS[key];
    if (!v || v === 'pending' || !v.hist) return;
    var p = popEl();
    var score = v.rating % 1 === 0 ? String(v.rating) : v.rating.toFixed(1);
    var h = '<p class="bfau-pop-t">' + score + '/5 Stars</p>';
    for (var i = 0; i < 5; i++){
      var n = v.hist[i] || 0;
      var w = v.reviews ? (n / v.reviews) * 100 : 0;
      h += '<div class="bfau-pop-r"><span class="bfau-pop-l">' + (5 - i) + ' Star'
        + (i === 4 ? '' : 's') + '</span><span class="bfau-pop-n">' + n + '</span>'
        + '<span class="bfau-pop-bar"><i style="width:' + w.toFixed(1) + '%"></i></span></div>';
    }
    p.innerHTML = h;
    p.hidden = false;
    var a = el.getBoundingClientRect();
    var left = a.left + a.width / 2 - p.offsetWidth / 2;
    left = Math.max(8, Math.min(left, document.documentElement.clientWidth - p.offsetWidth - 8));
    var below = a.bottom + 10;
    var fits = below + p.offsetHeight < window.innerHeight - 8;
    p.style.left = left + 'px';
    p.style.top = (fits ? below : Math.max(8, a.top - p.offsetHeight - 10)) + 'px';
  }

  function popHide(){ POP_KEY = null; POP_EL = null; if (POP) POP.hidden = true; }

  /* Delegated from the grid, which outlives every card in it. */
  function popBind(){
    var grid = $('[data-grid]');
    if (!grid || grid.__ffPop) return;
    grid.__ffPop = 1;
    grid.addEventListener('mouseover', function(e){
      var st = e.target.closest && e.target.closest('.ff-stars, .ff-rate-c');
      if (!st) { if (POP_EL && !(e.target.closest && e.target.closest('.ff-rate-row'))) popHide(); return; }
      var li = st.closest('[data-pool]');
      var key = li && li.getAttribute('data-pool');
      if (!key) return;
      POP_KEY = key; POP_EL = st;
      requestRating(key);            // no-op if it is known or already queued
      popShow(key, st);
    });
    grid.addEventListener('mouseleave', popHide);
    window.addEventListener('scroll', popHide, { passive:true });
  }

  function rateNext(){
    if (RATE_BUSY >= RATE_MAX || !RATE_Q.length) return;
    var key = RATE_Q.shift();
    /* Marked before the request goes out, not after it lands. A key that has
       been shifted off the queue but has not answered yet is in neither RATINGS
       nor RATE_Q, so the second card of a chassis scrolling into view during
       that window queued the same pool again — visible in the network panel as
       a duplicate served from browser cache. Wasted rather than wrong, but it
       breaks the one-request-per-pool property the whole design rests on.
       'pending' is overwritten by applyRating(), and by null on failure. Nothing
       reads the VALUE — requestRating() only asks whether the key is known. */
    RATINGS[key] = 'pending';
    RATE_BUSY++;
    fetch(RATE_URL + '&product_sku=' + encodeURIComponent(key), { credentials:'omit' })
      .then(function(r){ if (!r.ok) throw new Error('HTTP '+r.status); return r.json(); })
      .then(function(j){
        var pr = (j && j.rating && j.rating.product) || {};
        /* The per-level counts come back beside the average, so the hover
           breakdown costs no request of its own -- and the count is summed from
           them rather than read from pr.count, which is every review Feefo
           holds. The levels not quoted are held at 0 rather than carrying their
           real figure, because the breakdown panel reads these out and 0 is
           what is behind those rows. */
        var hist = [], c = 0;
        for (var i = 5; i >= 1; i--) {
          var n = isShown(i) ? (pr[i + '_star'] || 0) : 0;
          hist.push(n);
          c += n;
        }
        /* Zero reviews and a failed lookup are the same thing to a card, and
           both leave the baked figure alone rather than clearing it. */
        applyRating(key, c > 0 ? { rating: j.rating.rating, reviews: c, hist: hist } : null);
      })
      /* Silent. A shopper with a stale rating has a working finder; the baked
         figure is already on screen and stands. */
      .catch(function(){ RATINGS[key] = null; })
      .then(function(){ RATE_BUSY--; rateNext(); });
  }

  function requestRating(key){
    if (!key || !RATE_URL) return;
    if (RATINGS[key] !== undefined || RATE_Q.indexOf(key) >= 0) return;
    RATE_Q.push(key);
    rateNext();
  }

  /* Re-attached on every render(), because every render() replaces the nodes it
     was watching. Cheap: the observer only ever holds the rows currently in the
     grid, and a pool already fetched is skipped by requestRating().
     No IntersectionObserver means no live ratings and the baked figures stand,
     which is a working finder rather than a broken one. */
  function observeRatings(){
    if (typeof IntersectionObserver === 'undefined' || !RATE_URL) return;
    if (RATE_OBS) RATE_OBS.disconnect();
    RATE_OBS = new IntersectionObserver(function(es){
      es.forEach(function(e){
        if (!e.isIntersecting) return;
        RATE_OBS.unobserve(e.target);
        requestRating(e.target.getAttribute('data-pool'));
      });
    }, { rootMargin: '300px 0px' });
    // A card just below the fold is worth starting early: 300px of margin means
    // the stars are usually there by the time the card is.
    $$('[data-pool]').forEach(function(el){ RATE_OBS.observe(el); });
  }

  /* Stock in the shop's own three states.
   *
   * 'preorder' is BFA's rule — at or below zero stock with *Continue selling
   * when out of stock* ticked — resolved at build time from the one place both
   * halves of it are visible. Note the theme uses <= 0, not < 0: sitting at
   * exactly zero and still orderable is a pre-order too.
   *
   * No badge. The shop runs use_preorder_badge: false, so a real collection card
   * never shows one, and the finder introducing its own was the difference
   * showing. The Status row still says Pre Order, which is where a shopper on
   * this site is used to reading it. Flip to true only if the theme setting
   * flips too. */
  var SHOW_PREORDER_BADGE = false;

  /* The status row, exactly as the collection card builds it. Two states there,
     not three: in stock, or Pre Order with the expected date beside it. The
     .pre-order class goes on the LABEL as well as the detail — that is where
     the orange comes from — so this row is assembled whole rather than through
     row(). f.eta is the bfau-pr.expectation metafield, f.etaDate the
     expectation-date; the card shows whichever is set, and neither is invented
     here when the data has none. */
  function stockRow(f){
    if (f.stock === 'in')
      return '<li class="pr-info-single"><span class="pr-info-label">Status:</span>'
        + '<span class="pr-info-detail in-stock">In Stock</span></li>';
    var when = f.eta ? htmlEsc(f.eta) : (f.etaDate ? 'Avl. '+htmlEsc(f.etaDate) : '');
    if (f.stock === 'out')
      return '<li class="pr-info-single"><span class="pr-info-label">Status:</span>'
        + '<span class="pr-info-detail pre-order">Out of Stock</span></li>';
    return '<li class="pr-info-single"><span class="pr-info-label pre-order">Pre Order</span>'
      + '<span class="pr-info-detail pre-order">'+when+'</span></li>';
  }

  /* The theme's own badge container and pills, not a lookalike. With
     t4s-pr-style6 on the card, BFA's override pins the container to the whole
     image box, corners the sale flash top-left and drops any custom badge
     bottom-right — the "Scratch n Dent" treatment. Text and order match
     theme.min.js: sale first (label_sale_style 2, "-N% OFF"), then sold out or
     pre-order, then the product's own badges. */
  function badgeSlug(s){
    return String(s).toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-+|-+$/g,'');
  }
  function badges(f, pct){
    var b = '';
    if (pct) b += '<span class="t4s-badge-item t4s-badge-sale">-'+pct+'% OFF</span>';
    if (f.stock === 'out') b += '<span class="t4s-badge-item t4s-badge-soldout">Sold Out</span>';
    else if (f.stock === 'preorder' && SHOW_PREORDER_BADGE)
      b += '<span class="t4s-badge-item t4s-badge-preorder">Pre Order</span>';
    (f.badges || []).forEach(function(t){
      b += '<span class="t4s-badge-item t4s-badge-custom t4s-badge-'+badgeSlug(t)+'">'+htmlEsc(t)+'</span>';
    });
    return b ? '<div class="'+CLS.badge+'">'+b+'</div>' : '';
  }

  /* On sale, the original price is struck through and the new price called out.
     The discount percentage is carried by the corner flash on the image, not by
     a second badge here.
     In the theme the del/ins pair IS the theme's own price markup, so colours
     and weights come from its stylesheet; standalone we style it. */
  function priceHtml(f){
    var price = '<div class="'+CLS.price+'">';
    /* A price of zero means the options app is doing the pricing, not Shopify.
       Nothing in the range should be in that state — a product configured that
       way is one the shopper builds, and a fit finder cannot answer for it
       because the size is a choice too. It is kept out of the collection rather
       than handled here.
       This is the net under that: left alone the card rendered an empty price
       line, which reads as a card that failed to load rather than a product
       priced differently. Colour and weight inherit from the price line, so it
       stays the shop's price green in both builds. */
    if (!f.price){
      return price + '<span class="ff-tospec">Priced to Spec</span></div>';
    }
    if (THEME){
      price += f.was ? '<del>'+money(f.was)+'</del><ins>'+money(f.price)+'</ins>'
                     : (f.price ? money(f.price) : '');
    } else {
      if (f.was) price += '<span class="ff-was">'+money(f.was)+'</span>';
      if (f.price) price += '<span class="ff-price'+(f.was?' is-sale':'')+'">'+money(f.price)+'</span>';
    }
    return price + '</div>';
  }

  function card(x){
    /* sized is "there is an opening to judge this against". Without one there is
       no tier to name, so tier() is never asked for a verdict it cannot have. */
    var f = x.f, sized = x.r.min !== null, t = sized ? tier(x.r.min) : null,
        air = f.ventSource==='airflow';
    /* Camping gear needs no clearance, so its "Cavity" row would restate the
       Size row above it figure for figure — which reads as a contradiction, not
       as information. Suppressed for the same reason the integrated range's is,
       and by the same means: the fit maths still runs on it, it simply is not
       listed. Kept as its own flag rather than folded into air, because air
       ALSO swaps the Fit row for "flush" and prints the 200cm2 airflow note,
       and neither is true of an esky. */
    var noCavity = air || !!f.camping;

    /* Every row is always rendered, with a dash where a value is missing, so the
       spec block is the same height on every card and the fit line always lands
       in the same place down the grid. */
    /* Reviews first, then Model, then Size — the same order as the theme's own
       collection card (the pr-info list in product-grid-item7.liquid), so the
       two grids read as one system rather than two takes on the same product. */
    /* Cans and wine bottles are three cases, not two, and the collection card
       already gets this right: both, cans only, or bottles only. Reading it as
       "wine or not" put "Cans / Wine Btls: — / 135" on the eight wine-only
       fridges, which claims a can capacity nobody published. */
    var capRow = f.cans && f.wine ? row('Cans / Wine Btls:', f.cans+' / '+f.wine)
      : f.cans ? row('Cans:', f.cans)
        : f.wine ? row('Wine Btls:', f.wine)
          : row('Cans:', '\u2014');

    /* The pool key rides on the row, so the observer has something to watch and
       applyRating() has something to patch. Absent on the handful of fridges
       nothing may speak for, which is exactly the ones that must never be
       fetched: Feefo answers a blank product_sku with the MERCHANT's overall
       score, which would put the shop's rating on an unreviewed fridge. */
    var pkey = poolKeyFor(f);
    var spec = row('Reviews:', stars(f), 'ff-rate-row', null,
      pkey ? 'data-pool="'+htmlEsc(pkey)+'"' : null)
      + row('Model:', htmlEsc(f.model)||'\u2014', null, 'pr-info-model')
      + row('Size:', f.w+' x '+f.d+' x '+f.h+' WxDxHmm')
      /* Integrated units are built in flush — their cabinet size IS the opening,
         so quoting it back as a separate line just reads as a contradiction. The
         fit maths still uses it; it simply isn't listed.
         "Cavity:", shortened from "Cavity Needed:" 2026-09-09, and the mm rides
         on the figure. Both are about the same 228px column: the longer label
         plus the figure came to more text than the row had room for, so the row
         had been stacked outright to stop the figure wrapping mid-dimension.
         Seven characters back buys enough that the figure sits beside its label
         again even on the longest string we hold, and that frees the line below
         it for the overhang — which is the whole point of the rename. See
         .ff-cav-row for the measurement.
         The overhang span is emitted whether or not this fridge stands proud.
         Empty it reserves its line, and the row is the same two lines tall it
         has always been, so the fit line still lands at one height across the
         grid. */
      /* Freestanding shows the CLEARANCE here instead of a required space, and
         the swap is the other half of fit()'s branch rather than a second idea.
         In that mode the space row would read "600 x 570 x 850mm" against a Size
         row directly above it reading "600 x 570 x 850 WxDxHmm" - the same three
         numbers twice, which is how the integrated range earned its suppression a
         few lines up. The row the shopper actually needs there is the one thing
         those figures do NOT include, so that is what the line carries.
         Same .ff-cav-row, so it is the same two-line block in the same place down
         every card and a mode toggle moves nothing. */
      + (noCavity ? '' : (MODE === 'space'
        ? row('Ventilation:', ventNeed(f), 'ff-cav-row ff-vent-row')
        : row(W().row,
          '<span class="ff-cav-d">'+x.r.needW+' x '+x.r.needD+' x '+x.r.needH+'mm</span>'
          + '<span class="ff-proud">'
          + (x.r.proud ? 'Sits '+x.r.proud+'mm proud' : '')
          + '</span>', 'ff-cav-row')))
      + capRow
      + row('Ltrs:', f.cap ? f.cap+'L' : '\u2014')
      + row('Suitability:', htmlEsc(f.suitability) || '\u2014')
      + row('Brand:', htmlEsc(f.brand) || '\u2014')
      + row('Energy Star Rating:', f.energy || '\u2014')
      + stockRow(f)
      /* Two blocks, not one run with a middot — see .ff-fit-line. The tier
         names the fit, the second line gives the clearance it is based on,
         and neither can be broken across lines by a narrow card. */
      /* No millimetres on a proud fridge's Fit row: the Cavity row two above it
         already carries the figure, and printing it twice in one spec block
         reads as two different measurements rather than one. The tier name and
         the amber are this row's whole job here. x.r.min is no use to it either
         — it is the depth shortfall, a negative, and "-14mm spare" is not a
         sentence. */
      /* A dash, the same as any other row with no value — the Cavity row above
         still says what this fridge needs, which is the whole of what we know
         until a cavity is typed. Rendered rather than dropped so the spec block
         stays the same height as every other card's. */
      + row('Fit:', air
        ? '<span class="ff-fit-air">'+FIT.flush+'</span>'
        : !sized
          ? '\u2014'
        : x.r.proud
          ? '<span class="ff-fit-warn"><span class="ff-fit-line">'+FIT.proud+'</span></span>'
          : '<span class="ff-fit-'+t[0]+'"><span class="ff-fit-line">'+t[1]+'</span>'
            + '<span class="ff-fit-line">'+x.r.min+'mm spare</span></span>', 'ff-fit-row');

    var pct = f.was ? Math.round((f.was-f.price)/f.was*100) : 0;

    /* A div, not an article, and the same nesting as product-grid-item7.liquid:
       info > info__inner > title + info-detail > price-cart + pr-info. BFA's
       custom theme CSS is tag-qualified — 'div.t4s-product h3.t4s-product-title'
       and 'div.t4s-product{--product-title-size}' — so on an <article> the title
       loses its clamp, its min-height and its size, and the 0.8rem gutters key
       off this nesting, not off the classes alone. */
    var picked = CMP.indexOf(f.handle) !== -1;
    return '<div class="'+CLS.card+(picked?' ff-picked':'')+'"'+(f.productId?' data-pid="'+f.productId+'"':'')+'>'
      + '<div class="'+CLS.wrapper+'">'
      + '<div class="'+CLS.img+'">'
      + badges(f, pct)
      + (f.img?'<img src="'+f.img+'" alt="" loading="lazy">':'')
      + '<a class="'+CLS.imglink+'" href="'+PBASE+f.handle+'" tabindex="-1" aria-hidden="true"></a>'
      + '</div>'
      + '<div class="'+CLS.info+'"><div class="'+CLS.inner+'">'
      + '<h3 class="'+CLS.title+'"><a href="'+PBASE+f.handle+'">'+htmlEsc(f.title)+'</a></h3>'
      + '<div class="'+CLS.detail+'">'
      + '<div class="'+CLS.priceWrap+'">'+priceHtml(f)+'</div>'
      + (air ? '<p class="ff-airnote">'+AIRFLOW_NOTE+'</p>' : '')
      + '<div class="'+CLS.spec+'"><ul>'+spec+'</ul></div>'
      + '</div></div></div>'
      /* Last in the wrapper, so it is the card's foot on every card and a row
         of stretched cards puts every tickbox on one line. Camping gear gets
         none - an esky beside a bar fridge is not a comparison. */
      + (comparable(f)
        ? '<label class="ff-cmp"><input type="checkbox" data-cmp="'+htmlEsc(f.handle)+'"'
          + (picked?' checked':'')+'><span>Compare</span></label>'
        : '')
      + '</div></div>';
  }

  /* Shelf and parts cards, dropped in beside the fridges they fit.
   *
   * Placed after the LAST card of each chassis rather than the first, so a
   * family reads as a block and its accessories close it. One shelf fitting
   * SK156, SK220 and SK422 is emitted three times, once under each family —
   * which is the point: a shopper looking at an SK220 should not have to know
   * the same shelf was already shown under a fridge they scrolled past.
   *
   * Keyed on the chassis baked into the data, never re-derived here, so what a
   * shelf claims to fit and what a fridge claims to be cannot drift apart.
   */
  function withAccessories(rows){
    /* Nothing rides along uninvited. Each kind is asked for separately under
       View options, because they answer different questions — a shelf is an
       upgrade to a fridge you are buying, a hinge kit is what makes it take a
       cabinet door — and a shopper who wants one rarely wants both. */
    var showShelves = active['view:shelves'], showKits = active['view:kits'];
    var ACCESSORIES = ALL_ACCESSORIES.filter(function(a){
      return a.kind === 'kit' ? showKits : showShelves;
    });
    if (!ACCESSORIES.length) return rows.map(card);
    /* For each accessory, the last row of EACH chassis that it actually suits.
       Two rules at once, and both matter:
         - per chassis, so a kit fitting fourteen families appears under all
           fourteen rather than once at the foot of the grid;
         - by SKU within the chassis, so a hinge kit lands after the solid-door
           SK156s and never beside the heated ones it cannot fit. */
    var lastFor = ACCESSORIES.map(function(){ return {}; });
    rows.forEach(function(x, i){
      if (!x.f.chassis) return;
      ACCESSORIES.forEach(function(a, k){
        if (a.skus.indexOf(x.f.sku) >= 0) lastFor[k][x.f.chassis] = i;
      });
    });
    var out = [];
    rows.forEach(function(x, i){
      out.push(card(x));
      if (!x.f.chassis) return;
      ACCESSORIES.forEach(function(a, k){
        if (lastFor[k][x.f.chassis] === i) out.push(accessoryCard(a, x.f));
      });
    });
    return out;
  }

  /* Deliberately not the fridge card. No spec table, because every row on it
     asks a question a shelf cannot answer, and no fit line, because it does not
     fit anything — it suits a fridge. The badge and price markup are shared so
     the two read as one family. */
  function accessoryCard(a, f){
    var pct = a.was ? Math.round((a.was-a.price)/a.was*100) : 0;
    return '<div class="'+CLS.card+' ff-acc"'+(a.productId?' data-pid="'+a.productId+'"':'')+'>'
      + '<div class="'+CLS.wrapper+'">'
      + '<div class="'+CLS.img+'">'+badges(a, pct)
      + (a.img?'<img src="'+a.img+'" alt="" loading="lazy">':'')
      + '<a class="'+CLS.imglink+'" href="'+PBASE+a.handle+'" tabindex="-1" aria-hidden="true"></a>'
      + '</div>'
      /* No "Fits SK156" line here. The product title already names the models
         ("Roller Shelf To Suit SK156, SK220 and SK422") and the Suits row below
         states them exactly, so a third copy was noise on a card that only has
         room for a few lines. */
      + '<div class="'+CLS.info+'"><div class="'+CLS.inner+'">'
      + '<h3 class="'+CLS.title+'"><a href="'+PBASE+a.handle+'">'+htmlEsc(a.title)+'</a></h3>'
      + '<div class="'+CLS.detail+'">'
      + '<div class="'+CLS.priceWrap+'">'+priceHtml(a)+'</div>'
      /* Four rows, not three. A shelf card sits in the same grid row as a fridge
         card carrying eleven, so a three-row block left a band of empty card
         under the price. Model and Type are not filler — they are the two things
         the theme's own card would show and this one was dropping, and they read
         in the same order and the same colours as the fridge beside it.
         A "You need: 2 — one per door" row used to sit here. It went because the
         count is a question for the order, not for a fit finder: the page's job
         is which kit suits this fridge, and BFA can say how many when they take
         the call. */
      + '<div class="'+CLS.spec+'"><ul>'
      + row('Model:', htmlEsc(a.sku) || '\u2014', null, 'pr-info-model')
      + row('Type:', a.kind === 'kit' ? 'Sliding hinge kit' : 'Shelf')
      + row('Suits:', htmlEsc(a.fits.join(', ')))
      + stockRow(a)
      + '</ul></div>'
      + '</div></div></div>'
      + '</div></div>';
  }

  /* Which way the heat leaves, and therefore what the drawing has to show.
   *
   * A presentation question, so it lives here rather than in derive.js — nothing
   * in the Node build needs it, and derive.js is for facts about the fridge
   * rather than for how one is drawn.
   *
   * Three cases, from the two fields that already carry the answer:
   *
   *   flush  ventSource 'airflow' — the fully integrated range. No clearances at
   *          all, so it publishes none; the air goes through a duct in the
   *          joinery instead of round the cabinet.
   *   front  mount 'undercounter_units' — the Schmick SK range and its kin,
   *          exhausting through the plinth. This is WHY they ask 50/10/10 where
   *          a rear-vented cabinet the same size asks 150/40/40, and it is the
   *          single most useful thing the drawing can add: the band is already
   *          on screen, the reason for its width is not.
   *   rear   everything else — out the back and over the top.
   *
   * Note 'non_front_venting' falls into rear rather than earning a case of its
   * own. The value exists in admin to pick a different building-in article, not
   * to describe a third air path: it vents back and top like the uprights and
   * the minis do, just from inside the under-bench range. */
  function ventMode(f){
    /* Checked first. Camping gear has no mount and no clearances, so it would
       otherwise fall through to 'rear' and the diagram caption would tell a
       shopper their fire pit vents at the back and top. */
    if (f.camping) return 'none';
    if (f.ventSource === 'airflow') return 'flush';
    if (f.mount === 'undercounter_units') return 'front';
    return 'rear';
  }
  // Escaped rather than written as UTF-8, matching AIRFLOW_NOTE above: these are
  // emitted from a template literal into a file that gets uploaded and minified,
  // and an escape survives that whatever the tooling decides about encoding.
  var VENT_NOTE = {
    flush: 'Flush fit \u2014 needs a 200cm\u00b2 duct',
    front: 'Vents out the front',
    rear:  'Vents at the back and top',
    none:  'Freestanding — needs no clearance',
  };

  /* Which way each door opens, front-on, left to right.
   *
   * hingeCounts is the only field that describes doors individually, and it is
   * a count rather than an arrangement: BFA write "2 x Left & 1 x Right", which
   * says two doors open one way and one the other but never says which is which.
   * Putting the lefts first is this code's convention, not the data's — it is the
   * standard arrangement on a three-door under-bench, and it at least guarantees
   * the odd door out lands on an end rather than in the middle.
   *
   * A two-door cabinet is settled before either of those, because it is a fact
   * about the range rather than about the record: every two-door BFA sell is a
   * facing pair, hinged on the outer edges with the handles meeting in the
   * middle. Most say so — "1 x Left & 1 x Right", 146 of them — but HUS-C10 and
   * HUS-F10 carry a bare "Right", and reading that literally hung both doors the
   * same way and put one handle out at the cabinet edge. The prose is describing
   * the hinge hardware, not the arrangement.
   *
   * Below that, two fallbacks, for the 191 of 380 that name no count: the side
   * the SKU or the prose says it ships, and failing that right, which is the
   * bulk of the range. */
  function doorSides(f){
    var n = f.doors || 1, out = [], i;
    if (n === 2) return ['left', 'right'];
    var c = f.hingeCounts;
    if (c && c.left + c.right === n){
      for (i = 0; i < c.left; i++) out.push('left');
      for (i = 0; i < c.right; i++) out.push('right');
      return out;
    }
    var side = f.hinge || (f.hingeLeft && !f.hingeRight ? 'left' : 'right');
    for (i = 0; i < n; i++) out.push(side);
    return out;
  }

  /* A row of louvres — the plinth grille on a front-venting cabinet, and the duct
     in the joinery head above a flush one. Same glyph both times on purpose: it
     is the same thing, a hole for air, and drawing two would imply a difference
     that isn't there. */
  function louvres(gx, gy, gw, gh, opacity){
    if (gw < 6 || gh < 1.4) return '';
    var n = Math.max(3, Math.min(9, Math.round(gw / 6)));
    var step = gw / n, bar = Math.min(1.5, step * 0.42), s = '';
    for (var i = 0; i < n; i++){
      s += '<rect x="' + (gx + step*i + (step-bar)/2).toFixed(2) + '" y="' + (gy+0.5).toFixed(2)
        + '" width="' + bar.toFixed(2) + '" height="' + (gh-1).toFixed(2)
        + '" rx="' + (bar/2).toFixed(2) + '" fill="var(--ff-amber)" fill-opacity="' + opacity + '"/>';
    }
    return s;
  }

  /* The cabinet face: door panels, their hinges and their handles.
   *
   * Everything here is a pure function of the record, so the eight filter
   * dropdowns already drive it — best is picked from the FILTERED rows, so
   * ticking 3 Doors redraws the face with three panels and ticking Left Hinge
   * moves every handle across. No wiring, and nothing to keep in step.
   *
   * Each layer bails out rather than degrading when there is no room for it, so
   * a 430mm mini at the bottom of the scale draws a plain box instead of a
   * smudge. Same for a missing field: 40 fridges state no door count and draw as
   * one door, which is what they nearly all are. */
  function cabinetFace(f, bx, by, bw, bh, vent){
    if (bw < 5 || bh < 5) return '';
    var s = '';
    /* The grille is part of the cabinet, not of the door, so the doors are
       shortened to sit above it — a plinth vent drawn ACROSS the door bottoms
       reads as a design on the door rather than as a hole under it. */
    var plinth = vent === 'front' ? Math.min(4.5, bh * 0.16) : 0;
    if (plinth) s += louvres(bx + 1.2, by + bh - plinth, bw - 2.4, plinth, '.75');

    var sides = doorSides(f), n = sides.length;
    var pad = 0.9, gap = n > 1 ? 0.8 : 0;
    var dw = (bw - 2*pad - gap*(n-1)) / n, dh = bh - plinth - 2*pad;
    if (dw < 3 || dh < 4) return s;

    for (var i = 0; i < n; i++){
      var dx = bx + pad + i*(dw+gap), dy = by + pad;
      s += '<rect x="' + dx.toFixed(2) + '" y="' + dy.toFixed(2) + '" width="' + dw.toFixed(2)
        + '" height="' + dh.toFixed(2) + '" rx="0.8" fill="var(--ff-amber)" fill-opacity=".2" '
        + 'stroke="var(--ff-amber)" stroke-opacity=".7" stroke-width=".7"/>';
      if (dw < 6 || dh < 7) continue;
      var left = sides[i] === 'left';
      // Hinges on the stated side, two per door, set in at the quarter points.
      var hx = left ? dx - 0.7 : dx + dw - 0.7;
      var pip = Math.max(1.6, dh * 0.1);
      [0.19, 0.81].forEach(function(t){
        s += '<rect x="' + hx.toFixed(2) + '" y="' + (dy + dh*t - pip/2).toFixed(2)
          + '" width="1.4" height="' + pip.toFixed(2) + '" rx=".5" '
          + 'fill="var(--ff-amber)" fill-opacity=".95"/>';
      });
      /* Opposite the hinge, always — that one is physics rather than data, so no
         field is needed and none of the 42 "Right Hinge (Handle Left)" products
         can send it the wrong way. */
      var gw = Math.min(1.4, dw * 0.1);
      var gx = left ? dx + dw - 1.6 - gw : dx + 1.6;
      s += '<rect x="' + gx.toFixed(2) + '" y="' + (dy + dh*0.27).toFixed(2)
        + '" width="' + gw.toFixed(2) + '" height="' + (dh*0.46).toFixed(2)
        + '" rx="' + (gw/2).toFixed(2) + '" fill="var(--ff-amber)" fill-opacity=".9"/>';
    }
    return s;
  }

  /* Building-in videos, keyed on mount type. These are the same five files the
     product page serves from bfau-buildingIn-*.liquid, addressed directly rather
     than through the snippet: the snippet renders a whole accordion panel of
     diagrams and per-product cavity arithmetic, and this slot wants the video off
     the front of it. If BFA re-shoot one, the id changes in both places.
     mini_non_compressor is absent on purpose — that snippet carries diagrams and
     no video at all, and it is 2 fridges of 380. Blank mount is 24 more. Both
     fall through to Frothy, which is what he is for. */
  var BI_POSTER = 'https://cdn.shopify.com/s/files/1/0682/9549/1876/files/poster.jpg?v=1679970737';
  var BI_VID = {
    mini_compressor:       '3b95b0d40ff94a0f9500c71f73bcf626',
    undercounter_units:    '56f5286b471a411fb76a63add7386736',
    upright_free_standing: '661ab4cd224e451a9b14d227f674f841',
    non_front_venting:     '1e2fcb056f6147b48ae2cbec0d385c88',
    jc430:                 '3e275fa242df4866b5b83e6a99aca37a',
    /* No fridge carries this today — the Schmick MSL/MSF/MC units that ought to
       have it are among the 24 with the metafield unset, so they show Frothy.
       Mapped anyway: it is a real branch on the product page (bfau-buildingIn-ms,
       sharing mini-comp's video), and the day someone fills those in this starts
       working with no code change. */
    ms_modules:            '3b95b0d40ff94a0f9500c71f73bcf626'
  };
  var BI_LABEL = {
    mini_compressor:       'Building in — mini compressor',
    undercounter_units:    'Building in — undercounter',
    upright_free_standing: 'Building in — upright',
    non_front_venting:     'Building in — non front venting',
    jc430:                 'Building in — JC430',
    ms_modules:            'Building in — MS modules'
  };

  /* The one mount type every fridge on screen shares, or null if they differ.
     Blank mounts are skipped rather than counted as a type of their own: 24
     fridges carry none, and letting one of them veto the video would mean a set
     that is otherwise all undercounter shows Frothy because of a gap in the
     data. A set that is ONLY blanks still returns null — seen never gets set.
     Returns {mount, blanks} rather than the bare mount because the note under
     the video has to say what the claim covers. "Every result builds in this
     way" is a lie the moment one of the 24 blank-mount fridges is on screen: it
     was skipped, not agreed with. So the count of what was skipped travels back
     with the verdict rather than being recounted at the call site against a rule
     that only lives in here. */
  function oneMount(rows){
    var seen = null, blanks = 0;
    for (var i = 0; i < rows.length; i++){
      var m = rows[i].f.mount;
      if (!m){ blanks++; continue; }
      if (seen === null) seen = m;
      else if (seen !== m) return { mount: null, blanks: 0 };
    }
    return { mount: seen, blanks: blanks };
  }

  /* Best fit first, unanimous set second — in that order because measured, on
     this tool, is the state that actually resolves to one mount type.
     The other way round was tried first and measured: a unanimous result set
     happens on 2 of the 33 filter options and on NONE of eight realistic
     cavities, because a 600x600x850 opening takes undercounter and mini
     compressor units alike. Keying off the best fit instead pairs the video with
     the fridge the diagram is already drawing — same fridge, one column apart,
     which is the whole reason bestRow() is shared.
     The unanimous case is kept underneath it because it is the one path that
     works with no measurements at all: tick "Fully integrated" and every result
     is undercounter, so the video is honest before a single box is filled.

     Returns which path won, not just the answer, because the two paths make
     DIFFERENT claims and the note under the video has to print the right one.
     Best fit is one fridge out of a set that may build in several ways; the
     unanimous path is a statement about every result on screen. Collapsing both
     into "based on the best fitting fridge" would put a caveat on the one branch
     that does not need it — and that branch is the fresh-page, nothing-measured
     state, so it is the first thing a lot of shoppers see. */
  function biMount(rows){
    var b = bestRow(rows);
    if (b && b.f.mount) return { mount: b.f.mount, via: 'best', best: b, blanks: 0 };
    var one = oneMount(rows);
    return { mount: one.mount, via: 'all', best: null, blanks: one.blanks };
  }

  /* What the video is claiming, in a sentence, or '' when it claims nothing
     beyond itself. Split out from drawBuildingIn so the wording sits next to
     biMount's two paths rather than three lines deep in the render.
     'best' names the fridge, the same way the drawing's caption does and off the
     same row — the two columns are side by side and naming one fridge in one of
     them would read as two different answers.
     'all' does NOT name a fridge, because there is no single one to name: the
     claim is about the set. Where blanks were skipped it says so — those
     fridges are not covered either way, and a shopper whose fridge is one of the
     24 should not read "every result" and count themselves in. */
  function biNote(pick){
    if (!pick.best && !pick.mount) return '';
    if (pick.via === 'best'){
      return 'Based on the best fitting fridge, '
        + (pick.best.f.model || pick.best.f.title)
        + '. Other results may build in differently.';
    }
    return pick.blanks
      ? 'Every result with building-in details builds in this way; '
        + pick.blanks + (pick.blanks === 1 ? ' result has' : ' results have')
        + ' none on file.'
      : 'Every result on screen builds in this way.';
  }

  function drawBuildingIn(rows){
    var vid = $('[data-bi-vid]'), fro = $('[data-bi-frothy]'), lab = $('[data-bi-lab]'),
        note = $('[data-bi-note]');
    if (!vid || !fro) return;
    /* Freestanding never gets a video, whatever the best fit turns out to be.
       Every one of these clips is about cutting an opening and ducting it, which
       is the exact work a shopper standing a fridge in a room is not doing, so
       the slot falls back to Frothy the same way it does on a mixed result set.
       Null rather than a second early return: the branch below already knows how
       to leave this column tidy - it pauses a playing video on the way out - and
       two exits would be two places to remember that. */
    var pick = MODE === 'space' ? { mount:null, via:null, best:null, blanks:0 }
      : biMount(rows);
    var mount = pick.mount, id = BI_VID[mount];
    if (!id){
      /* Paused on the way out, not just hidden. A hidden <video> keeps playing —
         the shopper ticks a filter and is left listening to a video they can no
         longer see. */
      if (!vid.hidden){ vid.pause(); }
      vid.hidden = true; lab.hidden = true; fro.hidden = false;
      /* Guarded like [data-proudn] in render(): this element arrives in the same
         five-paste deploy as the code reading it, and a fresh engine under a
         stale snippet must fall back to no note rather than throw and take the
         whole render with it. */
      if (note){ note.hidden = true; }
      return;
    }
    var src = 'https://cdn.shopify.com/videos/c/o/v/' + id + '.mp4';
    /* Only when it actually changes. Re-assigning the same src reloads the
       element, which would restart a video mid-play on every keystroke. */
    if (vid.getAttribute('src') !== src){
      vid.pause();
      vid.setAttribute('src', src);
      vid.setAttribute('poster', BI_POSTER);
      vid.load();
    }
    var name = BI_LABEL[mount] || 'Building in';
    lab.textContent = name; lab.hidden = false;
    vid.setAttribute('title', name);
    vid.hidden = false; fro.hidden = true;
    if (note){
      var txt = biNote(pick);
      note.textContent = txt; note.hidden = !txt;
    }
  }

  /* Lifted out of drawViz so the video and the drawing name the same fridge.
     Two copies of "largest capacity that fits" would drift the first time either
     was touched, and the failure would be silent and absurd: a diagram of one
     fridge beside instructions for building in a different one.
     Gated on there being ANY measurement, like the drawing's caption. It used to
     demand all three, because a partial cavity fitted nothing by construction and
     an ungated best would have read that empty grid as a verdict. fit() answers
     per axis now, so a width on its own produces a real, honest best fit — the
     largest thing that clears the one figure we hold — and the caption says on
     what basis. Only a wholly empty cavity has no best, and that is c.open. */
  function bestRow(rows){
    var c = cavity();
    if (c.open || !rows.length) return null;
    return rows.slice().sort(function(a,b){ return (b.f.cap||0)-(a.f.cap||0); })[0];
  }

  /* The opening as a sentence, for the SVG's aria-label. Written out per axis
     rather than as "W by D by H" because a partial cavity has a hole in that
     form — "600 by  by 850mm" — and a screen reader gets no chance to see the
     empty fields the sighted reader is looking at. Naming each axis also says
     which one is missing without a second sentence to do it. */
  function ariaDims(c){
    var said = [];
    if (c.w) said.push(c.w + 'mm wide');
    if (c.d) said.push(c.d + 'mm deep');
    if (c.h) said.push(c.h + 'mm high');
    return said.length ? andList(said) : 'no measurements yet';
  }

  function drawViz(rows){
    var c = cavity(), cap = $('[data-viz-cap]');
    /* sized is "the shopper has told us something", not "the shopper has told us
       everything". It used to be the full three, on the reasoning that a cabinet
       cannot be placed against a cavity with no depth — which was true only
       because a blank depth was being read as 0mm. fit() treats a blank axis as
       no constraint now, so one measurement is enough to place a real fridge in
       the drawing, and the axes still blank simply stay drawn at the range's own
       largest opening the way they always have. */
    var sized = !c.open;
    var miss = missingAxes(c);
    var free = MODE === 'space';

    /* The opening is a hole in joinery, and the joinery is the shallow box that
       gives depth somewhere to be labelled — a front elevation can only ever show
       two of the three. Drawing the carcass rather than the bare hole is also
       what stops a solid-door cabinet reading as a free-standing fridge: the
       whole question this page answers is what goes IN something.
       boxW is generous and never reached. The scale is height-bound by the
       2150mm upright, so the widest opening in the range uses about 74 of it;
       the slack is what keeps a narrow cavity centred rather than hard left. */
    var boxW=80, boxH=116, baseY=150, leftPad=30;
    var lim = capDims();
    var scale = Math.min(boxW/lim.w, boxH/lim.h);

    /* An axis with no measurement yet is drawn at the largest opening in the
       range, which is the frame at full size — and that is not a placeholder, it
       is the truth about an empty cavity: everything fits, so the opening being
       asked about is as big as this range ever needs. Each figure typed then
       tightens its own axis, so the drawing narrows toward the real opening one
       measurement at a time instead of appearing from nothing when the third
       lands. The alternative was hiding the drawing until all three arrived,
       which moved the whole toolbar under the shopper mid-keystroke. */
    var vw = c.w || lim.w, vh = c.h || lim.h, vd = c.d || lim.d;
    var w=Math.min(vw, lim.w)*scale, h=Math.min(vh, lim.h)*scale;
    var dOff = Math.max(8, Math.min(Math.min(vd, lim.d)*scale*0.55, 24));
    var x = leftPad + (boxW-w)/2, y = baseY-h;
    var lab = function(tx,ty,t,rot){ return '<text x="'+tx+'" y="'+ty+'" text-anchor="middle" font-size="8.4" '
      + 'fill="currentColor" fill-opacity=".6"'+(rot?' transform="rotate(-90 '+tx+' '+ty+')"':'')+'>'+t+'</text>'; };

    /* The carcass around the opening: a wall each side and a head over the top.
       Solid enough to read as joinery rather than as a border — at .07 the stiles
       were a tint the eye skipped, and with the fridge nearly filling a snug
       cavity there was nothing left to say what it was sitting between. */
    var stile=6.5, head=7.5;
    /* No joinery in freestanding mode, so the carcass collapses to nothing and
       every measurement that was taken from its outside edge is taken from the
       opening's own instead. Zeroed rather than branched around: jx, jy and jw
       are read a dozen times below - for the floor line, the wireframe and all
       three labels - and a second set of expressions for each would be a second
       drawing to keep in step with this one. */
    if (MODE === 'space'){ stile = 0; head = 0; }
    var jx=x-stile, jy=y-head, jw=w+2*stile;
    var ink = function(o){ return 'fill="currentColor" fill-opacity="'+o+'" stroke="currentColor" '
      + 'stroke-opacity=".28" stroke-width=".8"'; };

    var out = '';
    /* Floor first, and wider than the cabinetry, so the whole assembly reads as
       standing on something rather than floating. */
    out += '<line x1="'+(jx-4)+'" y1="'+baseY+'" x2="'+(jx+jw+dOff+4)+'" y2="'+baseY+'" '
      + 'stroke="currentColor" stroke-opacity=".45" stroke-width="1.2"/>';

    if (dOff && MODE === 'space'){
      /* The space as a wireframe volume, with nothing else in the picture but
         the fridge.
         Built-in mode gets its third dimension for free - the benchtop and the
         carcass return ARE the depth - and with those gone the drawing would
         flatten to an elevation that cannot show what the D field is asking
         for, leaving the depth label with no corner to sit against.
         Stroke only, at roughly two thirds the front edge's weight, so it reads
         as the extent of a space rather than as another object standing in one.
         Three corner rays and the back top edge is the whole box: the back
         verticals and the floor behind them are behind the fridge in every case
         that matters, and drawing them only crowds the frame. */
      var wire = 'fill="none" stroke="currentColor" stroke-opacity=".3" stroke-width=".9"';
      out += '<path d="M'+x+' '+y+' l'+dOff+' -'+dOff+' h'+w+' l-'+dOff+' '+dOff+'" '+wire+'/>'
           + '<path d="M'+(x+w)+' '+baseY+' l'+dOff+' -'+dOff+' v-'+h+'" '+wire+'/>';
    }

    if (dOff && MODE !== 'space'){
      /* The right-hand return, floor to benchtop, and the benchtop slab over it.
       *
       * The shear runs up and to the right, so the right side is the one face
       * with depth to show and the left has none to give — the asymmetry is the
       * projection, not an oversight.
       *
       * The return used to stop at the underside of the benchtop, which left the
       * cabinetry reading as a flat frame with a slab hovering over it: all the
       * depth was in the bench and none of it in the thing holding it up. Running
       * it the full height puts the whole carcass in the same box.
       *
       * Benchtop and carcass return from the same x, so the bench does not
       * oversail its wall — side and top meet in one square corner, which is how
       * the joinery is actually built. The slab used to project past the wall by
       * a few units, and at this size that step read as a lip stuck on the front
       * rather than as a benchtop. One face, one edge, no seam to explain.
       *
       * Drawn before the front faces so the front reads as nearer, and shaded by
       * orientation — top lightest, front mid, sides darkest — which is what
       * makes the flat tints read as one solid rather than as separate shapes. */
      out += '<path d="M'+(jx+jw)+' '+jy+' l'+dOff+' -'+dOff+' v'+(head+h)+' l-'+dOff+' '+dOff+' z" '+ink('.17')+'/>'
           + '<path d="M'+jx+' '+jy+' l'+dOff+' -'+dOff+' h'+jw+' l-'+dOff+' '+dOff+' z" '+ink('.06')+'/>';
    }
    // Head and stiles as three rects, not one framing rect: the opening has to
    // stay a hole, and a single rect behind it would tint straight through.
    // Skipped outright in freestanding mode, where stile and head are 0 and all
    // three would render as zero-area rects with a visible stroke on them.
    if (stile) out += '<rect x="'+jx+'" y="'+jy+'" width="'+jw+'" height="'+head+'" '+ink('.11')+'/>'
         + '<rect x="'+jx+'" y="'+y+'" width="'+stile+'" height="'+h+'" '+ink('.11')+'/>'
         + '<rect x="'+(x+w)+'" y="'+y+'" width="'+stile+'" height="'+h+'" '+ink('.11')+'/>';
    out += '<rect x="'+x+'" y="'+y+'" width="'+w+'" height="'+h+'" fill="none" stroke="currentColor" stroke-opacity=".5" stroke-width="1.4"/>';

    /* Gated on sized, not just on rows: with a partial cavity nothing fits by
       construction (a zero depth fails every fridge), so an ungated best would
       read the empty grid as a verdict and caption the drawing "Nothing fits
       this opening" at someone who has typed one number so far. */
    var best = bestRow(rows);
    if (best){
      var vent = ventMode(best.f);
      /* The opening the fridge needs, used to place the cabinet inside it and
         then not drawn at all.
         It carried an amber tint for a while, on the reasoning that the
         ventilation band is the whole point of the picture. It was — and the
         tint was the wrong way to make it, because a band of the same colour as
         the cabinet reads as MORE CABINET. The fridge appeared to run wall to
         wall in exactly the drawings where the clearance mattered most.
         Air is blank. Leaving the band empty is what makes it read as a gap, and
         the gap is the thing being shown. No stroke either: dashes were tried
         before and the eye took them for the important edge, in a drawing that
         already has a wall line and a cabinet line in it.
         Clearance is symmetric on the sides and top-only vertically, so the
         cabinet sits centred left-to-right and on the floor. */
      var fw=best.r.needW*scale, fh=best.r.needH*scale;
      var ox=x+(w-fw)/2;
      /* The air gap, drawn at no less than GAP_MIN however small the figure is.
       *
       * At true scale a 10mm side clearance is half a unit — a hairline — so the
       * cabinet rendered hard against the cavity wall and the picture said the
       * opposite of what the whole page is about. Same clamp in kind as the
       * cavity itself, which stops growing at the largest opening in the range
       * while the typed figure keeps counting: the drawing is the illustration
       * and the card's "Cavity" row is the measurement.
       *
       * Only where a clearance actually exists. A flush integrated unit publishes
       * 0/0/0 because it is built to touch, and inventing a gap around one would
       * be the same lie in the other direction — so zero stays zero. */
      var GAP_MIN = 1.7;
      /* No band at all in freestanding mode, and that follows from fit() rather
       * than being a drawing decision: the space asked for IS the cabinet there,
       * so needW === f.w and there is no distance between the two rects to show.
       * It has to be said explicitly all the same, because GAP_MIN would have
       * opened a gap anyway on a figure that is now zero - and then paid for it
       * out of the cabinet, since bw = fw - 2*gx would draw the fridge NARROWER
       * than the fridge. The clearance is not lost with the band: it is on the
       * card as the Ventilation row and in the blue note under this caption. */
      var gx = (!free && best.f.vs > 0) ? Math.max(best.f.vs*scale, GAP_MIN) : 0;
      var gt = (!free && best.f.vt > 0) ? Math.max(best.f.vt*scale, GAP_MIN) : 0;
      var bw=best.f.w*scale, bh=best.f.h*scale;
      // Never at the cost of the cabinet itself: on a small fridge the widened
      // gap would eat the very thing it is meant to sit beside.
      if (fw - 2*gx < bw*0.55 || fh - gt < bh*0.55){ gx = best.f.vs*scale; gt = best.f.vt*scale; }
      else { bw = fw - 2*gx; bh = fh - gt; }
      var bx=ox+gx, by=baseY-bh;
      /* Always drawn, even when it lands exactly on the opening. A flush-fitting
         integrated unit has no clearance band to sit inside, so it used to be
         skipped and left as the .18 tint alone — which was fine while the tint
         was the whole picture and is not once there are doors and handles on it.
         The two rects coincide; the cabinet is simply the one that shows. */
      out += '<rect x="'+bx+'" y="'+by+'" width="'+bw+'" height="'+bh+'" '
           + 'fill="var(--ff-amber)" fill-opacity=".45" stroke="var(--ff-amber)" stroke-width="1.2"/>';
      out += cabinetFace(best.f, bx, by, bw, bh, vent);

      /* Rear venting draws nothing, and that is the decision rather than a gap.
         The clearance that matters is the 100 to 150mm BEHIND the fridge, and a
         front elevation has nowhere to put it. Two chevrons on the benchtop's
         top face were the attempt: they read as arrows sitting on the bench, not
         as air leaving the cabinet, and pointing up is the one direction the air
         does not go. The figure is on the card and the vent path is in the
         label, which is where a drawing that cannot show a thing should leave it.

         The duct is a hole in the joinery, so it is drawn in the head, not on the
         fridge — which is exactly the distinction a flush install turns on. */
      if (vent === 'flush' && head) out += louvres(x+w*0.25, jy+1.4, w*0.5, head-2.8, '.8');

      /* The model, and nothing else. The clearance figures used to ride here —
         "dashed edge is its air gap, 50mm sides / 50mm top" — which put three
         numbers in a caption that answers one question, and every one of them is
         already on the card as "Cavity". A line naming the vent path went
         the same way for the same reason: the grille and the duct say it in the
         drawing, which is where a caption beside a drawing should leave it. It survives on the label below, so a screen reader is told what
         the picture shows rather than being the one reader left without it. */
      /* The model, its cabinet size, and — on the flush range only — what that
         size is for. The clearance figures still do not ride here: "50mm sides /
         50mm top" answers a question the drawing has already answered in the
         band around the cabinet, and the card's Cavity row carries the number.
         The cabinet's own W x D x H is the opposite case — nothing on screen
         states it, and it is what a tape measure reads. */
      /* One row per axis, each carrying its own letter — see .ff-viz-ax. The
         run-on "W x D x H" line went with the run-on figure: every number names
         its own axis now, which is the whole of what that line did. */
      var axRow = function(letter, mm){
        return '<span class="ff-viz-ax"><i>' + letter + '</i>' + mm + '</span>';
      };
      cap.innerHTML = '<span class="ff-viz-lab">Best Fitting</span><b>'
        + htmlEsc(best.f.model||best.f.title) + '</b>'
        + '<span class="ff-viz-dim"><em>Fridge Measurements</em>'
        + axRow('W', best.f.w) + axRow('D', best.f.d) + axRow('H', best.f.h)
        + '</span>'
        /* The part-measured warning, in the slot the flush note uses and for the
           same reason: it is a caveat on what the figures above it MEAN. Here
           they are a fridge chosen against one or two of the shopper's three
           numbers, and the honest thing is to name which — a shopper who typed a
           width and got a best fit has been answered, but has not been told the
           depth was never checked. "Check ... before you buy" rather than "enter
           the rest": they may well not be able to measure the rest yet, which is
           why they are here with one figure, and the tool has no business
           refusing them until they can.
           It comes BEFORE the flush note when both show, because it qualifies the
           whole result where the flush note qualifies one range. */
        /* Named by what is MISSING, not by what was checked, and the column is
           the reason rather than the wording: at 145px this note gets about 21
           characters to the line, so "Checked against your width and depth only
           — be sure to check the height before you buy" ran to four lines and
           pushed the caption past the drawing beside it. The missing axes are the
           shorter half of the same sentence and the actionable half — "measure
           the height" is a job, "width and depth were checked" is a receipt. */
        + (miss.length
          ? '<span class="ff-viz-note is-warn">'
            + andList(miss).replace(/^./, function(ch){ return ch.toUpperCase(); })
            + ' not checked — be sure to measure before you buy.</span>'
          : '')
        /* Keyed on the vent mode, not on f.fullyIntegrated, and the two are not
           the same set. fullyIntegrated means "takes a cabinet door on its front
           with no sliding hinge kit", which is eight fridges; seven of those
           publish no clearances at all and are built to fill the opening, and the
           eighth is the Blastcool iXP, an outdoor unit that still wants 5/5/50 of
           air and therefore DOES sit inside a cavity with a gap round it. Telling
           an iXP shopper their opening must be cut to the cabinet would be wrong,
           and wrong in the expensive direction. vent === 'flush' is exactly the
           seven this is true of — the same test that drew the duct in the
           joinery a few lines up, which is the thing the note is describing. */
        /* The air gap, in the slot the band used to occupy in the picture. It
           only shows in freestanding mode, and only where there is a clearance
           to state: the flush range publishes 0/0/0 and is built to touch, so a
           note telling that shopper to leave air would contradict the one below
           it. Last of the three, after the part-measured caveat, because it is
           the narrowest claim of the three - it is about this fridge, where the
           caveat above is about the whole result. */
        + (free && vent !== 'flush' && (best.f.vs || best.f.vt || best.f.vr)
          ? '<span class="ff-viz-note is-vent">Leave air on top of this: '
            + ventGap(best.f) + '.</span>'
          : '')
        + (vent === 'flush'
          ? '<span class="ff-viz-note">Note: this unit/combo is fully integrated.</span>'
          : '');
      svg.setAttribute('aria-label', 'Your '+W().subject+' at '+ariaDims(c)
        + ', drawn ' + (MODE === 'space' ? 'to scale' : 'in cabinetry')
        + ' with the best fitting fridge: '
        + (best.f.model||best.f.title) + ', ' + VENT_NOTE[vent].toLowerCase() + '.'
        + (miss.length ? ' Checked against your ' + andList(givenAxes(c))
          + ' only; the ' + andList(miss) + ' has not been checked.' : ''));
    } else if (sized){
      /* Still reachable on a partial cavity: one measurement can be too small on
         its own — a 400mm width clears nothing we stock — and that is a real
         verdict rather than the arithmetic artefact the old all-three gate was
         guarding against. */
      cap.textContent = 'Nothing fits this ' + W().opening;
      svg.setAttribute('aria-label', 'Your '+W().subject+' at '+ariaDims(c)
        + ', drawn ' + (MODE === 'space' ? 'to scale' : 'in cabinetry')
        + '. Nothing in the range fits it.');
    } else {
      /* Nothing measured at all, so the drawing is the range's own largest
         opening and there is no fridge in it to name. This is the ONLY branch
         left here — "Enter all three measurements" used to sit on the else, and
         there is no longer a state it describes. */
      cap.textContent = 'Pop your ' + W().subject + ' in to see the fit';
      svg.setAttribute('aria-label', 'An empty ' + W().subject
        + (MODE === 'space' ? '' : ' drawn in cabinetry') + ' at the '
        + 'largest opening this range needs, ' + lim.w + ' by ' + lim.d + ' by '
        + lim.h + 'mm. It resizes as you enter your own measurements.');
    }

    /* "any", not the cap figure it is actually drawn at: the drawing is showing
       the largest opening the range needs, but what the shopper has told us about
       that axis is nothing at all, and printing 1370 beside a box they never
       measured would read as a cavity we had decided for them. */
    out += lab(x+w/2, baseY+12, (c.w || 'any')+' W');
    out += lab(x-stile-6, y+h/2, (c.h || 'any')+' H', true);
    /* Set off the corner rather than against it: the benchtop's top face ends at
       jx+jw+dOff, and a tight offset put the left edge of a centred
       five-character label exactly on that corner. The drawing is height-bound,
       so the widest cavity still leaves room on the right for this.
       Floored, because the label rides the top face and the top face rises with
       both height and depth: a 2150mm cavity with a deep bench put the baseline
       at 5.5, which clipped the caps off against the top of the viewBox. The
       label is clear of the drawing horizontally, so dropping it a few units is
       free — it stays beside the corner it names either way. */
    if (dOff) out += lab(jx+jw+dOff+18, Math.max(10, jy-dOff+3), (c.d || 'any')+' D');
    svg.innerHTML = out;
  }

  /* Fridges that are not in the range because a pool or only toggle is off, and
     that would fit the cavity under the shopper's current filters. Everything the
     alert says about "our fridges" is otherwise scoped to the open pools, and
     several of those sentences are flatly wrong while 201 branded designs sit
     out of view. Counted through results() so the promised number is the number
     that appears. */
  function closedPools(sel){
    var out = [];
    GROUPS.forEach(function(g){
      g.options.forEach(function(o){
        if (!(o.pool || o.only) || sel[g.id+':'+o.id]) return;
        var probe = {}; Object.keys(sel).forEach(function(k){ if (sel[k]) probe[k] = true; });
        probe[g.id+':'+o.id] = true;
        /* A pool ADDS to what is on screen, so the promise is the difference. An
           only option REPLACES it, so the promise is the whole of what it shows —
           subtracting here would under-count it, and go negative whenever the
           plain range is the bigger of the two. */
        var n = o.only ? results(probe).length
          : results(probe).length - results(sel).length;
        if (n > 0) out.push({ group:g.id, label:o.label, n:n, only:!!o.only });
      });
    });
    return out;
  }

  /* Why nothing is showing, in the shopper's terms — named against the smallest
     fridge actually stocked rather than an abstract minimum. */
  /* An offer the shopper can take, not just read. The alert is rewritten on every
     render, so nothing is bound here — wire() listens on the box and reads
     data-clear off whatever was clicked. */
  function fixButtons(list){
    return '<div class="ff-fixes">' + list.map(function(c){
      return '<button type="button" class="ff-fix" data-clear="' + htmlEsc(c.id) + '">'
        + 'Clear ' + htmlEsc(c.label)
        + '<span>' + c.n + (c.n === 1 ? ' fits' : ' fit') + '</span></button>';
    }).join('') + '</div>';
  }

  /* Same shape as fixButtons(): a button the shopper can press inside a box that
     is rewritten on every render, read back by the delegated handler in wire().
     data-overhang carries the millimetres rather than a boolean, so the same
     button turns the allowance off by carrying 0. */
  function overhangBtn(mm, label, count, unit){
    return '<div class="ff-fixes"><button type="button" class="ff-fix" data-overhang="' + mm + '">'
      + label + '<span>' + count + ' ' + unit + '</span></button></div>';
  }

  /* What ticking the allowance would put on screen that is not there now.
     Asked by running the real grid twice rather than by comparing depths: the
     shopper's filters, the open pools and the width and height limits all still
     apply to the second run, so the number promised is the number that appears
     — the same rule closedPools() follows, and for the same reason. */
  /* Gated on DEPTH alone, not on all three. The allowance is a depth allowance —
     it is the front of the cabinet standing out of the opening — so a cavity
     with a depth in it can be asked the question whether or not the other two
     were given. It used to demand all three only because fit() could not answer
     anything else. */
  /* Freestanding is a hard zero, and this is the single gate for it: every
     overhang offer on screen is drawn from this number, so returning 0 here
     takes all of them off at once. fit() stays mode-blind - it is handed an
     allowance of 0 in that mode because applyMode() clears ALLOW on the way in,
     not because the arithmetic learned about the switch. */
  function overhangGain(sel){
    var c = cavity();
    if (MODE === 'space' || ALLOW || !c.d) return 0;
    return results(sel, OVERHANG.max).length - results(sel, 0).length;
  }

  /* "ventilation and all" is a claim about the ARITHMETIC, and since fit() stopped
     folding the clearances into the freestanding requirement it is only true on
     one side of the switch. The claim comes out rather than being restated: these
     boxes are transient and the standing places - the hint, the Ventilation row,
     the note under the drawing - are where the shopper is told where the air gap
     went. A fourth voice saying it in a box that disappears on the next keystroke
     would be noise. */
  function ventAll(){ return MODE === 'space' ? '' : ', ventilation and all'; }
  function ventInc(){ return MODE === 'space' ? '' : ', ventilation included'; }

  function updateAlert(rows, sel){
    var box = $('[data-alert]'), c = cavity(), p = pool(sel);
    /* No cavity at all is now where the finder STARTS, so it gets the neutral box
       rather than the alarming one: the grid under it is the whole range and
       there is nothing to correct. It also has to name the way back — someone who
       has typed an opening and wants the full range again needs telling that
       emptying those boxes, or putting 0 in them, is what does it. */
    if (c.open){
      box.hidden = false;
      box.className = 'ff-alert is-info';
      /* The count, not "every fridge we stock" — branded designs are held out of
         the pool by default, so the honest headline is the size of what is
         actually on screen, and it only claims the whole catalogue when the pool
         IS the whole catalogue. Same test the "It all fits" box below makes. */
      /* Two bodies under one headline, CSS picks (BFA, 2026-09-22). The long
         one ran four lines on a 390px phone directly above the grid it was
         describing. The short one keeps all three things the long one says -
         that filtering is the other way in, that the arithmetic has the air
         gap in it, and how to get the whole range back - and drops the words
         between them. The COUNT is not shortened: it is the one figure in the
         box and the reason the box opens with a number.

         Spans rather than a matchMedia branch, for the reason the rest of this
         page gives for the same choice: this box is rewritten on every
         keystroke, and a JS read of the viewport would have to be right on
         rotation and on a desktop resize too. CSS is already right. */
      box.innerHTML = '<b>Showing all ' + p.length + ' fridges'
        + (p.length === FRIDGES.length ? ' we stock' : '')
        + '</b><span class="ff-alert-long">'
        + 'Filter above for the sort you\u2019re after, then pop your '
        + W().subject + ' in '
        + 'and we\u2019ll work out what actually goes in it' + ventAll() + '. '
        + 'Leave those boxes empty, or put 0 in them, to see the lot again.'
        + '</span><span class="ff-alert-short">'
        + 'Filter above, or pop your ' + W().subject + ' in and we\u2019ll work '
        + 'out what fits' + ventAll() + '. Empty, or 0, shows the lot.'
        + '</span>';
      return;
    }
    /* "Enter all three measurements" used to stop the tool dead here, in the red
       alert, on any cavity with a blank in it. It is gone rather than softened:
       the grid behind it is a real answer now — fit() constrains per axis — so an
       alert is the wrong instrument for saying the answer is partial. That is a
       caveat on the result, and it lives on the result, in the caption under the
       drawing. See the is-warn note in drawViz().
       What DOES still belong to this box is the offer, and it is made below in
       the "it all fits" branch: if everything clears the one figure given, the
       useful next thing to say is which figures would narrow it. */
    var miss = missingAxes(c);
    var more = closedPools(sel);
    var proudNow = rows.filter(function(x){ return x.r.proud; }).length;

    /* The allowance is on and something on screen is standing proud, so this box
       stops being an alert and becomes a label for the grid underneath it. It
       outranks every message below including "it all fits", which would be a
       plain lie here: these do not all fit, they have been let in.
       It has to persist. A shopper who ticked this three scrolls ago and is now
       looking at a 600mm fridge against their 580mm cavity needs the reason in
       front of them, not in their memory — and the way back out is the same
       button that let them in, carrying 0. */
    if (rows.length && ALLOW && proudNow){
      box.hidden = false;
      box.className = 'ff-alert is-info';
      box.innerHTML = '<b>Including fridges that stand up to ' + ALLOW + 'mm out of the '
        + W().opening + '</b>'
        + proudNote() + ' Each card says how far that one sticks out.'
        + overhangBtn(0, 'Exact fits only', rows.length - proudNow,
          (rows.length - proudNow) === 1 ? 'fits' : 'fit');
      return;
    }
    /* When the opening clears the whole range, say so — it is the one result
       that needs no caveats, and a shopper reading "142 of 142" deserves to know
       the measuring part is over.
       "The whole range" has to mean what the shopper is looking at. With branded
       designs held back, "every fridge we stock" is a claim about 179 of 384,
       so the sentence names the ones still to come rather than overstating. */
    if (rows.length && rows.length === p.length){
      box.hidden = false;
      box.className = 'ff-alert is-good';
      /* On a part-measured cavity this is still true and still worth saying, but
         it is true of LESS than it sounds: everything clears the width, which is
         not the same claim as everything going in the opening. So the headline
         names the axes it was actually tested on and the body asks for the rest
         — an offer, not the blocking demand this box used to make. Wording is
         the caption's, deliberately: a shopper reading both should meet one
         sentence twice, not two rules to reconcile. */
      box.innerHTML = (miss.length
          ? '<b>Everything clears your ' + andList(givenAxes(c)) + '</b>Every fridge '
            + (p.length === FRIDGES.length ? 'we stock' : 'shown here')
            + ' fits that much of the ' + W().opening + ventAll() + '. '
            + 'Pop the ' + andList(miss) + ' in and we’ll narrow it down '
            + '— and be sure to check ' + (miss.length === 1 ? 'it' : 'them')
            + ' before you buy.'
          : '<b>Beauty - It all fits!</b>Every fridge '
            + (p.length === FRIDGES.length ? 'we stock' : 'shown here')
            + ' will go in that ' + W().opening + ventAll() + '. Pick whatever takes your fancy.')
        /* An only option shows its fridges INSTEAD of these, so it can't be
           offered as "another N fit" — that reads as a bigger grid. */
        + (more.length ? (more[0].only
          ? ' ' + more[0].n + ' ' + htmlEsc(more[0].label.toLowerCase()) + ' fit too \u2014 tick '
            + htmlEsc(more[0].label) + ' under ' + LABELS[more[0].group] + ' to see those instead.'
          : ' Another ' + more[0].n + ' fit under ' + LABELS[more[0].group]
            + ' \u2192 ' + htmlEsc(more[0].label) + '.') : '');
      return;
    }
    box.className = 'ff-alert';

    /* Nothing is wrong here — the grid has results — which is exactly why this
       box used to go straight to hidden. But it is also the case the depth
       allowance was built for and the one it would never have been seen in: at
       a 560mm cavity 52 fridges fit and another 75 are held out by 20mm or
       less, and a shopper with 52 cards in front of them has no reason to
       suspect it. Offered here, in the warm tone rather than the alarming one,
       because more choice is not a problem report. */
    if (rows.length){
      var gain = overhangGain(sel);
      if (gain > 0){
        box.hidden = false;
        box.className = 'ff-alert is-info';
        box.innerHTML = '<b>' + gain + ' more would fit if you can allow a little overhang</b>'
          + proudNote()
          + overhangBtn(OVERHANG.max, 'Allow up to ' + OVERHANG.max + 'mm overhang',
            gain, gain === 1 ? 'more fits' : 'more fit');
        return;
      }
      box.hidden = true; return;
    }

    /* Nothing on screen fits — but a closed pool may be full of fridges that do,
       and "no fridge fits a cavity this small" while 30 branded designs would go
       straight in is the one wrong answer this box must never give. Checked
       before the cavity is blamed, because if any of them fit then the cavity is
       not the problem. */
    if (more.length){
      box.hidden = false;
      box.innerHTML = '<b>Nothing here fits, but ' + more[0].n + ' '
        + htmlEsc(more[0].label.toLowerCase()) + ' would</b>Tick '
        + htmlEsc(more[0].label) + ' under ' + LABELS[more[0].group] + ' to '
        + (more[0].only ? 'switch the grid to ' : 'see ')
        + (more[0].n === 1 ? 'it' : 'them') + '.';
      return;
    }

    /* Does anything in the pool fit, filters aside? That single question is what
       separates the two failures this box has to tell apart, and it has to be
       asked by running the fit test rather than by comparing against "the
       smallest fridge".
       Smallest used to mean least volume, and the fridge with the least volume is
       not the one that clears a given opening — a tall narrow cabinet beats a
       short wide one in a narrow cavity. Blaming the cavity on that comparison
       told a shopper their wall was too small when their filters were the whole
       problem. */
    var fitsCavity = p.filter(function(f){ return fit(f, c).fits; });

    if (!fitsCavity.length){
      /* Before the cavity is blamed. "No fridge fits a 560mm depth" is true only
         of an exact fit, and saying it while 75 fridges would go in standing
         20mm proud sends a shopper away from a wall that would have taken any
         of them. Same precedence as the closed-pool check above, for the same
         reason: if something would fit, the cavity is not the problem. */
      var gainD = overhangGain(sel);
      if (gainD > 0){
        box.hidden = false;
        box.className = 'ff-alert is-info';
        box.innerHTML = '<b>Nothing fits a ' + c.d + 'mm depth exactly</b>'
          + gainD + (gainD === 1 ? ' fridge would' : ' fridges would') + ' go in standing '
          + OVERHANG.max + 'mm proud or less. ' + proudNote()
          + overhangBtn(OVERHANG.max, 'Allow up to ' + OVERHANG.max + 'mm overhang',
            gainD, gainD === 1 ? 'fits' : 'fit');
        return;
      }
      /* Per measurement, not per fridge: "the shallowest we stock needs 600mm" is
         a fact the shopper can act on — measure again, or ring us — whereas the
         dimensions of one particular cabinet are trivia. Each minimum may belong
         to a different fridge, which is exactly why they are worked out
         separately. */
      /* Freestanding drops the clearances here for the same reason fit() does,
         and it has to be the same reason in the same direction: this box quotes
         the smallest thing we stock straight back at a shopper whose figure just
         failed, so a minimum worked out on a different rule from the one that
         failed them would name a number the grid does not agree with. */
      var free = MODE === 'space';
      var minW = null, minD = null, minH = null;
      p.forEach(function(f){
        var w = free ? f.w : f.w+2*f.vs,
            d = free ? f.d : f.d+f.vr,
            h = free ? f.h : f.h+f.vt;
        if (minW === null || w < minW) minW = w;
        if (minD === null || d < minD) minD = d;
        if (minH === null || h < minH) minH = h;
      });
      if (minW === null){ box.hidden = true; return; }
      /* got > 0 before got < need, and the order of those two tests is the whole
         guard. A blank axis is 0, and 0 is under every minimum in the range, so
         without it a shopper who typed a width alone would be told their DEPTH
         and HEIGHT fall short of figures they never entered — the tool inventing
         a 0mm cavity and then complaining about it. Only a measurement we were
         actually given can be too small. */
      var tooSmall = [
        { got:c.w, need:minW, name:'width',  sup:'narrowest'  },
        { got:c.d, need:minD, name:'depth',  sup:'shallowest' },
        { got:c.h, need:minH, name:'height', sup:'shortest'   },
      ].filter(function(d){ return d.got && d.got < d.need; });

      box.hidden = false;
      if (tooSmall.length === 1){
        var t = tooSmall[0];
        box.innerHTML = '<b>No fridge fits a ' + t.got + 'mm ' + t.name + '</b>The '
          + t.sup + ' we stock needs ' + t.need + 'mm' + ventInc() + '. '
          + 'Worth measuring again — or give us a call on 1300 376 849 and we will '
          + 'size it up with you.';
      } else if (tooSmall.length){
        box.innerHTML = '<b>No fridge fits ' + W().an + ' this small</b>The smallest we stock needs '
          + tooSmall.map(function(d){ return d.need + 'mm of ' + d.name; }).join(' and ')
          + ventInc() + ', and your ' + tooSmall.map(function(d){ return d.name; }).join(' and ')
          + ' falls short. Worth measuring again — or give us a call on 1300 376 849.';
      } else {
        /* Every measurement clears something, but no ONE fridge clears them all
           — a long shallow opening that only deep fridges are wide enough for.
           "all three" only when there ARE three: on a part-measured cavity this
           is two measurements that cannot be met together, and saying three
           would point the shopper at a figure they never typed. */
        var nGiven = givenAxes(c).length;
        box.innerHTML = '<b>Nothing fits this ' + W().opening + '</b>Each measurement on its own clears '
          + 'something we stock, but no single fridge fits '
          + (nGiven > 2 ? 'all three' : 'both') + ' at once. Give us a call '
          + 'on 1300 376 849 and we will find the closest thing.';
      }
      return;
    }

    /* The cavity is fine, so a filter is doing the excluding. Work out which one
       by dropping each group in turn — naming the culprit beats "try clearing a
       filter" when eight dropdowns are in play. */
    /* Display and pool toggles are excluded: they add cards and fridges, never
       remove either, so naming one as "the blocker" would send the shopper to
       untick a control that cannot be the cause. A pool option that is ON has
       only widened the range; one that is OFF was already offered above, by
       closedPools(). An only option that is ON genuinely can be the blocker — it
       is holding the plain range out — so it counts, and dropping the group in
       the probe below reopens the pool exactly as unticking it would. */
    var chosenGroups = GROUPS.filter(function(g){
      return g.options.some(function(o){ return (o.test || o.only) && sel[g.id+':'+o.id]; });
    });
    var culprits = [];
    chosenGroups.forEach(function(g){
      var without = {};
      Object.keys(sel).forEach(function(k){
        if (sel[k] && k.slice(0, k.indexOf(':')) !== g.id) without[k] = true;
      });
      var n = results(without).length;
      if (n > 0) culprits.push({ id: g.id, label: LABELS[g.id], n: n });
    });

    box.hidden = false;
    /* Ordered by what each one hands back, and capped at two. A third option
       turns a fix into a decision at exactly the moment the shopper is already
       stuck, and the two best are the two worth having.
       The "no filters chosen" case that used to sit here is unreachable now:
       with nothing ticked, passes() lets everything through, so the grid holds
       whatever clears the cavity — and we only got this far because something
       does. That case is the cavity branch above. */
    culprits.sort(function(a,b){ return b.n-a.n; });
    culprits = culprits.slice(0, 2);

    if (culprits.length === 1){
      box.innerHTML = '<b>Your ' + htmlEsc(culprits[0].label) + ' filter is the blocker</b>'
        + 'Clear it and ' + culprits[0].n + ' '
        + (culprits[0].n === 1 ? 'fridge fits' : 'fridges fit') + ' this ' + W().subject + '.'
        + fixButtons(culprits);
    } else if (culprits.length){
      box.innerHTML = '<b>Nothing matches all your filters</b>'
        + 'Clearing either of these opens it back up:' + fixButtons(culprits);
    } else {
      /* Genuinely the combination, and we can say so without hedging: a fridge
         fits the cavity, and no single group is holding it back. */
      box.innerHTML = '<b>Nothing matches all your filters</b>No single filter is the culprit — '
        + 'the combination rules everything out. Try clearing them all and adding one at a time.';
    }
  }

  /* Everything the install switch changes that render() does not already redo.
     Which is almost nothing: the grid, the drawing, the alert, the legend and
     the video slot all read MODE themselves, so the only things left here are
     the two pieces of static markup above the fields - the label and the hint -
     and the pressed state on the buttons.
     THE MEASUREMENTS ARE NOT TOUCHED. They are the same three numbers in either
     mode, and clearing them on a toggle would punish a shopper for looking at
     the other half of the tool. Filters and sort survive for the same reason:
     neither means anything different on the other side of the switch.
     THE OVERHANG ALLOWANCE IS THE ONE EXCEPTION, and it is cleared rather than
     carried because it DOES mean something different - it means nothing at all.
     Standing proud is a fridge finishing forward of the opening it sits in, and
     freestanding has no opening: the shopper gave us the space they are willing
     to hand over, so a cabinet that exceeds it is over the figure they set, not
     proud of a cavity face. overhangGain() refuses to offer it there; this line
     is the other half, for the shopper who ticked the allowance in cavity mode
     and then flicks across with 20mm still banked. Without it their grid would
     keep letting oversized cabinets through under a heading no box on screen is
     willing to print any more. */
  function applyMode(m){
    if (setMode(m)) render();
  }
  /* The switch without the render, for restoreSearch(): it runs in boot() before
     wire(), and boot() renders once itself straight afterwards. */
  function setMode(m){
    if (m !== 'cavity' && m !== 'space') return false;
    MODE = m;
    if (MODE === 'space') ALLOW = 0;
    $$('[data-mode]').forEach(function(b){
      var on = b.getAttribute('data-mode') === m;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', String(on));
    });
    var lab = $('[data-cav-lab]'), hint = $('[data-hint]');
    /* Guarded, like [data-proudn] in render() and for the same reason: these
       attributes arrive in the SAME deploy round as the code reading them, and
       the deploy is five manual pastes. A stale snippet under a fresh engine
       should lose the label rewrite, not the whole finder. */
    if (lab) lab.textContent = W().label;
    /* innerHTML, because the freestanding hint carries a .ff-vent-hi span around
       the clause about the air gap - see WORDS. Both strings are literals in this
       file and neither takes a shopper value, so there is nothing here for a
       shopper to inject into; the day one of them interpolates anything, it
       escapes it first. */
    /* The compare page has no cards; each fridge's clearances are its
       Ventilation rows there. */
    if (hint) hint.innerHTML = CPAGE
      ? W().hint.replace('every card lists its own', 'each fridge\u2019s is in the Ventilation rows below')
      : W().hint;
    return true;
  }

  /* The grid is drawn in batches, not all at once (issue #2, 2026-10-05).
     Every card on every render was ~200 cards and ~13,000 elements: a ~370ms
     long task per keystroke at phone speed, and up to 1.6s with the session
     recorders that watch every DOM change. The HTML for every card is still
     built - it is string work and cheap - but only GRID_STEP cards are put in
     the page, and the next batch goes in as a marker below the last one comes
     within GRID_AHEAD of the screen. Counts, filters, sort and the drawing all
     read the rows, never the DOM, so none of them can tell.
     Without IntersectionObserver the whole grid is drawn, as before. */
  var GRID_STEP = 24, GRID_AHEAD = '1500px';
  var GRID_CARDS = [], GRID_SHOWN = 0, GRID_OBS = null;
  function fillGrid(cards){
    GRID_CARDS = cards; GRID_SHOWN = 0;
    if (GRID_OBS) GRID_OBS.disconnect();
    grid.innerHTML = '';
    gridMore(typeof IntersectionObserver === 'undefined' ? cards.length : GRID_STEP);
  }
  function gridMore(n){
    var old = grid.querySelector('[data-grid-more]');
    if (old) old.parentNode.removeChild(old);
    var next = GRID_CARDS.slice(GRID_SHOWN, GRID_SHOWN + n);
    if (!next.length) return;
    GRID_SHOWN += next.length;
    var more = GRID_SHOWN < GRID_CARDS.length
      ? '<div class="ff-more" data-grid-more aria-hidden="true"></div>' : '';
    grid.insertAdjacentHTML('beforeend', next.join('') + more);
    if (GRID_SHOWN === next.length) return; // first batch: render() finishes the wiring
    /* A later batch: the new cards need what render() gave the first ones -
       their Compare ticks and their place in the ratings queue. */
    syncCompare();
    observeRatings();
    watchMore();
  }
  function watchMore(){
    var m = grid.querySelector('[data-grid-more]');
    if (!m || typeof IntersectionObserver === 'undefined') return;
    if (!GRID_OBS) GRID_OBS = new IntersectionObserver(function(es){
      es.forEach(function(e){ if (e.isIntersecting) gridMore(GRID_STEP); });
    }, { rootMargin: '0px 0px ' + GRID_AHEAD + ' 0px' });
    GRID_OBS.disconnect();
    GRID_OBS.observe(m);
  }

  function render(){
    /* The compare page has no grid to draw: a render there - the live refresh,
       most often - is the table redrawn on the records it just got. */
    if (CPAGE){ syncCompare(); return; }
    /* Any render satisfies a pending one. Typing then immediately ticking a
       filter would otherwise run the grid twice: once for the tick, once more
       when the keystroke's timer came due on data that had not changed since. */
    clearTimeout(RENDER_T); RENDER_T = 0;
    updateEchoes();
    /* Before sortRows(), which reads the select this may have just rewritten. */
    autoSort();
    var rows = sortRows(results(active));
    if (rows.length) fillGrid(withAccessories(rows));
    else {
      fillGrid([]);
      grid.innerHTML = '<div class="ff-empty"><strong>No fridges to show</strong>See the note above for why.</div>';
    }

    // Fridges only. A shelf does not fit a cavity, so counting it would answer
    // a question the shopper did not ask.
    $('[data-n]').textContent = rows.length;
    $('[data-total]').textContent = pool(active).length;
    /* "215 of 384 fit — 88 of those sit proud". Second half of one sentence, so
       the headline number stays the number of cards below it and the overhang
       qualifies it rather than competing with it. */
    var proudN = rows.filter(function(x){ return x.r.proud; }).length;
    /* Guarded, unlike its neighbours. Every other element render() writes to
       has been in the snippet for rounds; this one arrives in the SAME round
       as the code that writes it, and the deploy is five manual pastes. A
       stale snippet under a fresh engine would put null here, and the
       TypeError would take the whole render down with it — a blank grid, not
       a missing figure. The count is worth less than the finder. */
    var pEl = $('[data-proudn]');
    if (pEl){
      pEl.hidden = !proudN;
      pEl.textContent = proudN ? ' \u2014 ' + proudN + ' of those sit proud' : '';
    }
    /* The mobile drawer's own footer button — same figure as the main count
       above, on a second element because it lives at the bottom of a
       full-screen panel rather than in the results bar. */
    $('[data-n2]').textContent = rows.length;
    var air = rows.filter(function(x){ return x.f.ventSource==='airflow'; }).length;
    $('[data-legend]').textContent = air
      ? air+' fully integrated, sized flush'
      /* The proud tier displaces the spare-room legend rather than joining it:
         the two thresholds describe clearance, which is the one thing a proud
         fridge has none of, and running all three together reads as a scale
         with the overhang at the bottom of it. It is not on that scale. */
      : proudN ? FIT.proud+' = front stands out of the '+W().opening+', rear vent gap kept'
      /* Both tiers are amounts of spare room, so there is nothing for them to
         name until there is an opening to be spare of. */
      : (rows.length && !cavity().open
          ? FIT.roomy+' = '+FIT.threshold+'mm or more spare \u00b7 '+FIT.tight+' = under '+FIT.threshold+'mm'
          : '');

    GROUPS.forEach(function(g){
      /* An option's count is how many fridges match THAT option, given the
         other groups' filters — the group's own selections are excluded from
         the probe. Leaving them in unions them (options within a group are OR'd),
         so ticking Lockable made every sibling option report the Lockable total.
         A pool or only selection in the same group is NOT an OR'd sibling: it
         says which fridges exist. Dropping it would count Dual Zone against the
         plain range while the shopper is looking at branded designs. */
      var base = {};
      Object.keys(active).forEach(function(k){
        if (!active[k]) return;
        if (k.slice(0, k.indexOf(':')) !== g.id) { base[k] = true; return; }
        var own = g.options.filter(function(o){ return g.id+':'+o.id === k; })[0];
        if (own && (own.pool || own.only)) base[k] = true;
      });
      var chosen = 0;
      g.options.forEach(function(o){
        if (active[g.id+':'+o.id]) chosen++;
        var el = $('[data-count="'+g.id+':'+o.id+'"]');
        if (!el) return;
        /* Both kinds count what the tick actually puts on screen, computed by
           running results() rather than by a filter written out again here, so
           the number cannot disagree with what ticking produces.
             pool  what it would ADD. The pool is closed, so results() with the
                   option on counts the plain fridges too and the number would
                   read as a promise of 380 of them; the difference is the ones
                   it admits.
             only  what would be on screen afterwards, full stop — it replaces
                   the grid rather than adding to it, so there is nothing to
                   subtract. */
        if (o.pool || o.only){
          var withOn = {}; Object.keys(base).forEach(function(k){ withOn[k] = base[k]; });
          withOn[g.id+':'+o.id] = true;
          var n2 = o.only ? results(withOn).length
            : results(withOn).length - results(base).length;
          el.textContent = n2;
          el.closest('.ff-opt').classList.toggle('is-off', n2===0 && !active[g.id+':'+o.id]);
          return;
        }
        /* A display toggle narrows nothing, so the fridge probe would report the
           whole unfiltered range — 241 beside "Shelves" reads as a promise of
           241 shelves. It gets the count of accessories of its own kind that
           suit a fridge currently on screen, which is what the tick will
           actually add, counted per product rather than per card: one shelf
           fitting three families is one product, shown three times. */
        if (o.display){
          var kind = o.id === 'kits' ? 'kit' : 'shelf';
          var suits = {};
          rows.forEach(function(x){ if (x.f.sku) suits[x.f.sku] = true; });
          var na = ALL_ACCESSORIES.filter(function(a){
            return a.kind === kind && a.skus.some(function(s){ return suits[s]; });
          }).length;
          el.textContent = na;
          el.closest('.ff-opt').classList.toggle('is-off', na===0 && !active[g.id+':'+o.id]);
          return;
        }
        var probe = {}; Object.keys(base).forEach(function(k){ probe[k] = base[k]; });
        probe[g.id+':'+o.id] = true;
        var n = results(probe).length;
        el.textContent = n;
        el.closest('.ff-opt').classList.toggle('is-off', n===0 && !active[g.id+':'+o.id]);
      });
      var badge = $('[data-sel="'+g.id+'"]');
      if (badge){ badge.textContent = chosen; badge.hidden = chosen === 0; }
    });
    var activeCount = Object.keys(active).filter(function(k){ return active[k]; }).length;
    $('.ff-clear').hidden = !activeCount;
    /* The mobile drawer trigger's own badge — same idea as each group's
       [data-sel] count above, just summed across every group rather than
       one. */
    var totalBadge = $('[data-sel="total"]');
    if (totalBadge){ totalBadge.textContent = activeCount; totalBadge.hidden = !activeCount; }
    drawViz(rows);
    drawBuildingIn(rows);
    updateAlert(rows, active);
    /* The tickboxes (the list may have changed on another page since) and
       the saved search. */
    syncCompare();
    saveSearch();
    observeRatings();
    watchMore();
    /* Bound once, to the grid rather than to the cards: render() has just
       replaced every card, and a handler on one would have gone with it. */
    popBind();
  }

  /* Typing a measurement is the only input that fires per KEYSTROKE, and render()
     rebuilds every card in the grid from scratch. "1370" therefore paid for four
     full rebuilds to reach one answer, three of them for widths the shopper was
     never asking about — 137mm fits nothing, so the grid emptied and refilled
     under their hands as they typed.

     RENDER_MS is a pause, not a rate limit: the timer restarts on each keystroke,
     so a burst of typing renders once when it stops. 160ms clears the gap between
     keystrokes for a fast typist while still landing before a finger leaves the
     keypad — long enough to swallow the burst, short enough that the count never
     feels stuck.

     The echo beside each field is deliberately NOT on this timer. It reads back
     what was typed ("60cm" = 600mm), so it has to keep up with the typing to be
     the confirmation it is meant to be; it costs one text node per field, which
     is not what was slow. */
  var RENDER_T = 0, RENDER_MS = 160;
  function renderSoon(){
    updateEchoes();
    clearTimeout(RENDER_T);
    RENDER_T = setTimeout(render, RENDER_MS);
  }

  /* Flexbox can say "grow to fill the line" but not "grow only if I am not the
     FIRST thing on it", and that distinction is the whole difference between
     View finishing the filter row neatly and View becoming a full-width slab on
     a line of its own. So the line gets measured.

     Always measured with the class OFF. At its natural width View either fits
     beside the last filter or it does not, and growing it afterwards cannot
     push it off a row it already fits on — so this settles in one pass and
     cannot oscillate. Measuring with the class ON would read the grown width
     back and never let it shrink again. */
  var FIT_T = 0;
  function fitView(){
    /* Addressed by the attribute alone, not .ff-drop[data-drop="view"]:
       only .ff-drop elements carry data-drop, so the class buys nothing, and
       check-liquid.js resolves a compound class+attribute selector by the
       literal string rather than by its parts — so the compound form fails
       its "every engine selector resolves in the template" test. */
    var view = $('[data-drop="view"]');
    if (!view) return;
    view.classList.remove('ff-view-fill');
    /* Measured against the FIRST filter, not the nearest one. "Shares a row
       with whatever precedes it" was the obvious test and it is too loose: once
       the filters wrap, View lands on row two beside the last two or three of
       them and fills what is left of THAT row, which at 1024 made it 803px —
       the same slab, just one row down. Filling only reads as finishing the bar
       off when the bar is a single line, so that is the actual condition:
       View's row is the first filter's row. Anything narrower and it stays the
       ordinary auto-width button the other nine are. */
    var first = $('.ff-fbar .ff-drop');
    if (!first || first === view) return;
    if (Math.round(first.getBoundingClientRect().top) === Math.round(view.getBoundingClientRect().top)){
      view.classList.add('ff-view-fill');
    }
  }
  function fitViewSoon(){ clearTimeout(FIT_T); FIT_T = setTimeout(fitView, 120); }

  function wire(){
    /* One dropdown open at a time; closes on outside click or Escape. */
    /* Called as a panel opens, never on resize: a panel that is open when the
       window resizes is closed by the next click anywhere, and re-measuring on
       every resize frame would cost more than it saves. Removing the class
       before measuring is load-bearing — without it a panel that was flipped
       last time reports its flipped position and never flips back. */
    function place(panel){
      panel.classList.remove('ff-right');
      if (panel.getBoundingClientRect().right > $('.ff-fbar').getBoundingClientRect().right){
        panel.classList.add('ff-right');
      }
    }
    function closeAll(except){
      $$('.ff-drop').forEach(function(d){
        if (d === except) return;
        d.querySelector('.ff-btn').setAttribute('aria-expanded','false');
        d.querySelector('.ff-panel').hidden = true;
      });
    }
    $$('.ff-drop').forEach(function(d){
      var btn = d.querySelector('.ff-btn'), panel = d.querySelector('.ff-panel');
      btn.addEventListener('click', function(e){
        e.stopPropagation();
        var open = btn.getAttribute('aria-expanded') === 'true';
        closeAll(d);
        btn.setAttribute('aria-expanded', String(!open));
        panel.hidden = open;
        if (!open) place(panel);
      });
      panel.addEventListener('click', function(e){ e.stopPropagation(); });
    });
    document.addEventListener('click', function(){ closeAll(null); });

    /* Delegated off the grid, which outlives every card in it — the same reason
       popBind() is delegated, and the same trap avoided: render() replaces the
       grid's innerHTML on every keystroke, so a handler bound to a card link is
       thrown away by the next count that changes.

       CAPTURE phase. This runs on the click that navigates away, and a bubbling
       handler is not guaranteed to have run before the browser follows the href.
       localStorage.setItem is synchronous, so having the write happen early in
       the dispatch is the whole of what is needed to make it reliable.

       Matched on PBASE rather than on a class: both links on a card go to the
       product (the full-bleed image link and the title), the accessory cards use
       the same pair, and PBASE is the value the Liquid template injected for
       this market's URL prefix. A class list would have to be kept in step with
       card() by hand. */
    var fitGrid = $('[data-grid]');
    if (fitGrid) fitGrid.addEventListener('click', function(e){
      var a = e.target.closest && e.target.closest('a[href]');
      if (!a) return;
      if ((a.getAttribute('href') || '').indexOf(PBASE) !== 0) return;
      saveFit();
    }, true);

    /* Mobile filter/view drawer — see coreCss()'s .ff-fopen block and
       bodyHtml()'s [data-fbtn]/[data-fclose]/[data-fshow]. One class toggled
       on root turns .ff-fbar into a full-screen panel; the SAME .ff-drop
       buttons already wired above keep working unchanged inside it, so
       nothing here needs to know about individual filter groups at all. */
    var fbtn = $('[data-fbtn]');
    function fbarOpen(v){
      root.classList.toggle('ff-fopen', v);
      fbtn.setAttribute('aria-expanded', String(v));
      /* Locks the PAGE behind the drawer, not the drawer itself — .ff-fbar
         carries its own overflow-y:auto and still needs to scroll. */
      document.documentElement.style.overflow = v ? 'hidden' : '';
    }
    fbtn.addEventListener('click', function(e){ e.stopPropagation(); fbarOpen(true); });
    /* The X button AND the scrim behind the panel — tapping either closes it. */
    $$('[data-fclose]').forEach(function(el){
      el.addEventListener('click', function(e){ e.stopPropagation(); fbarOpen(false); });
    });
    /* Purely a close action — the grid is already live-filtered by the time
       a shopper reaches this button, so "showing" it is just getting the
       drawer out of the way. */
    $('[data-fshow]').addEventListener('click', function(e){ e.stopPropagation(); fbarOpen(false); });

    document.addEventListener('keydown', function(e){
      if (e.key === 'Escape'){
        if (root.classList.contains('ff-fopen')){ fbarOpen(false); fbtn.focus(); return; }
        var open = $('.ff-btn[aria-expanded="true"]');
        closeAll(null);
        if (open) open.focus();
      }
    });

    /* Both buttons call the same handler with their own value, rather than one
       button flipping a flag: a toggle that names only the state you are not in
       has to be read twice to work out what pressing it does, and the pressed
       one being inert is what makes this pair read as a switch. */
    $$('[data-mode]').forEach(function(b){
      b.addEventListener('click', function(){ applyMode(b.getAttribute('data-mode')); });
    });

    $$('[data-f]').forEach(function(cb){
      cb.addEventListener('change', function(){ active[cb.dataset.f] = cb.checked; render(); });
    });
    /* input debounces the grid (renderSoon); change does not. change fires on
       blur and on a keypad's "done", by which point the shopper has stopped
       typing and is waiting on the answer — making them sit out the pause would
       be the one moment it reads as lag. render() cancels any pending timer, so
       the pair cannot both fire for the same edit. */
    DIM_IDS.forEach(function(id){
      var el = $('#'+id);
      el.addEventListener('input', renderSoon);
      el.addEventListener('change', render);
    });

    /* Delegated: updateAlert() replaces the box's innerHTML on every render, so a
       handler bound to a button would be thrown away the moment the count it
       shows changes. */
    $('[data-alert]').addEventListener('click', function(e){
      /* Checked first and returned on, because an overhang button is not a
         filter: there is no group to clear and falling through to the loop
         below would find no match and re-render for nothing. */
      var ob = e.target.closest ? e.target.closest('[data-overhang]') : null;
      if (ob){ ALLOW = Number(ob.getAttribute('data-overhang')) || 0; render(); return; }
      var btn = e.target.closest ? e.target.closest('[data-clear]') : null;
      if (!btn) return;
      var gid = btn.getAttribute('data-clear');
      GROUPS.forEach(function(g){
        if (g.id !== gid) return;
        g.options.forEach(function(o){
          var k = g.id + ':' + o.id;
          if (!active[k]) return;
          active[k] = false;
          var cb = $('[data-f="' + k + '"]');
          if (cb) cb.checked = false;
        });
      });
      render();
    });
    $('#ff-sort').addEventListener('change', function(){
      /* One way only. Choosing a sort is the shopper taking the wheel, and
         nothing hands it back - not a cleared measurement, not a mode switch.
         Resetting on an empty cavity would mean a shopper who picked "Price,
         low to high", then retyped a width, got capacity order back without
         touching the dropdown that still said price. */
      SORT_TOUCHED = true;
      render();
    });
    $('.ff-clear').addEventListener('click', function(){
      active = {}; $$('[data-f]').forEach(function(cb){ cb.checked = false; }); render();
    });
    /* Everything, not just the filters Clear all covers: a restored search is
       measurements, placement, allowance and sort as well, and "start a new
       search" that left yesterday's width in the box would not be one. The
       render that follows writes the empty search, which drops the saved copy
       and the params and hides the notice - see saveSearch(). Guarded because
       the markup lands in the same deploy round as this. */
    var restart = $('[data-restart]');
    if (restart) restart.addEventListener('click', function(){
      DIM_IDS.forEach(function(id){ var el = $('#'+id); if (el) el.value = ''; });
      active = {}; syncBoxes();
      /* Not the compare picks: those are site-wide now, made on product pages
         as well, and the tray has a Clear of its own. */
      SORT_TOUCHED = false; ALLOW = 0;
      setMode('cavity');
      render();
    });

    var shareBtn = $('[data-share="finder"]');
    if (shareBtn) shareBtn.addEventListener('click', function(){
      share(shareBtn, finderShareUrl(), 'Frothy Finder — Bar Fridges Australia');
    });

    wireCompare();
  }

  /* ── Live records, derived in the browser ───────────────────────────────
   *
   * The whole finder from one collection, refreshed on every page load. A fridge
   * tagged into it appears here with no rebuild, no export, no upload: the
   * dimensions and clearances the fit maths needs are metafields, and Liquid can
   * read metafields. The export was only ever a slow manual transport for them.
   *
   * The baked asset is still what paints first — it is a CDN file and it is
   * instant — and it remains the only source of star ratings, which need 389
   * Feefo calls and cannot be done here. A brand-new product has no reviews
   * anyway, so it shows "Not yet reviewed" until the next rebuild and everything
   * else about it is correct immediately.
   */
  /* A shelf or hinge kit, refreshed from the feed.
   *
   * Merged onto the baked record rather than derived into a new one, because the
   * two halves of an accessory come from different places and only one of them
   * can go live. What it SUITS — the chassis a shelf fits, how many kits a door
   * count needs — is worked out at build time from SKUs and titles, and Liquid
   * cannot express any of it. What it COSTS changes weekly. So the pairing stays
   * baked and the volatile half is taken from the feed.
   *
   * Note stockState() rather than a plain availability flag: "available" is true
   * for a pre-order too, and four of the fourteen shelves are on pre-order. The
   * feed carries the inventory quantity, so unlike the products.json merge this
   * one can tell the three states apart.
   */
  function refreshAccessory(a, raw){
    var price = num(raw.price);
    if (price) a.price = price;
    // The feed already nulls a compare-at that is not above the selling price.
    a.was = num(raw.was);
    if (raw.img) a.img = raw.img;
    a.inStock = raw.available !== false;
    a.stock = stockState(num(raw.qty), raw.available !== false);
    a.badges = raw.badges ? String(raw.badges).split(';').map(function(s){ return s.trim(); })
      .filter(Boolean) : [];
  }

  function liveRecords(items){
    var recs = [];
    var accBy = {};
    ALL_ACCESSORIES.forEach(function(a){ accBy[a.handle] = a; });
    /* One card per product, however many times the feed mentions it.
     *
     * The feed arrives as nine separate paginated requests, concatenated, and
     * nothing about that guarantees each product appears once. Three ways it
     * does not, none of them under this page's control:
     *
     *   - a caching proxy that keys on the path and drops the query string
     *     answers every ?page=N with page 1's contents;
     *   - the collection changing size mid-fetch — a tagging session is exactly
     *     that — slides products across page boundaries between requests;
     *   - a tie-heavy collection sort can place one product on two pages.
     *
     * All three produce the same symptom: the fridge renders twice, and it looks
     * like the finder inventing duplicates rather than the transport repeating
     * itself. The handle is the product's identity, so the first record for a
     * handle wins and later ones are dropped. */
    var seen = {};
    items.forEach(function(raw){
      if (seen[raw.handle]) return;
      seen[raw.handle] = true;
      /* An accessory in the feed is refreshed, never derived. Deriving one as a
         fridge would be worse than useless: it has no cabinet, so applyVent
         drops it — and that is a fact about today's metafields rather than a
         rule, so a shelf that ever acquired an ex-width would walk straight into
         the grid as a fridge. The baked record already knows what it is. */
      var acc = accBy[raw.handle];
      if (acc){ refreshAccessory(acc, raw); return; }
      var dec = raw.model ? decodeSku(raw.model) : {};
      var f = deriveOne(raw, dec);
      /* Liquid cannot express "no tag", only an empty string, so the blanks come
         back as '' and have to be nulled here rather than reaching a card as an
         empty spec row. */
      ['brand','suitability','mount','eta','etaDate','model','sku'].forEach(function(k){
        if (f[k] === '') f[k] = null;
      });
      f.badges = raw.badges ? String(raw.badges).split(';').map(function(s){ return s.trim(); })
        .filter(Boolean) : [];
      recs.push(f);
    });
    /* The same chassis fallback the Node build runs — the live feed carries the
       same blank door types, and a card that answers no Door Style filter is the
       bug this fixes. */
    applyChassisDoor(recs);
    return applyVent(recs, 200).kept;
  }

  /* Ratings are the one thing the feed cannot carry, so they are carried across
     from the baked set by SKU. A product too new to be in that set simply has
     none, which is the truth. */
  function keepRatings(fresh, old){
    var by = {};
    old.forEach(function(f){ if (f.sku) by[f.sku] = f; });
    fresh.forEach(function(f){
      var prev = f.sku && by[f.sku];
      f.rating = prev ? prev.rating : null;
      f.reviews = prev ? prev.reviews : null;
      f.revFloat = prev ? prev.revFloat : false;
      f.revOf = prev ? prev.revOf : null;
    });
    return fresh;
  }

  function refreshAll(){
    var base = root.getAttribute('data-feed');
    if (!base) return refreshPrices();
    /* Page 1 first, because it names how many pages there are. The rest go out
       together rather than in sequence — eight round trips one after another is
       eight times the latency for no benefit.
       The page count is used as a hint, not as truth. A stale page 1 — proxy, or
       a CDN holding the response from before the collection grew — reports the
       page count it was generated with, and trusting it loads a SHORT feed that
       looks entirely healthy: every card correct, a third of the range missing,
       nothing to say so. So the fetch keeps going past the promised end until a
       page comes back short, which is the only reliable last-page marker. */
    var FEED_PAGE = 50;
    /* One cache-busting token for the whole read, computed ONCE here and sent
     * with every page including the walk past the end.
     *
     * The nine pages are one snapshot or they are nothing. A cache between the
     * shopper and the shop — a corporate proxy, most often — holds each page
     * URL independently and expires them independently, so page 3 can be
     * minutes older than page 4. Offset pagination cannot survive that: a
     * product that has since moved from page 4 to page 3 arrives on both, and
     * the product that took its place arrives on neither. Observed in the wild
     * as 112 repeats out of 402, differing on every load.
     *
     * Bucketed to the minute rather than unique per request. A shared token
     * still forces a miss on anything staler than that, which is the point, but
     * it lets a genuine CDN serve a burst of visitors from one generation
     * instead of sending nine origin requests each. What matters is not that the
     * pages are fresh — it is that they agree. */
    var FEED_TOKEN = Math.floor(Date.now() / 60000);
    var pageUrl = function(p){ return base + p + '&_=' + FEED_TOKEN; };
    /* Three at a time, not all eight at once.
     *
     * Eight simultaneous requests to one origin is what a throttle is built to
     * stop, and a shop where several people browse from one office IP shares
     * that budget between them. Throttled pages do not come back as errors —
     * they come back SHORT, so the feed assembles cleanly with a block of
     * products missing, and the range silently shrinks by a different amount on
     * every load. Three keeps the latency win of overlapping requests without
     * looking like a scrape. */
    var FEED_CONCURRENCY = 3;
    var wait = function(ms){ return new Promise(function(r){ setTimeout(r, ms); }); };

    /* Retried, because a throttled page is a transient answer rather than a
       wrong one, and backing off briefly turns a fallback into a correct load.
       A short page counts as a failure worth retrying only when it cannot be
       the last one — the final page is short by definition. */
    function fetchPage(p, mustBeFull, tries){
      tries = tries || 0;
      return fetch(pageUrl(p), { credentials:'omit' })
        .then(function(r){ if (!r.ok) throw new Error('HTTP '+r.status); return r.json(); })
        .then(function(d){
          var items = (d && d.items) || [];
          /* The feed stamps every response with the page it actually is, and
           * that is the one thing that can tell the two remaining causes apart.
           *
           * A cache handing back the wrong body answers ?page=6 with a document
           * that says "page":5 — proof the transport is at fault, and something
           * a shared token or a different URL shape can fix.
           *
           * Correct labels with overlapping CONTENT means the opposite: the shop
           * itself is paginating unstably, because offset pagination over a sort
           * with ties has no fixed order to slice. Nothing on this side can fix
           * that one; the collection needs a deterministic sort.
           *
           * Guessing between them cost most of a day. Now it says which. */
          if (d && d.page && d.page !== p) {
            throw new Error('page ' + p + ' answered as page ' + d.page + ' (cache served the wrong body)');
          }
          if (mustBeFull && items.length !== FEED_PAGE) throw new Error('short page '+p);
          return items;
        })
        .catch(function(e){
          if (tries >= 2) throw e;
          return wait(300 * (tries + 1)).then(function(){
            return fetchPage(p, mustBeFull, tries + 1);
          });
        });
    }

    /* A fixed-width pool: each runner takes the next page as it finishes, so
       there are never more than FEED_CONCURRENCY requests in the air. */
    function fetchPages(list, lastPage){
      var out = {}, i = 0;
      function next(){
        if (i >= list.length) return Promise.resolve();
        var p = list[i++];
        // The final page is short by definition, so only the ones before it are
        // held to a full 50 — otherwise every healthy load retries and gives up.
        return fetchPage(p, p < lastPage).then(function(items){ out[p] = items; return next(); });
      }
      var runners = [];
      for (var k = 0; k < Math.min(FEED_CONCURRENCY, list.length); k++) runners.push(next());
      return Promise.all(runners).then(function(){
        return list.map(function(p){ return out[p]; });
      });
    }

    function fetchFrom(p, acc){
      return fetchPage(p, false).then(function(got){
        acc = acc.concat(got);
        return (got.length === FEED_PAGE && p < 40) ? fetchFrom(p+1, acc) : acc;
      });
    }
    fetch(pageUrl(1), { credentials:'omit' })
      .then(function(r){ if (!r.ok) throw new Error('HTTP '+r.status); return r.json(); })
      .then(function(first){
        var claimed = first.pages || 1;
        var list = [];
        for (var p = 2; p <= claimed; p++) list.push(p);
        return fetchPages(list, claimed).then(function(pages){
          var all = [first.items || []].concat(pages);
          /* Every page but the last must hold exactly 50. A short page in the
             middle means that request did not bring back what it was asked for
             — a throttling proxy answering eight parallel requests, most often —
             and the assembled feed is missing a block of products it will never
             mention again.
             This has to be caught HERE rather than downstream, because a short
             feed is indistinguishable from a real one once it is a list of
             records: every card on it is correct, the range is simply smaller,
             and the page would quietly replace a complete baked set with it. */
          for (var i = 0; i < all.length - 1; i++) {
            if (all[i].length !== FEED_PAGE) {
              throw new Error('short page ' + (i+1) + ': ' + all[i].length + '/' + FEED_PAGE);
            }
          }
          /* Which pages overlap, not just how many items repeated. Two pages
             carrying the same product is the signature; naming the pair is what
             separates "a cache served page 5 twice" from "every page overlaps
             its neighbour", and those have different fixes. */
          var where = {}, pairs = [];
          all.forEach(function(pg, idx){
            pg.forEach(function(it){
              var seenOn = where[it.handle];
              if (seenOn === undefined) { where[it.handle] = idx + 1; return; }
              var pair = seenOn + '+' + (idx + 1);
              if (pairs.indexOf(pair) < 0) pairs.push(pair);
            });
          });
          if (pairs.length) throw new Error('pages overlap: ' + pairs.slice(0, 8).join(', '));
          var items = [];
          all.forEach(function(pg){ items = items.concat(pg); });
          /* The last promised page was full, so the promise was short. Keep
             walking one page at a time until one comes back under 50. */
          if (all[all.length-1].length === FEED_PAGE) return fetchFrom(claimed + 1, items);
          return items;
        });
      })
      .then(function(items){
        if (!items.length) throw new Error('empty feed');
        /* A repeated handle proves the page set is not one snapshot.
         *
         * Offset pagination over a fixed collection cannot serve the same
         * product twice, so a duplicate means the pages disagree about what
         * they were paginating — a proxy answering two page numbers from one
         * cached body, or the collection shifting under the fetch. Either way
         * something got served twice and something else never got served at
         * all, so the omission is the real damage and the duplicate is just the
         * half of it that is visible.
         * liveRecords() de-duplicates as well, and still should: that guards the
         * render path. This decides whether the read is trustworthy enough to
         * replace a good range with, which is a different question. */
        var uniq = {}, dupes = 0;
        items.forEach(function(i){
          if (uniq[i.handle]) dupes++; else uniq[i.handle] = true;
        });
        if (dupes) throw new Error('feed repeated ' + dupes + ' of ' + items.length + ' items');
        var fresh = keepRatings(liveRecords(items), FRIDGES);
        if (!fresh.length) throw new Error('nothing derived');
        /* The live feed may not shrink the range. Last line of defence, and the
         * only one that does not care WHY.
         *
         * Everything above catches a transport that fails in a recognisable
         * shape — a short page, a stale page count, a repeated handle. What it
         * cannot catch is a page that arrives well-formed and wrong: fifty
         * items, correct JSON, stale or partial content. Somewhere between the
         * shop and an office network that is exactly what happens, and the only
         * evidence is the count dropping from the baked figure to a smaller one
         * that differs on every load.
         *
         * The baked set is a known-good floor — it was built, checked and
         * shipped — so a live set materially below it is not news about the
         * catalogue, it is a broken read. A genuine mass-untagging would trip
         * this too and hold the previous range until the next rebuild, which is
         * the right way round: showing a fridge that has just left the finder
         * costs far less than a range that quietly loses a fifth of itself and
         * still looks authoritative. */
        if (fresh.length < FRIDGES.length * 0.9) {
          throw new Error('feed short: ' + fresh.length + ' vs baked ' + FRIDGES.length);
        }
        FRIDGES = fresh;
        CAP = null;              // cavity scale is pinned to the range; it moved
        POOL_OF = {};            // pools are derived from the set; it changed
        pairKits();              // capacities are live now, so the kits repair
        cmpAdopt();              // so a fridge tagged in since the build can be compared
        cmpResolve();            // and a SKU in a link that only the live feed knows
        render();
      })
      /* Any failure at all falls back to the baked set, which is already on
         screen. A stale finder beats a broken one.
         Silent to the shopper, who can do nothing with the news and still has a
         working finder — but NOT silent to whoever is looking for it. Every
         guard above throws with what it saw, and this is the one place that
         knows a fallback happened at all. Without it the only evidence is a
         count that does not move, which is indistinguishable from the feed
         working, and that is how a broken office network cost a day. */
      .catch(function(e){
        if (window.console && console.warn) {
          console.warn('[frothy] live feed rejected, using baked data:',
            (e && e.message) || e);
        }
        refreshPrices();
      });
  }

  /* Live prices, from the collection that already decides membership.
   *
   * The JSON asset is built from a products.json fetch too, but at BUILD time,
   * so from the moment it is written it starts drifting: a price edited in admin
   * is wrong in the finder until someone remembers to rebuild, with nothing to
   * remind them. One request at runtime removes the whole class of problem.
   *
   * Dimensions and clearances stay baked, because they have no live source — the
   * Matrixify export is the only place they exist. That split is the point: what
   * changes weekly is read live, what changes when a new model lands is rebuilt
   * when a new model lands.
   *
   * Silent on failure by design. A shopper with a stale price still gets a
   * working finder; a shopper with an error message gets nothing. */
  function mergeLive(products){
    var by = {};
    products.forEach(function(p){
      var priced = p.variants.filter(function(v){ return Number(v.price) > 0; });
      /* Cheapest variant, and compare-at only counts as a markdown when it is
         ABOVE the selling price — same two rules as fetchRetail() in
         build-data.js, so the live and baked numbers can never disagree about
         what a sale is. */
      var c = priced.sort(function(a,b){ return Number(a.price)-Number(b.price); })[0];
      if (!c) return;
      var now = Number(c.price), was = Number(c.compare_at_price || 0);
      by[p.handle] = {
        price: now || null,
        was: was > now ? was : null,
        img: (p.images && p.images[0] && p.images[0].src
          ? p.images[0].src.replace(/(\.[a-z]+)(\?|$)/i, '_400x$1$2') : null),
        avail: p.variants.some(function(v){ return v.available; })
      };
    });
    var n = 0;
    FRIDGES.concat(ALL_ACCESSORIES).forEach(function(f){
      var l = by[f.handle];
      if (!l) return;
      n++;
      if (l.price) f.price = l.price;
      f.was = l.was;
      if (l.img) f.img = l.img;
      /* products.json says available or not; it cannot say WHY. A pre-order is
         available — that is what continue-selling means — so a live 'available'
         can confirm a sold-out item is back but can never tell in-stock from
         pre-order. That distinction needs the inventory quantity, which only the
         export carries, so the baked state stands unless live contradicts it. */
      f.inStock = l.avail;
      if (!l.avail) f.stock = 'out';
      else if (f.stock === 'out') f.stock = 'in';
    });
    return n;
  }

  /* Paginated, for the same reason the data feed is: products.json serves at
     most 250 and the collection is past that. An unpaginated fetch does not
     fail — it just prices the first 250 fridges and leaves the rest on baked
     figures, which is the silent drift this whole function exists to remove.
     A short page is the last page, so a full one is the only reason to ask for
     another. */
  function pricePages(url, page, acc){
    return fetch(url + '&page=' + page, { credentials:'omit' })
      .then(function(r){ if (!r.ok) throw new Error('HTTP '+r.status); return r.json(); })
      .then(function(d){
        var got = (d && d.products) || [];
        acc = acc.concat(got);
        return (got.length === 250 && page < 20) ? pricePages(url, page+1, acc) : acc;
      });
  }

  function refreshPrices(){
    var url = root.getAttribute('data-live');
    if (!url) return;
    pricePages(url, 1, [])
      .then(function(products){ if (products.length && mergeLive(products)) render(); })
      .catch(function(){ /* baked prices stand */ });
  }

  /* Which fridges each hinge kit suits, worked out from the fridge set that is
     current — baked at first paint, live metafields a moment later. kitFor() is
     derive.js's rule, inlined above and shared with the Node build, so the two
     cannot disagree about where a kit belongs.

     Everything downstream reads a.skus and a.fits and needs no idea this
     happened: the card's "Suits:" row, the placement in withAccessories(), and
     the count beside "Sliding hinge kits" all follow.

     Kits only. A roller shelf names its chassis in its title ("Roller Shelf To
     Suit SK116") and nothing in the feed states it, so its pairing is worked out
     at build time and stays baked. */
  function pairKits(){
    ALL_ACCESSORIES.forEach(function(a){
      if (a.kind !== 'kit') return;
      var suits = FRIDGES.filter(function(f){ return kitFor(f) === a.sku; });
      a.skus = suits.map(function(f){ return f.sku; }).filter(Boolean);
      a.fits = suits.map(function(f){ return f.chassis; })
        .filter(function(c, i, all){ return c && all.indexOf(c) === i; });
    });
  }

  /* The opening, handed over in the URL: ?w=900&d=600&h=850&f=doors:d2,suit:outdoor
   *
   * One read, on arrival, and nothing else. The homepage quick-size widget
   * (bfau-frothy-quicksize.liquid) puts three numbers in a link and this is what
   * receives them. There is no write path: the cavity is never pushed back into
   * the address bar as the shopper types, and no history entry is made. The URL
   * is a way IN to the finder, not a record of what it is currently showing, and
   * the two are different jobs — the second one is a router and this page does
   * not want one.
   *
   * It must stay inside boot(), and that is the whole reason it is a named
   * function called from there rather than a few lines at the top of the file.
   * readMm() decides whether a bare "60" means 60mm or 600mm by asking
   * openRange(), which derives its bounds from FRIDGES and MEMOISES them into
   * OPEN — and nothing ever clears OPEN, not even refreshAll(), which does clear
   * CAP and POOL_OF. Run this before the fridge data has landed and OPEN caches
   * the hardcoded {lo:390,hi:2150} fallback for the life of the page. Nothing
   * looks wrong: the grid paints, the counts are right, and every bare number
   * typed for the rest of the session is read against a range that is not the
   * range. By boot() FRIDGES is populated and the range is the real one.
   *
   * The RAW text goes into the field, not a normalised number. readMm() already
   * reads 600, 600mm, 60cm, 60 cm and 0.6m, so the widget at the other end has
   * nothing to normalise and no second copy of these rules to drift from this
   * one — which is the same argument derive.js makes about being inlined here
   * rather than reimplemented.
   *
   * A param readMm() cannot read leaves its field ALONE, and since the three
   * inputs now ship EMPTY that is a safe answer rather than the least bad one.
   * It used to be the least bad one: the fields shipped with 1370 x 890 x 2150
   * in them, so a bad param had no empty state to fall back to and blanking or
   * zeroing the field meant a finder that said nothing fits. Blank and 0 both
   * mean "no limit" now — see cavity() — so a rejected param drops that axis out
   * of the fit test and the shopper sees more fridges, not none.
   * A dropped param still looks like a working search for a partial opening,
   * which is why the defence stays at the other end: the widget will not build a
   * link at all until all three of its fields are shaped like measurements, so a
   * param this rejects should never be sent. */
  function prefillFromUrl(q){
    var got = false;
    [['w','ff-cw'],['d','ff-cd'],['h','ff-ch']].forEach(function(pair){
      var raw = q.get(pair[0]);
      if (raw === null) return;
      raw = raw.trim();
      /* Readable, not necessarily unambiguous. readMm() flags a genuinely
         undecidable bare number with ask:true rather than refusing it, and the
         echo under the field then asks the question in so many words. That is
         exactly what someone typing the same thing here would get, and it beats
         silently discarding a measurement the shopper did give us. */
      if (!readMm(raw)) return;
      var el = $('#'+pair[1]);
      if (!el) return;
      el.value = raw;
      got = true;
    });
    /* render() calls updateEchoes() itself, so this is belt and braces — but the
       prefill should not depend on what boot() happens to call next, and the
       echo is the only thing on screen that reports how a handed-over "60cm" was
       read. Skipped entirely when nothing landed, which is every ordinary page
       load. */
    if (got) updateEchoes();

    /* Filters, handed over the same way: ?f=doors:d2,suit:outdoor
     *
     * The tokens are the engine's OWN keys — the 'group:option' string already
     * used by data-f=, by 'active', and by the data-clear handler. Nothing is
     * translated on the way in, and there is deliberately no friendlier alias
     * table: an alias table is a second list of what the filters are, and the
     * moment an option id changes, the two disagree and the one nobody rebuilt
     * wins. The homepage widget sends these strings verbatim for the same
     * reason it sends raw "60cm" rather than 600.
     *
     * Validated against GROUPS rather than trusted, and a token that names no
     * real option is DROPPED — not applied to nothing, not guessed at. The cost
     * of dropping it is a wider grid than the shopper asked for, which is a
     * finder showing too much; the cost of guessing is a finder confidently
     * showing the wrong range. Same call prefillFromUrl already makes for a
     * dimension readMm() cannot read.
     *
     * Ticks the checkbox as well as setting 'active', because those are two
     * separate records of the same fact and render() only reads one of them.
     * Leave the box unticked and the grid is filtered while every dropdown says
     * it is not — and the shopper's first click on the group they cannot see
     * checked would turn the filter ON in the UI and OFF in the state. The
     * markup is static Liquid, so the boxes are in the DOM before boot() runs.
     *
     * Runs before wire(), like the rest of this function, which is fine in both
     * directions: wire() only attaches listeners, and render() (called straight
     * after) is what turns 'active' into a grid and into the little count badge
     * beside each group label. */
    var chosen = q.get('f');
    if (chosen) chosen.split(',').forEach(function(tok){
      tok = tok.trim();
      var bits = tok.split(':');
      if (bits.length !== 2 || !bits[0] || !bits[1]) return;
      var real = false;
      GROUPS.forEach(function(g){
        if (g.id !== bits[0]) return;
        g.options.forEach(function(o){ if (o.id === bits[1]) real = true; });
      });
      if (!real) return;
      active[tok] = true;
      var cb = $('[data-f="' + tok + '"]');
      if (cb) cb.checked = true;
    });

    /* The rest of what a search is, since the finder began writing its state
       back (see saveSearch()): placement, overhang allowance and a sort the
       shopper chose. Each is validated the same way the filters are — a value
       that is not one of the real ones is dropped and the default stands.

       Placement first, because setMode('space') clears ALLOW, and an allowance
       read before it would be wiped by it. The allowance is only ever 0 or
       OVERHANG.max from the buttons, so anything else is not something the
       finder wrote. sort is present only when the shopper picked it; setting
       SORT_TOUCHED keeps autoSort() from overruling a choice they made. */
    if (q.get('mode') === 'space') setMode('space');
    if (MODE === 'cavity' && Number(q.get('allow')) === OVERHANG.max) ALLOW = OVERHANG.max;
    var sort = q.get('sort'), sel = $('#ff-sort');
    if (sort && sel) for (var i = 0; i < sel.options.length; i++){
      if (sel.options[i].value !== sort) continue;
      sel.value = sort; SORT_TOUCHED = true;
    }
  }

  /* ── The search, kept ───────────────────────────────────────────────────
   *
   * Two copies of the same query string, for two ways back to the page:
   *
   *   the address bar   Back, reload, and a link someone was sent. Rewritten
   *                     with replaceState on every render, so Back leaves the
   *                     finder instead of undoing it one tick at a time.
   *   localStorage      the menu, the homepage, any link that is just
   *                     /pages/frothy-finder. Kept SEARCH_TTL_HOURS from the
   *                     last CHANGE to the search, not the last visit, so a
   *                     shopper who looks in every evening still starts clean.
   *
   * Both hold the param string prefillFromUrl() reads, rather than a JSON shape
   * of their own, so a saved search is validated by exactly the code that
   * validates a link — a filter id renamed between builds is dropped from a
   * stale saved search the same way it is dropped from a stale shared link.
   *
   * THE ADDRESS BAR WINS. Any finder param on arrival means that link is the
   * search, and the saved one is ignored rather than merged: the homepage
   * quick-size box sends a fresh measurement, and topping it up with last
   * week's filters would answer a question nobody asked.
   *
   * Separate from 'bfau.ff.fit' and deliberately so. That record is a warranty
   * claim written on click-through; this is convenience written on every render,
   * and bfau-ff-stamp.liquid must never read one as the other. */
  var SEARCH_STORE = 'bfau.ff.search';
  var SEARCH_TTL_HOURS = 12;
  /* cmp= was one of these until 2026-09-28. The picks are site-wide now, kept
     by bfau-compare.js, and only the compare page's own address carries them. */
  var SEARCH_KEYS = ['w','d','h','f','mode','allow','sort'];

  /* The live search as a param string, in a fixed key order so an unchanged
     search compares equal. ':' and ',' are left readable in f= because the
     tokens are meant to be read and pasted (see the handover). */
  function searchString(){
    var parts = [];
    function put(k, v){
      if (!v) return;
      parts.push(k + '=' + encodeURIComponent(v).replace(/%3A/g, ':').replace(/%2C/g, ','));
    }
    put('w', ($('#ff-cw').value || '').trim());
    put('d', ($('#ff-cd').value || '').trim());
    put('h', ($('#ff-ch').value || '').trim());
    put('f', Object.keys(active).filter(function(k){ return active[k]; }).sort().join(','));
    if (MODE === 'space') put('mode', 'space');
    if (ALLOW) put('allow', String(ALLOW));
    if (SORT_TOUCHED) put('sort', $('#ff-sort').value);
    return parts.join('&');
  }

  function hasSearchParams(q){
    return SEARCH_KEYS.some(function(k){ return q.get(k) !== null; });
  }

  /* Called at the end of every render(). Neither copy is touched when the
     search has not changed, which is most renders — the live-price refresh, a
     View toggle's recount — and is what keeps the storage expiry measured from
     the last change and keeps replaceState well under Safari's rate limit. */
  var LAST_SEARCH = null;
  function saveSearch(){
    var s = searchString();
    if (s === LAST_SEARCH) return;
    LAST_SEARCH = s;

    /* The shopper's own params only; anything else on the URL — a utm tag, a
       Shopify preview flag — is carried through byte for byte.
       Not on the compare page, whose address is the picks. It calls this only
       when the shopper changes a measurement in its panel, and then only the
       stored copy below is written, which is what the finder picks up next
       time: measure on either page, and the other one knows. */
    if (!CPAGE) try {
      var keep = location.search.replace(/^[?]/, '').split('&').filter(function(p){
        return p && SEARCH_KEYS.indexOf(decodeURIComponent(p.split('=')[0])) === -1;
      });
      if (s) keep.push(s);
      var url = location.pathname + (keep.length ? '?' + keep.join('&') : '') + location.hash;
      if (url !== location.pathname + location.search + location.hash){
        history.replaceState(history.state, '', url);
      }
    } catch (e) { /* Old browser or a sandboxed frame: the grid still works. */ }

    /* Compared against what is stored as well as against LAST_SEARCH, which
       starts empty on every page load: the first render of a visit writes the
       same search it just restored, and restamping it there would move the
       expiry on every visit rather than on every change. */
    try {
      if (!s) localStorage.removeItem(SEARCH_STORE);
      else if (savedSearch() !== s) localStorage.setItem(SEARCH_STORE, JSON.stringify({
        q: s, exp: Date.now() + SEARCH_TTL_HOURS * 60 * 60 * 1000
      }));
    } catch (e) { /* Private browsing or a full quota — nothing is kept, same as before. */ }

    var note = $('[data-resumed]');
    if (note && !s) note.hidden = true;
  }

  function savedSearch(){
    try {
      var rec = JSON.parse(localStorage.getItem(SEARCH_STORE) || 'null');
      if (rec && typeof rec.q === 'string' && rec.exp > Date.now()) return rec.q;
      if (rec) localStorage.removeItem(SEARCH_STORE);
    } catch (e) {}
    return '';
  }

  /* Every checkbox set from 'active', ticked or not. This is the Back-button
     fix as much as a restore step: when the browser rebuilds the page instead
     of taking it from the back/forward cache, it re-ticks the boxes it
     remembers WITHOUT firing change, so 'active' starts empty under boxes that
     look ticked — a grid that ignores filters the dropdowns say are on, and a
     first click that unticks one and applies nothing. Setting every box from
     the state after the restore means the two records can only ever agree. */
  function syncBoxes(){
    $$('[data-f]').forEach(function(cb){ cb.checked = !!active[cb.dataset.f]; });
  }

  function restoreSearch(){
    if (window.URLSearchParams){
      var q = new URLSearchParams(location.search);
      if (hasSearchParams(q)){
        prefillFromUrl(q);
      } else {
        var saved = savedSearch();
        if (saved){
          prefillFromUrl(new URLSearchParams(saved));
          var note = $('[data-resumed]');
          if (note) note.hidden = false;
        }
      }
    }
    syncBoxes();
  }

  /* ── Share ──────────────────────────────────────────────────────────────
   *
   * One button on the finder (the search) and one on the compare page (the
   * picks and the opening). On a phone it opens the phone's own share sheet -
   * Messages, WhatsApp, email - which is where a "which of these?" goes; on a
   * desktop, where the system sheet is a poor fit for pasting into an email,
   * it copies the link and says so on the button. A cancelled share sheet is
   * not an error. */
  var SHARE_T = 0;
  function share(btn, url, title){
    var coarse = window.matchMedia && window.matchMedia('(pointer:coarse)').matches;
    if (coarse && navigator.share){
      navigator.share({ title: title, url: url }).catch(function(){});
      return;
    }
    copyText(url).then(function(ok){ shareSaid(btn, ok ? 'Link copied' : 'Couldn\u2019t copy'); });
  }
  function copyText(t){
    if (navigator.clipboard && navigator.clipboard.writeText){
      return navigator.clipboard.writeText(t).then(function(){ return true; }, function(){ return legacyCopy(t); });
    }
    return Promise.resolve(legacyCopy(t));
  }
  /* Older Safari, and any frame that refuses the clipboard API. */
  function legacyCopy(t){
    var ta = document.createElement('textarea'), ok = false;
    ta.value = t;
    ta.setAttribute('readonly', '');
    ta.style.cssText = 'position:fixed;top:-1000px;left:0;opacity:0';
    document.body.appendChild(ta);
    ta.select();
    try { ok = document.execCommand('copy'); } catch (e) {}
    document.body.removeChild(ta);
    return ok;
  }
  function shareSaid(btn, msg){
    var l = btn.querySelector('[data-share-l]');
    if (!l) return;
    l.textContent = msg;
    btn.classList.add('is-done');
    clearTimeout(SHARE_T);
    SHARE_T = setTimeout(function(){ l.textContent = 'Share'; btn.classList.remove('is-done'); }, 2200);
  }
  /* The page's own address, without anything that was on it. */
  function pageBase(){ return location.href.split('#')[0].split('?')[0]; }
  /* The finder: the search exactly as prefillFromUrl() reads it back. */
  function finderShareUrl(){
    var s = searchString();
    return pageBase() + (s ? '?' + s : '');
  }
  /* The compare page: the picks, and the opening they are being fitted to.
     Filters and sort are the finder's business and stay out of it. */
  var OPENING_KEYS = ['w','d','h','mode','allow'];
  function compareShareUrl(){
    var q = new URLSearchParams(searchString()), parts = ['cmp=' + cmpParam()];
    OPENING_KEYS.forEach(function(k){ var v = q.get(k); if (v) parts.push(k + '=' + encodeURIComponent(v)); });
    return pageBase() + '?' + parts.join('&');
  }

  /* ── Compare ────────────────────────────────────────────────────────────
   *
   * SITE-WIDE SINCE 2026-09-28. The list of picks lives in
   * theme/assets/bfau-compare.js (window.BFAU_CMP), shared with the Compare
   * tickbox on every theme product card and the product page's "Add to
   * compare", and so does the tray that used to be drawn here. This engine
   * keeps two jobs:
   *
   *   the finder     its own cards' tickboxes, which write to that list and
   *                  are redrawn from it on 'bfau:cmp'
   *   the page       /pages/compare is this same engine with data-cpage on
   *                  .frothy (bfau-frothy-compare.liquid), so the fit row, the
   *                  ranking and the live prices are the finder's own rather
   *                  than a second copy of them
   *
   * Picks are HANDLES, resolved back to records at the moment of use rather
   * than held: refreshAll() swaps every record for a live one after first
   * paint, and a held record would compare yesterday's price.
   *
   * TWO ON A PHONE, THREE ABOVE 700px, enforced by bfau-compare.js. At 390px
   * two columns get ~170px each, which holds "750x570x865mm" on one line;
   * three get ~115px and nothing holds.
   *
   * Without bfau-compare.js - the standalone preview built without it, or a
   * theme it was never installed on - the finder still ticks, into a list of
   * its own that nothing else sees. */
  var CMP = [];
  function cmpApi(){ return window.BFAU_CMP || null; }
  function cmpMax(){
    var a = cmpApi();
    if (a) return a.max();
    return window.matchMedia && window.matchMedia('(max-width:700px)').matches ? 2 : 3;
  }
  function recByHandle(h){
    for (var i = 0; i < FRIDGES.length; i++) if (FRIDGES[i].handle === h) return FRIDGES[i];
    return null;
  }

  /* A compare link names each pick by its SKU, not its handle (2026-09-29).
     BFA's handles are sentences - 81 characters typically, 146 at worst - so
     three picks made a 300-character link; SKUs top out at 20, all 380 are
     set and none repeat, and "SG1R-HD,HUS-SC88-SS" says what is being
     compared before anyone opens it. The list itself stays handles: this is
     the address only, turned back into handles the moment it is read.
     A pick with no record here (added on a product page since the build)
     keeps its handle in the link, and a handle is still read, so every link
     ever shared keeps working. */
  function cmpToken(h){
    var f = recByHandle(h);
    return f && f.sku ? f.sku : h;
  }
  /* Handle first, so a handle can never be misread as someone else's SKU;
     SKUs case-blind, because a link typed out by hand arrives in any case. */
  function cmpHandle(t){
    if (recByHandle(t)) return t;
    var u = String(t).toUpperCase();
    for (var i = 0; i < FRIDGES.length; i++){
      if (FRIDGES[i].sku && String(FRIDGES[i].sku).toUpperCase() === u) return FRIDGES[i].handle;
    }
    return t;
  }
  function cmpParam(){ return CMP.map(function(h){ return encodeURIComponent(cmpToken(h)); }).join(','); }
  /* A SKU the baked data did not know, from a link sent by someone whose
     page had the live feed, becomes a handle once the live records land. */
  function cmpResolve(){
    var a = cmpApi(), list = a ? a.list() : CMP, next = list.map(cmpHandle);
    if (next.join(',') === list.join(',')) return;
    if (a) a.setAll(next); else CMP = next;
  }
  function comparable(f){ return !!f && !f.accessory && !f.camping; }
  function shortTitle(f){ return String(f.title || '').replace(/\s*[-\u2013]\s*Model\b.*$/i, ''); }
  function cmpName(f){ return (f.brand ? f.brand + ' ' : '') + (f.model || shortTitle(f)); }

  function setCompare(h, on){
    var a = cmpApi();
    /* The list's own 'bfau:cmp' brings the change back through syncCompare(),
       along with the swap-out toast when a pick past the limit replaced one. */
    if (a){ a.set(h, on); return; }
    var at = CMP.indexOf(h);
    if (on && at === -1 && comparable(recByHandle(h))){
      while (CMP.length >= cmpMax()) CMP.shift();
      CMP.push(h);
    }
    if (!on && at !== -1) CMP.splice(at, 1);
    syncCompare();
  }

  /* The records, handed to bfau-compare.js: it needs them for the tray's
     thumbnails and to know which products are comparable, and would otherwise
     fetch this same 426KB asset a second time. Once with the baked records at
     boot, again with the live ones once refreshAll() has them. */
  function cmpAdopt(){
    var a = cmpApi();
    if (a && a.adopt) a.adopt(FRIDGES);
  }

  /* Every picture of the picks brought into line with the list: the tickboxes
     on whatever cards are on screen, and the page if this is the page. Cheap
     enough to run whole on every change, and running it whole is what stops
     them disagreeing.
     A handle this engine has no record for is KEPT in the list, just not
     drawn. On the compare page the live feed may be on its way with it, and
     on the finder it may be a fridge picked from a product page since. */
  function syncCompare(){
    var a = cmpApi();
    if (a) CMP = a.list();
    $$('[data-cmp]').forEach(function(cb){
      var on = CMP.indexOf(cb.getAttribute('data-cmp')) !== -1;
      cb.checked = on;
      var c = cb.closest('.ff-card');
      if (c) c.classList.toggle('ff-picked', on);
    });
    if (CPAGE) renderCompare();
  }

  /* The rows, in the order a shopper standing at an opening asks them: does it
     fit, what does it cost, how much does it hold — then the details.
     better marks one winner per row, and only where "better" is not a matter
     of taste: never on finish, door style, hinge side or use. A tie marks
     nothing. A row nobody has a figure for is dropped whole. */
  function cmpRows(list){
    var c = cavity(), rs = list.map(function(f){ return fit(f, c); });
    var yes = '<span class="ff-cyes">Yes</span>', no = '<span class="ff-cno">No</span>';
    var DOOR = { glass:'Glass', heated:'Heated glass', solid:'Solid' };
    var FINISH = { stainless:'Stainless steel', black:'Black', white:'White' };
    function axes(r){
      var a = [];
      if (c.w) a.push('W +' + (c.w - r.needW));
      if (c.d) a.push('D +' + (c.d - r.needD));
      if (c.h) a.push('H +' + (c.h - r.needH));
      return a.join(' \u00b7 ') + 'mm';
    }
    return [
      { lab: c.open ? 'Fit' : 'Fit in your ' + W().opening
          + (CPAGE ? '<button class="ff-cedit" type="button" data-cmeasure-go>Change</button>' : ''),
        fit:true, better:'hi',
        num: function(f, j){
          var r = rs[j];
          if (c.open || f.ventSource === 'airflow' || !r.fits || r.min === null) return null;
          return r.proud ? -r.proud : r.min;
        },
        show: function(f, j){
          var r = rs[j];
          /* On the compare page, a way to the measurement panel above. */
          if (c.open) return CPAGE ? '<button class="ff-cno" type="button" data-cmeasure-go>Add your measurements</button>'
            : '<span class="ff-cno">Add your measurements</span>';
          if (f.ventSource === 'airflow') return '<span class="ff-fit-air">' + FIT.flush + '</span>';
          if (!r.fits) return '<span class="ff-fit-warn">Doesn\u2019t fit</span>';
          if (r.proud) return '<span class="ff-fit-warn">Sits ' + r.proud + 'mm proud</span>';
          var t = tier(r.min);
          return '<span class="ff-fit-' + t[0] + '">\u2713 ' + t[1] + '</span><small>' + axes(r) + '</small>';
        } },
      { lab:'Price', better:'lo', num:function(f){ return f.price || null; },
        show:function(f){
          if (!f.price) return '<span class="ff-cprice">Priced to spec</span>';
          return '<span class="t4s-product-price ff-cprice">'
            + (f.was ? '<del>' + money(f.was) + '</del><ins>' + money(f.price) + '<!--up--></ins>'
              : '<span class="ff-cnow">' + money(f.price) + '<!--up--></span>')
            + '</span>';
        } },
      { lab:'Capacity', better:'hi', num:function(f){ return f.cap || null; },
        show:function(f){ return f.cap ? f.cap + ' L' : ''; } },
      { lab:'Holds', better:'hi', num:function(f){ return f.cans || null; },
        show:function(f){
          if (f.cans && f.wine) return f.cans + ' cans<small>or ' + f.wine + ' wine bottles</small>';
          return f.cans ? f.cans + ' cans' : f.wine ? f.wine + ' wine bottles' : '';
        } },
      { lab:'Size (W\u00d7D\u00d7H)',
        show:function(f){ return f.w + '\u00d7' + f.d + '\u00d7' + f.h + 'mm'; } },
      MODE === 'space'
        ? { lab:'Ventilation',
            show:function(f){ return f.ventSource === 'airflow' ? '' : 'Top ' + f.vt + ', side ' + f.vs + ', rear ' + f.vr + 'mm'; } }
        : { lab:'Opening needed',
            show:function(f, j){
              if (f.ventSource === 'airflow') return '';
              var r = rs[j];
              return r.needW + '\u00d7' + r.needD + '\u00d7' + r.needH + 'mm<small>ventilation included</small>';
            } },
      { lab:'Energy rating', better:'hi', num:function(f){ return f.energy || null; },
        show:function(f){ return f.energy ? f.energy + (Number(f.energy) === 1 ? ' star' : ' stars') : ''; } },
      { lab:'Noise', better:'lo', num:function(f){ return f.noise || null; },
        show:function(f){ return f.noise ? f.noise + ' dB' : ''; } },
      { lab:'Rated to', better:'hi', num:function(f){ return f.maxTemp || null; },
        show:function(f){ return f.maxTemp ? f.maxTemp + '\u00b0C room temp' : ''; } },
      { lab:'Doors', show:function(f){ return f.doors ? f.doors + (f.doors > 1 ? ' doors' : ' door') : ''; } },
      { lab:'Door type', show:function(f){ return DOOR[f.door] || ''; } },
      { lab:'Finish', show:function(f){ return FINISH[f.colour] || ''; } },
      { lab:'Hinge', show:function(f){
          return f.reversible ? 'Reversible' : f.hinge === 'left' ? 'Left' : f.hinge === 'right' ? 'Right' : '';
        } },
      { lab:'Use', show:function(f){ return htmlEsc(f.suitability || ''); } },
      { lab:'Dual zone', show:function(f){ return f.dualZone ? yes : no; } },
      { lab:'Lockable', show:function(f){ return f.lockable ? yes : no; } },
      /* Not ranked. A 5.0 from one review would take the marker off a 4.9 from
         sixteen, which is the wrong way round; the counts sit under the
         scores so the shopper can weigh them, and that is the honest answer. */
      { lab:'Reviews',
        show:function(f){
          return f.rating ? '\u2605 ' + Number(f.rating).toFixed(1)
            + '<small>' + f.reviews + (f.reviews === 1 ? ' review' : ' reviews') + '</small>' : '';
        } },
      { lab:'Stock', show:function(f){
          if (f.stock === 'in') return '<span class="ff-cyes">In stock</span>';
          if (f.stock === 'out') return 'Out of stock';
          return 'Pre-order' + (f.eta ? '<small>' + htmlEsc(f.eta) + '</small>' : '');
        } },
      { lab:'Brand', show:function(f){ return htmlEsc(f.brand || ''); } },
      { lab:'Model', show:function(f){ return htmlEsc(f.model || ''); } },
    ];
  }

  /* ── The full specifications ───────────────────────────────────────────
   *
   * Under the finder's rows, the product page's own spec table, section by
   * section, in the product page's order and words. Read from the product
   * page's own snippet rather than restated here: templates/
   * product.compare-specs.liquid renders snippets/bfau_pr_details.liquid with
   * no layout, so /products/<handle>?view=compare-specs is that table and
   * nothing else, and a row added to the product page turns up here with no
   * change to this file.
   *
   * Parsed by the browser, not by pattern: that snippet's RUNNING COST header
   * cell is never closed, and the HTML parser repairs it the way the product
   * page's own rendering does.
   *
   * Sections the page does not compare - the overview (the description), the
   * downloads, the video - are not read. Rows the finder's own rows above
   * already give, as a number it can rank, are skipped rather than shown
   * twice (SPEC_SKIP). The TASTY INFO 1-10 rows are one merchant's list of
   * selling points split across numbered rows, and "Tasty info 3" beside
   * "Tasty info 3" compares nothing, so they are gathered into one list. */
  var SPEC_SECTIONS = [
    ['main-features', 'Main features'],
    ['technical', 'Technical'],
    ['capacity', 'Capacity'],
    ['dimensions', 'Dimensions'],
    ['ventilation', 'Ventilation Requirements'],
    ['peace-of-mind', 'Peace of mind']
  ];
  var SPEC_SKIP = { modelskucode:1, lockable:1, energystarrating:1, noiselevel:1,
    exteriorwxdxh:1, litres:1, standard375mlcans:1, standardwinebottles:1 };
  var SPECS = {}, SPECS_WAIT = {};
  /* Not specKey(): derive.js's inlined rules already have one. */
  function specSlug(t){ return String(t).toLowerCase().replace(/[^a-z0-9]/g, ''); }

  /* The product page's value cell, kept as markup (it is rich text: paragraphs,
     lists, the "Learn more" PDF links) with anything that could act or restyle
     stripped. Links open in a new tab so the comparison stays put. */
  function specValue(td){
    var c = td.cloneNode(true);
    Array.prototype.forEach.call(c.querySelectorAll('script,style,iframe,noscript,form,button,input,select,textarea,svg,img'),
      function(x){ x.parentNode.removeChild(x); });
    Array.prototype.forEach.call(c.querySelectorAll('*'), function(x){
      for (var i = x.attributes.length - 1; i >= 0; i--){
        var n = x.attributes[i].name;
        if (!(x.tagName === 'A' && n === 'href')) x.removeAttribute(n);
      }
      if (x.tagName === 'A'){
        if (!/^(https?:|\/)/i.test(x.getAttribute('href') || '')) x.removeAttribute('href');
        x.setAttribute('target', '_blank');
        x.setAttribute('rel', 'noopener');
      }
    });
    return c.innerHTML.replace(/\s+/g, ' ').trim();
  }

  function parseSpecs(html){
    var doc = new DOMParser().parseFromString(html, 'text/html'), out = {};
    SPEC_SECTIONS.forEach(function(s){
      var pane = doc.getElementById('v-pills-' + s[0]);
      if (!pane) return;
      var rows = [], tasty = [];
      Array.prototype.forEach.call(pane.querySelectorAll('tr'), function(tr){
        var th = null, td = null;
        for (var i = 0; i < tr.children.length; i++){
          var ch = tr.children[i];
          if (ch.tagName === 'TH' && !th) th = ch;
          else if (ch.tagName === 'TD' && !td) td = ch;
        }
        /* The capacity row nests its own table; its inner rows are read
           in their own right, so the outer one is passed over. */
        if (!th || !td || td.querySelector('table')) return;
        var lab = th.textContent.replace(/\s+/g, ' ').trim().replace(/\s*:$/, ''),
            key = specSlug(lab), val = specValue(td);
        if (!key || !td.textContent.trim() || SPEC_SKIP[key]) return;
        if (/^tastyinfo/.test(key)){ tasty.push(val); return; }
        rows.push({ key:key, lab:lab, html:val });
      });
      if (tasty.length) rows.unshift({ key:'highlights', lab:'Highlights',
        html:'<ul>' + tasty.map(function(t){ return '<li>' + t + '</li>'; }).join('') + '</ul>' });
      out[s[0]] = rows;
    });
    return out;
  }

  function loadSpecs(h){
    if (SPECS[h] || SPECS_WAIT[h]) return;
    if (!window.fetch || !window.DOMParser){ SPECS[h] = {}; return; }
    SPECS_WAIT[h] = true;
    fetch(PBASE + encodeURIComponent(h) + '?view=compare-specs', { credentials:'same-origin' })
      .then(function(r){ if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(function(html){ SPECS[h] = parseSpecs(html); })
      .catch(function(e){
        SPECS[h] = {};
        if (window.console && console.warn) console.warn('[frothy] specs for ' + h + ' failed:', (e && e.message) || e);
      })
      .then(function(){ delete SPECS_WAIT[h]; if (CPAGE) renderCompare(); });
  }

  /* One row per label across the fridges being compared, in the order the
     labels first appear, so a row only one of them has still lines up. */
  function specGroups(list){
    var groups = [];
    SPEC_SECTIONS.forEach(function(s){
      var order = [], labs = {};
      list.forEach(function(f){
        var rs = (SPECS[f.handle] || {})[s[0]] || [];
        rs.forEach(function(r){ if (!labs[r.key]){ labs[r.key] = r.lab; order.push(r.key); } });
      });
      if (!order.length) return;
      groups.push({ id:s[0], title:s[1], rows:order.map(function(k){
        return { lab:htmlEsc(labs[k]).replace(/\(([^)]*)\)/g, '<span class="ff-cnc">($1)</span>'),
          show:function(f){
            var rs = (SPECS[f.handle] || {})[s[0]] || [];
            for (var i = 0; i < rs.length; i++) if (rs[i].key === k) return rs[i].html;
            return '';
          } };
      }) });
    });
    return groups;
  }

  /* ── The page ─────────────────────────────────────────────────────────── */

  /* One row of the table. better marks one winner, and only where every
     fridge has a figure: a tie marks nothing, and neither does a row with a
     gap in it, because "best of the ones we know" reads as "best". */
  function rowHtml(r, list, sec){
    var vals = list.map(function(f, j){ var v = r.show(f, j); return v ? String(v) : ''; });
    if (vals.every(function(v){ return !v; })) return '';
    var same = vals.every(function(v){ return v === vals[0]; });
    var best = -1;
    if (r.better && !same){
      var nums = list.map(function(f, j){ return r.num(f, j); });
      if (nums.every(function(x){ return typeof x === 'number' && !isNaN(x); })){
        var top = r.better === 'hi' ? Math.max.apply(null, nums) : Math.min.apply(null, nums);
        if (nums.filter(function(x){ return x === top; }).length === 1) best = nums.indexOf(top);
      }
    }
    return '<div class="ff-ccols ff-crow' + (same ? ' is-same' : '') + (r.fit ? ' is-fit' : '')
      + '" data-same="' + same + '" data-sec="' + sec + '">'
      + '<div class="ff-clab">' + r.lab + '</div>'
      + vals.map(function(v, j){
          if (!v) v = '\u2014';
          /* Inline, ahead of any second line, so the marker sits on the value
             it ranks rather than dropping under the small print. */
          if (j === best){
            /* A row can name its own spot with <!--up--> - the price does, so the
               marker sits on the sale price rather than wrapping under it. */
            var up = '<i class="ff-cup" aria-label="better">\u25b2</i>', at = v.indexOf('<small>');
            if (v.indexOf('<!--up-->') !== -1) v = v.replace('<!--up-->', up);
            else v = at === -1 ? v + up : v.slice(0, at) + up + v.slice(at);
          }
          return '<div class="ff-cval' + (j === best ? ' is-best' : '') + '">' + v + '</div>';
        }).join('')
      + '</div>';
  }

  /* "Only show differences": rows where every fridge says the same go, and
     so does a section heading left with nothing under it. The fit row stays
     whatever it says - it is the question the page exists to answer. */
  function applyDiff(){
    var box = $('#ff-cdiff'), only = !!(box && box.checked), rows = $('[data-crows]');
    if (!rows) return;
    var shown = {};
    Array.prototype.forEach.call(rows.querySelectorAll('.ff-crow'), function(r){
      r.hidden = only && r.getAttribute('data-same') === 'true' && !r.classList.contains('is-fit');
      if (!r.hidden) shown[r.getAttribute('data-sec')] = true;
    });
    Array.prototype.forEach.call(rows.querySelectorAll('[data-csec]'), function(h){
      h.hidden = !shown[h.getAttribute('data-csec')];
    });
  }

  /* The address bar carries the picks, so the page can be reloaded and sent:
     "which of these two?" opens straight to the pair. Anything else on the
     URL - a utm tag, a preview flag - is carried through byte for byte,
     EXCEPT the search keys a shared link brings (w, d, h...): those are read
     once on arrival and saved (bootComparePage()), and left in the address
     bar they would go stale the moment the pop-up changed them. */
  function cmpUrl(){
    try {
      var keep = location.search.replace(/^[?]/, '').split('&').filter(function(p){
        var k = decodeURIComponent(p.split('=')[0]);
        return p && k !== 'cmp' && SEARCH_KEYS.indexOf(k) === -1;
      });
      if (CMP.length) keep.push('cmp=' + cmpParam());
      var url = location.pathname + (keep.length ? '?' + keep.join('&') : '') + location.hash;
      if (url !== location.pathname + location.search + location.hash) history.replaceState(history.state, '', url);
    } catch (e) {}
  }

  function renderCompare(){
    var list = CMP.map(recByHandle).filter(comparable), n = list.length;
    var table = $('[data-ctable]'), empty = $('[data-cempty]'), mini = $('[data-cmini]');
    cmpUrl();
    /* Releases the space held while the data loaded - see .ff-cpage:not(.is-drawn). */
    $('[data-cpage-body]').classList.add('is-drawn');
    if (n < 2){
      table.hidden = true;
      empty.hidden = false;
      mini.classList.remove('is-on');
      return;
    }
    empty.hidden = true;
    table.hidden = false;
    $('[data-cpage-body]').style.setProperty('--ff-cn', n);
    list.forEach(function(f){ loadSpecs(f.handle); });

    $('[data-cheads]').innerHTML = '<div class="ff-ccorner"></div>' + list.map(function(f){
      var href = PBASE + f.handle;
      return '<div class="ff-chd">'
        + '<button class="ff-chd-x" type="button" data-cunpick="' + htmlEsc(f.handle) + '" aria-label="Remove '
        + htmlEsc(cmpName(f)) + ' from compare">&times;</button>'
        + '<a class="ff-chd-img" href="' + href + '" tabindex="-1" aria-hidden="true">'
        + (f.img ? '<img src="' + f.img + '" alt="">' : '') + '</a>'
        + '<a class="ff-chd-t" href="' + href + '">' + htmlEsc(f.model || shortTitle(f)) + '</a>'
        + (f.model ? '<span class="ff-chd-m">' + htmlEsc(shortTitle(f)) + '</span>' : '') + '</div>';
    }).join('');
    mini.innerHTML = '<div class="ff-ccorner"></div>' + list.map(function(f){
      return '<div class="ff-cmini-c"><span>' + htmlEsc(f.model || shortTitle(f)) + '</span></div>';
    }).join('');

    var html = '<div class="ff-csec" data-csec="glance">At a glance</div>'
      + cmpRows(list).map(function(r){ return rowHtml(r, list, 'glance'); }).join('');
    specGroups(list).forEach(function(g){
      html += '<div class="ff-csec" data-csec="' + g.id + '">' + htmlEsc(g.title) + '</div>'
        + g.rows.map(function(r){ return rowHtml(r, list, g.id); }).join('');
    });
    if (list.some(function(f){ return SPECS_WAIT[f.handle]; })){
      html += '<div class="ff-cload">Loading the full specifications\u2026</div>';
    }
    $('[data-crows]').innerHTML = html;
    applyDiff();

    $('[data-cfoot]').innerHTML = '<div class="ff-ccorner"></div>' + list.map(function(f){
      return '<a class="ff-cview" href="' + PBASE + f.handle + '">View</a>';
    }).join('');
    placeMini();
  }

  /* The slim bar of names that stands in for the heads once they have
     scrolled away. Fixed, under the theme's sticky header: its bottom edge is
     measured on every scroll rather than assumed, because the header is
     taller at the top of the page than stuck, and not there at all on a
     theme with sticky switched off. Left and width follow the table. */
  function placeMini(){
    var t = $('[data-ctable]'), heads = $('[data-cheads]'), mini = $('[data-cmini]');
    if (!t || !mini) return;
    if (t.hidden){ mini.classList.remove('is-on'); return; }
    var hd = document.querySelector('.t4s-section-header'), top = 0;
    if (hd){
      var b = hd.getBoundingClientRect().bottom;
      if (b > 0) top = Math.round(b);
    }
    var r = t.getBoundingClientRect();
    root.style.setProperty('--ff-mtop', top + 'px');
    root.style.setProperty('--ff-ml', Math.round(r.left) + 'px');
    root.style.setProperty('--ff-mw', Math.round(r.width) + 'px');
    mini.classList.toggle('is-on', heads.getBoundingClientRect().bottom < top + 8 && r.bottom > top + 120);
  }

  function wireCompare(){
    /* Another page, another tab or the tray's own × changed the list. */
    document.addEventListener('bfau:cmp', syncCompare);

    if (!CPAGE){
      grid.addEventListener('change', function(e){
        var cb = e.target.closest ? e.target.closest('[data-cmp]') : null;
        if (cb) setCompare(cb.getAttribute('data-cmp'), cb.checked);
      });
      return;
    }

    root.addEventListener('click', function(e){
      var b = e.target.closest ? e.target.closest('[data-cunpick]') : null;
      if (b) setCompare(b.getAttribute('data-cunpick'), false);
      if (e.target.closest && e.target.closest('[data-cmeasure-go]')) openMeasure();
    });
    $('#ff-cdiff').addEventListener('change', applyDiff);

    var shareCmp = $('[data-share="compare"]');
    if (shareCmp) shareCmp.addEventListener('click', function(){
      var names = CMP.map(recByHandle).filter(comparable).map(cmpName);
      share(shareCmp, compareShareUrl(), 'Comparing ' + names.join(' vs ') + ' — Bar Fridges Australia');
    });

    /* The measurement panel. The fields are the finder's own, so cavity()
       reads them and updateEchoes() confirms "60cm" as 600mm exactly as it
       does there. A keystroke redraws on the finder's own pause (RENDER_MS)
       rather than per key, and each change goes into the saved search the
       finder restores from. */
    var MEASURE_T = 0;
    function measured(){ renderCompare(); saveSearch(); }
    DIM_IDS.forEach(function(id){
      var el = $('#' + id);
      if (!el) return;
      el.addEventListener('input', function(){
        updateEchoes();
        clearTimeout(MEASURE_T);
        MEASURE_T = setTimeout(function(){ MEASURE_T = 0; measured(); }, RENDER_MS);
      });
    });
    $$('.ff-cmodal [data-mode]').forEach(function(btn){
      btn.addEventListener('click', function(){ if (setMode(btn.getAttribute('data-mode'))) measured(); });
    });
    /* ✕, "Check the fit", a click on the backdrop (the dialog element itself,
       outside its box), and Enter in a field all close it; Escape is the
       dialog's own. Closing lands any keystroke still inside the pause. */
    var dlg = $('[data-cmeasure]');
    if (dlg){
      dlg.addEventListener('click', function(e){
        if (e.target === dlg || (e.target.closest && e.target.closest('[data-cmeasure-close]'))) closeMeasure();
      });
      dlg.addEventListener('keydown', function(e){
        if (e.key === 'Enter' && e.target && e.target.tagName === 'INPUT'){ e.preventDefault(); closeMeasure(); }
      });
      dlg.addEventListener('close', function(){
        if (MEASURE_T){ clearTimeout(MEASURE_T); MEASURE_T = 0; measured(); }
      });
    }

    /* Same click-through rule as the grid's: leaving for a product page is
       what writes the fit record the product page stamps onto the order, and
       the page's product links are a way of leaving. saveFit() writes nothing
       when no measurement was restored. */
    $('[data-cpage-body]').addEventListener('click', function(e){
      var a = e.target.closest && e.target.closest('a[href]');
      if (a && (a.getAttribute('href') || '').indexOf(PBASE) === 0) saveFit();
    }, true);

    var MINI_Q = false;
    function miniSoon(){
      if (MINI_Q) return;
      MINI_Q = true;
      (window.requestAnimationFrame || setTimeout)(function(){ MINI_Q = false; placeMini(); });
    }
    window.addEventListener('scroll', miniSoon, { passive:true });
    window.addEventListener('resize', miniSoon);
  }

  /* "Add your measurements" (or "Change") in the fit row opens the pop-up,
     cursor in Width. The fit row behind it redraws as they type. */
  function openMeasure(){
    var d = $('[data-cmeasure]'), w = $('#ff-cw');
    if (!d || d.open) return;
    if (d.showModal) try { d.showModal(); } catch (e) { d.setAttribute('open', ''); }
    else d.setAttribute('open', '');
    if (w) setTimeout(function(){ try { w.focus({ preventScroll:true }); } catch (e) { w.focus(); } }, 30);
  }
  function closeMeasure(){
    var d = $('[data-cmeasure]');
    if (!d || !d.open) return;
    if (d.close) d.close(); else d.removeAttribute('open');
  }

  /* The compare page. The finder's markup is on it, hidden, and restoreSearch()
     fills its fields from the saved search exactly as it would on the finder -
     which is how the Fit row knows the opening. A link's cmp= wins over the
     stored list, and is cut to this screen's limit by setAll(). */
  function bootComparePage(){
    var a = cmpApi(), q = null;
    try { q = new URLSearchParams(location.search).get('cmp'); } catch (e) {}
    if (q !== null){
      var hs = q.split(',').map(function(h){ return h.trim(); }).filter(Boolean).map(cmpHandle);
      if (a) a.setAll(hs);
      else CMP = hs.slice(-cmpMax());
    }
    /* A shared compare link carries the sender's opening, and restoreSearch()
       has already filled the fields from it - the address bar wins, as on the
       finder. Saved now, as the finder saves a link's search, so it outlives
       cmpUrl() taking it off the address bar. */
    var linked = false;
    try { linked = hasSearchParams(new URLSearchParams(location.search)); } catch (e) {}
    if (linked) saveSearch();
    /* The finder's measurement block, moved into the pop-up: one set of
       fields, so nothing has to be kept in step with a copy. */
    var slot = $('[data-cmeasure-slot]'), cav = $('.ff-cav-main');
    if (slot && cav) slot.appendChild(cav);
    updateEchoes();
    wireCompare();
    syncCompare();
    refreshAll();
  }

  function boot(){
    ALL_ACCESSORIES = FRIDGES.filter(function(f){ return f.accessory; });
    FRIDGES = FRIDGES.filter(function(f){ return !f.accessory; });
    pairKits();
    /* Still before wire() and render(), for the reason prefillFromUrl() has
       always had to be: readMm() memoises openRange() into OPEN on first use. */
    restoreSearch();
    cmpAdopt();
    if (CPAGE){ bootComparePage(); return; }
    wire(); render();
    /* Whether View fits beside the filters is decided by label widths, and
       label widths move when the webfont lands — so once now against the
       fallback face and again when the real one arrives. Resize is debounced;
       nothing else can change the answer, since the count badges went out of
       flow and no longer alter any button's width. */
    fitView();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitView);
    window.addEventListener('resize', fitViewSoon);
    /* After the first paint, never before it. The grid is usable on baked data;
       waiting on a network call to show anything would trade a stale figure for
       a guaranteed blank screen. */
    refreshAll();
  }

  if (FRIDGES){ boot(); return; }

  /* Theme build: the fridge data is a separate cacheable asset, so the page
     paints its shell first and fills in when the data lands. */
  var src = root.getAttribute('data-src');
  fetch(src, { credentials:'omit' })
    .then(function(r){ if (!r.ok) throw new Error('HTTP '+r.status); return r.json(); })
    .then(function(d){ FRIDGES = d; return true; })
    /* Only a failed READ says "could not load", and it says why in the console.
       boot() used to sit inside this chain, so ANY exception it threw — a typo in
       the engine, a bad selector — was caught here and reported to the shopper as
       a download failure. That is a lie in the one direction that costs the most
       time: the grid says the data did not arrive while the counts above it are
       plainly rendered from data that did. Cost half an hour once; the fix is to
       let boot() throw where a throw belongs, in the console with a stack. */
    .catch(function(e){
      grid.innerHTML = '<div class="ff-empty"><strong>The finder could not load</strong>'
        + 'Give us a call on 1300 376 849 and we will size it up for you.</div>';
      if (window.console && console.warn) {
        console.warn('[frothy] data asset failed:', (e && e.message) || e);
      }
      return false;
    })
    .then(function(ok){ if (ok) boot(); });
})();
